webpackJsonp([2],{

/***/ "+QYB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+dD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-col',{staticClass:"header",attrs:{"span":24}},[_c('el-col',{staticClass:"logo",attrs:{"span":4}},[_c('span',[_c('i',{staticClass:"txt"},[_vm._v("宠品仓-管理员后台系统")])])]),_vm._v(" "),_c('el-col',{staticClass:"userinfo",attrs:{"offset":18,"span":2}},[_c('el-dropdown',{on:{"command":_vm.manyCommand}},[_c('span',{staticClass:"el-dropdown-link"},[_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"loginout"}},[_vm._v("退出登录")])],1)],1)],1)],1),_vm._v(" "),_c('el-col',{staticClass:"main",attrs:{"span":24}},[_c('section',{class:_vm.menuClass},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.$route.path,"collapse":_vm.isCollapse,"theme":"dark","router":"","unique-opened":""}},[_c('li',{staticClass:"el-menu-item fold",on:{"click":_vm.toggleSidebar}},[_c('i',{class:_vm.menuIcon})]),_vm._v(" "),_vm._l((_vm.$router.options.routes),function(item,index){return (!item.hidden)?[(!item.leaf)?_c('el-submenu',{attrs:{"index":index+''}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{class:item.iconCls}),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_vm._l((item.children),function(child,index){return (!child.hidden)?_c('el-menu-item',{attrs:{"index":child.path}},[_vm._v(_vm._s(child.name))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(item.leaf&&item.children.length>0)?_c('el-menu-item',{attrs:{"index":item.children[0].path}},[_c('i',{class:item.iconCls}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.children[0].name))])]):_vm._e()]:_vm._e()})],2)],1),_vm._v(" "),_c('div',{class:_vm.containerClass},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/NDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":15}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"专题ID","prop":"id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"专题标题","prop":"title","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"状态","prop":"status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm.shanchustatus[scope.row.status])+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增","size":"small"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"专题名称","prop":"title"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.title),callback:function ($$v) {_vm.addForm.title=$$v},expression:"addForm.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"专题图片","prop":"pic"}},[_c('el-upload',{attrs:{"multiple":"","action":"https://up.qbox.me","on-success":_vm.handleUploadSuccess,"on-error":_vm.handleUploadError,"before-upload":_vm.handleBeforeUpload,"data":_vm.uploadForm,"file-list":_vm.fileListPro,"list-type":"picture","show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击多选上传")])],1),_vm._v(" "),(_vm.fileListPro.length > 0)?_c('div',{staticClass:"image-sort-container"},_vm._l((_vm.fileListPro),function(file,index){return _c('div',{key:index,staticClass:"image-sort-item"},[_c('img',{staticClass:"sort-img",attrs:{"src":file.url}}),_vm._v(" "),_c('div',{staticClass:"sort-btns"},[_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-left","disabled":index === 0},on:{"click":function($event){_vm.moveImage(index, 'up')}}},[_vm._v("前移")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-right","disabled":index === _vm.fileListPro.length - 1},on:{"click":function($event){_vm.moveImage(index, 'down')}}},[_vm._v("后移")]),_vm._v(" "),_c('el-button',{staticStyle:{"color":"#ff4949"},attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.deleteImage(index)}}},[_vm._v("删除")])],1)])})):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"专题状态","prop":"status"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"0","off-value":"1"},model:{value:(_vm.addForm.status),callback:function ($$v) {_vm.addForm.status=$$v},expression:"addForm.status"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑","size":"small"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"专题名称","prop":"title"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.title),callback:function ($$v) {_vm.editForm.title=$$v},expression:"editForm.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"专题图片","prop":"pic"}},[_c('el-upload',{attrs:{"multiple":"","action":"https://up.qbox.me","on-success":_vm.handleUploadSuccess,"on-error":_vm.handleUploadError,"before-upload":_vm.handleBeforeUpload,"data":_vm.uploadForm,"file-list":_vm.fileListPro,"list-type":"picture","show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击多选上传")])],1),_vm._v(" "),(_vm.fileListPro.length > 0)?_c('div',{staticClass:"image-sort-container"},_vm._l((_vm.fileListPro),function(file,index){return _c('div',{key:index,staticClass:"image-sort-item"},[_c('img',{staticClass:"sort-img",attrs:{"src":file.url}}),_vm._v(" "),_c('div',{staticClass:"sort-btns"},[_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-left","disabled":index === 0},on:{"click":function($event){_vm.moveImage(index, 'up')}}},[_vm._v("前移")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-right","disabled":index === _vm.fileListPro.length - 1},on:{"click":function($event){_vm.moveImage(index, 'down')}}},[_vm._v("后移")]),_vm._v(" "),_c('el-button',{staticStyle:{"color":"#ff4949"},attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.deleteImage(index)}}},[_vm._v("删除")])],1)])})):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"专题状态","prop":"status"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"0","off-value":"1"},model:{value:(_vm.editForm.status),callback:function ($$v) {_vm.editForm.status=$$v},expression:"editForm.status"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/QBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"row-key":_vm.getRowKeys,"expand-row-keys":_vm.expands},on:{"expand":_vm.expand}},[_c('el-table-column',{attrs:{"label":"标题","prop":"title","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品ID","prop":"proid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺ID","prop":"dianpuid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"模式","prop":"mode","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.spiderMode[scope.row.mode]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"createtime","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"爬虫状态","prop":"status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.spiderStatus[scope.row.status]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"event_unique_key","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.setSpider(scope.row._id, 1)}}},[_vm._v("失效")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){_vm.setSpider(scope.row._id, 2)}}},[_vm._v("删除")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.setSpider(scope.row._id, 0)}}},[_vm._v("恢复")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/XPq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/hNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/x53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_huiyuan_vue__ = __webpack_require__("0mug");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5970abf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_huiyuan_vue__ = __webpack_require__("lMZt");
function injectStyle (ssrContext) {
  __webpack_require__("Ob1u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5970abf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_huiyuan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5970abf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_huiyuan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0efo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0iuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    picUrl: 'https://cpcimg.tianranliang.com/',
    recommendStatus: {
        0: '正常',
        1: '全网',
        2: '新品',
        3: '热门',
        4: '推荐',
        5: '次顶',
        6: '置顶'
    },
    isDefault: {
        0: '非默认',
        1: '默认'
    },
    proStatus: {
        0: '未上架',
        1: '已上架'
    },
    overseaArr: {
        0: '全球购',
        1: '国内'
    },
    userStatus: {
        0: '正常',
        1: '冻结'
    },
    userLevel: {
        0: '金牌销售员',
        1: '品牌合伙人',
        2: '城市合伙人'
    },
    userChannel: {
        0: '微商',
        1: '淘宝',
        2: '实体',
        3: '其他'
    },
    isoverseaStatus: {
        0: '保税直邮',
        1: '国内现货'
    },
    iswhiteProStatus: {
        1: '白名单'
    },
    deliverStatus: {
        '-1': '未发货',
        0: '非拆单',
        1: '拆单发货'
    },
    orderStatus: {
        '-1': '已完成',
        0: '已取消',
        1: '待支付',
        2: '待发货',
        201: '拆单件',
        3: '收货中',
        4: '已收货',
        5: '已删除',
        6: '售后中',
        601: '已处理'
    },
    wuliuStatus: {
        'canvassing': 1,
        'checkin_scan': 2,
        'checkout_scan': 2,
        'checkout': 2,
        'deliver_to_forwarder': 2,
        'international_transport': 2,
        'cross_border_transport': 2,
        'customs_clearance': 2,
        'customs_release': 3,
        'express_delivery': 4,
        '50': 4,
        '3036': 4,
        '44': 4,
        '8000': 5,
        '9000': 6
    },
    wuliuCompany: {
        // 0: 'UEQ',
        0: "极兔快递",
        1: '中通快递',
        2: "圆通快递",
        3: '申通快递',
        4: "中国邮政",
        5: '韵达快递',
        6: "德邦快递",
        7: "京东快递",
        8: "顺丰快递",
        9: "菜鸟快递",
        10: "壹米滴答",
        11: "韵达快运",
        12: "中通快运",
        13: "百世快运",
        14: "安能物流",
        15: "顺心捷达"
    },
    tixianStatus: {
        0: '提现中',
        1: '提现成功'
    },
    jiesuanStatus: {
        0: '未结算',
        1: '已结算'
    },
    baoyouStatus: {
        0: '不包邮',
        1: '包邮'
    },
    spiderStatus: {
        0: '正常',
        1: '失效',
        2: '删除'
    },
    spiderMode: {
        1: '多规格',
        2: '单规格'
    },

    anjianStatus: {
        0: '非按件计算',
        1: '按件计算'
    },
    tongyongStatus: {
        0: '非通用',
        1: '通用'
    },
    shengFen: {
        0: '其他',
        1: '北京',
        2: '天津',
        3: '河北省',
        4: '山西省',
        5: '内蒙古',
        6: '辽宁省',
        7: '吉林省',
        8: '黑龙江省',
        9: '上海',
        10: '江苏省',
        11: '浙江省',
        12: '安徽省',
        13: '福建省',
        14: '江西省',
        15: '山东省',
        16: '河南省',
        17: '湖北省',
        18: '湖南省',
        19: '广东省',
        20: '广西',
        21: '海南省',
        22: '重庆',
        23: '四川省',
        24: '贵州省',
        25: '云南省',
        26: '西藏',
        27: '陕西省',
        28: '甘肃省',
        29: '青海省',
        30: '宁夏',
        31: '新疆',
        32: '台湾省',
        33: '香港',
        34: '澳门',
        35: '华东仓',
        36: '华南仓',
        37: '华北仓',
        38: '西南仓',
        39: '东北仓',
        40: '西北仓',
        41: '保税仓'
    },
    indexStatus: {
        1: '热卖',
        2: '狗狗膳食',
        3: '猫咪膳食',
        4: '宠物零食',
        5: '营养保健',
        6: '医疗护理',
        7: '猫狗玩具',
        8: '出行装备',
        9: '猫砂厕所',
        10: '家居日用',
        11: '美容服饰',
        12: '保税直邮',
        13: '云仓现货',
        14: '京东直供',
        15: '跨界优选',
        16: '罐头餐盒',
        17: '共创品牌'
    },
    verifyStatus: {
        0: '未审核',
        1: '已审核'
    },
    iswhiteStatus: {
        0: '普通客户',
        1: '白名单客户'
    },
    recommend: {
        0: '未推荐',
        1: '已推荐'
    },
    verify: {
        0: '通过审核',
        1: '新增待审核',
        2: '修改待审核'
    },
    status: {
        0: '正常',
        1: '删除'
    },
    supportStatus: {
        0: '不支持',
        1: '支持'
    },
    huiyuanLevel: {
        0: '金牌销售员',
        1: '品牌合伙人',
        2: '城市合伙人'
    },
    huiyuanChannel: {
        0: '微商',
        1: '淘宝',
        2: '实体',
        3: '其他'
    },
    sexStatus: {
        0: '未知',
        1: '男',
        2: '女'
    },
    adminLevel: {
        0: '供应商',
        1: '系统管理员'
    },
    isHot: {
        0: '非热门',
        1: '热门'
    }
});

/***/ }),

/***/ "0mug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      supportStatus: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].supportStatus,
      verifyStatus: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].verifyStatus,
      huiyuanLevel: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].huiyuanLevel,
      huiyuanChannel: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].huiyuanChannel,
      sexStatus: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].sexStatus,
      selectUserLevel: "200",
      userinfoForm: {},
      verifyFormVisible: false,
      viewFormVisible: false,
      address: '',
      beginTime: '',
      endTime: '',
      sex: '',
      channel: '',
      level: ''
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      query = this.beginTime + "|" + this.endTime + "|" + this.selectUserLevel + "|" + query;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/userinfo/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    // 导出Excel
    export2Excel: function export2Excel() {
      var _this2 = this;

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      // if(!this.beginTime || !this.endTime) {
      //   this.$message({
      //     message: '时间不能为空！',
      //     type: 'warning'
      //   });
      //   return;
      // }
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/userinfo/excel/' + this.beginTime + '/' + this.endTime + "/" + this.selectUserLevel).then(function (response) {
        if (response.data.state) {
          if (response.data.msg) {
            console.log(response.data.msg);
            __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
              var _require = __webpack_require__("zKXg"),
                  export_json_to_excel = _require.export_json_to_excel;

              var tHeader = ['用户编号', '微信名称', '联系方式', '来源', '  店铺名称', '最近登陆', '创建时间', '备注']; //对应表格输出的title
              var filterVal = ['usid', 'name', 'tel', 'channel', 'dianpu_name', 'lately_at', 'create_time', 'remark']; // 对应表格输出的数据
              var list = response.data.msg;
              var data = _this2.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '用户列表_' + _this2.beginTime + '_' + _this2.endTime); //对应下载文件的名字
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          } else {
            _this2.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        } else {
          _this2.$message({
            message: '无数据，请联系管理员！',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$message({
          message: '导出异常，请联系管理员！',
          type: 'error'
        });
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },

    //   审核
    verify: function verify(row) {
      this.userinfoForm = row;
      this.userinfoForm.level = row.level.toString();
      this.userinfoForm.channel = row.channel.toString();
      this.userinfoForm.five_pifa = row.five_pifa.toString();
      this.userinfoForm.one_daifa = row.one_daifa.toString();
      this.userinfoForm.add_cart = row.add_cart.toString();
      this.userinfoForm.user_status = row.user_status.toString();
      this.userinfoForm.is_white = row.is_white.toString();
      this.verifyFormVisible = true;
    },
    showOrder: function showOrder(usid, orderNum) {
      this.$router.push('/order/list/' + usid + '/' + orderNum);
    },
    verifySubmit: function verifySubmit() {
      var _this3 = this;

      this.$confirm('确认提交吗？', '提示', {}).then(function () {
        _this3.submitLoading = true;
        var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.userinfoForm);
        para.level = parseInt(para.level);
        para.channel = parseInt(para.channel);
        para.five_pifa = parseInt(para.five_pifa);
        para.one_daifa = parseInt(para.one_daifa);
        para.add_cart = parseInt(para.add_cart);
        para.user_status = parseInt(para.user_status);
        para.is_white = parseInt(para.is_white);
        //异步请求
        _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/userinfo', para).then(function (response) {
          if (response.data.state) {
            _this3.$message({
              message: '提交成功',
              type: 'success'
            });
            _this3.verifyFormVisible = false;
            _this3.search();
          } else {
            _this3.$message({
              message: '提交失败，请联系管理员',
              type: 'error'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this3.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        });
        _this3.submitLoading = false;
      });
    },


    //   查看
    view: function view(row) {
      this.userinfoForm = row;
      this.address = row.sheng + '-' + row.shi + '-' + row.xian;
      this.sex = this.sexStatus[row.sex];
      this.channel = this.huiyuanChannel[row.channel];
      this.level = this.huiyuanLevel[row.level];
      this.userinfoForm.five_pifa = row.five_pifa.toString();
      this.userinfoForm.one_daifa = row.one_daifa.toString();
      this.userinfoForm.add_cart = row.add_cart.toString();
      this.userinfoForm.user_status = row.user_status.toString();
      this.userinfoForm.is_white = row.is_white.toString();
      this.viewFormVisible = true;
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "0qLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":20}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.beginTime),callback:function ($$v) {_vm.beginTime=$$v},expression:"beginTime"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}}),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":"店铺名称","size":"small"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.export2Excel}},[_vm._v("导出数据")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(_vm.profitSum))])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"ID","prop":"arrid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分销编号","prop":"usid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺等级","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.userLevel[scope.row.level]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺名称","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"平均价格","prop":"avg_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"订单数量","prop":"num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"销售额","prop":"sum_price","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.sum_price < 1001)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 10000)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 5000)?_c('el-button',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 1000)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"产出额","prop":"sum_profit","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.sum_profit < 101)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 1000)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 500)?_c('el-button',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 100)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"利润率","prop":"profit_margin","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺备注","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showOrder(scope.row.usid, '')}}},[_vm._v("查看订单")])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1gMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-row',{staticClass:"row-bg",staticStyle:{"margin-bottom":"30px"},attrs:{"type":"flex","justify":"space-around"}},[_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("今日订单数")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.orderCount))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("待填单号")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.danhaoCount))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("今日订单金额")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.orderSum))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("今日订单利润|率")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.profitSum)+"|"+_vm._s(_vm.numFilter(_vm.profitSum/_vm.orderSum*100)))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("当月订单数量")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.orderCountMonth))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("当月总金额|共创")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.orderSumMonth)+"|"+_vm._s(_vm.numFilter(_vm.orderSumGongChuangMonth/_vm.orderSumMonth*100)))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("当月订单利润|率")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.profitSumMonth)+"|"+_vm._s(_vm.numFilter(_vm.profitSumMonth/_vm.orderSumMonth*100)))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("当月共创产出|总")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.profitSumGongChuangMonth)+"|"+_vm._s(_vm.orderSumGongChuangMonth))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("新增|总分销")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.userCount)+"|"+_vm._s(_vm.userZongCount))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',[_c('div',[_vm._v("库存低|总商品")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.kucunCount)+"|"+_vm._s(_vm.proCount))])])])])],1),_vm._v(" "),_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":12}},[_c('div',{attrs:{"id":"order"}})]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{attrs:{"id":"orderSum"}})])],1),_vm._v(" "),_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":12}},[_c('div',{attrs:{"id":"gongChuangOrder"}})]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{attrs:{"id":"gongChuangOrderSum"}})])],1),_vm._v(" "),_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":12}},[_c('div',{attrs:{"id":"user"}})]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{attrs:{"id":"profitSum"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "26W3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__ = __webpack_require__("0iuG");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      listLoading: false,
      wuliuVisbile: false,
      orderNum: this.$route.params.orderNum,
      wuliuNum: '',
      tableDataProduct: [],
      expands: [],
      getRowKeys: function getRowKeys(row) {
        return row.id;
      },

      wuliuStatusTabs: [],
      wuliuStatus: 0,
      wuliuInfos: [],
      wuliuAction: '',
      activeNames: '1',
      wuliuCom: '',
      wuliuCompany: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].wuliuCompany,
      // ========= 新增的变量 =========
      lastUsedWuliuCom: '', // 记忆用户最后一次选的快递公司
      batchWuliuVisible: false,
      batchSubmitLoading: false,
      batchWuliuCom: '',
      batchTableData: []
    };
  },

  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/suborder/' + this.orderNum).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.tableData = data.msg;
        } else {
          _this.$message({
            message: data.msg,
            type: 'warning'
          });
        }
        _this.listLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },

    // 【优化】原有的单行修改：加入快递公司记忆功能
    showWuliu: function showWuliu(row) {
      this.wuliuVisbile = true;
      this.wuliuNum = row.wuliu_num;
      this.subOrderNum = row.suborder_num;
      // 如果当前订单有快递，就用当前的；如果没有，就用上一次记住的快递
      this.wuliuCom = row.wuliu_company || this.lastUsedWuliuCom;
    },

    // 添加物流
    editSubmit: function editSubmit() {
      var _this2 = this;

      this.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/suborder/' + this.orderNum + '/' + this.subOrderNum + '/' + this.wuliuNum + '/' + this.wuliuCom).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this2.$message({ message: '提交成功', type: 'success' });
          _this2.lastUsedWuliuCom = _this2.wuliuCom; // 记住本次使用的快递
        } else {
          _this2.$message({ message: data.msg, type: 'warning' });
        }
        _this2.getList();
        _this2.wuliuVisbile = false;
      }).catch(function (error) {
        console.log(error);
        _this2.$message({
          message: '提交异常，请联系管理员',
          type: 'error'
        });
      });
    },

    // 短信提醒
    smsRemind: function smsRemind() {
      var _this3 = this;

      this.$confirm('是否确认发送短信提醒？', '提示', {}).then(function () {
        _this3.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/sms_remind/' + _this3.orderNum).then(function (response) {
          if (response.data.state) {
            _this3.$message({
              message: '发送成功',
              type: 'success'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this3.$message({
            message: '发送异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //查询订单状态，物流状态等。
    expand: function expand(row, expanded) {
      if (expanded) {
        this.wuliuStatusTabs = row.wuliu_num ? row.wuliu_num.split(',') : [];
        this.wuliuAction = this.wuliuStatusTabs[0];
        this.getProduct(row.suborder_ids);
        this.getWuliuStatus(row.wuliu_num, row.order_num);
        this.expands = [];
        this.expands.push(row.id);
      }
    },

    // 获取商品列表
    getProduct: function getProduct(orderIds) {
      var _this4 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/suborder/form/' + orderIds).then(function (response) {
        if (response.data.state) {
          _this4.tableDataProduct = response.data.msg;
        } else {
          _this4.$message({
            message: '获取商品列表失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this4.$message({
          message: '获取商品列表异常，请联系管理员',
          type: 'error'
        });
      });
    },

    // 1. 打开批量编辑弹窗
    showBatchWuliu: function showBatchWuliu() {
      if (!this.tableData || this.tableData.length === 0) {
        return this.$message.warning('当前没有子订单可以操作');
      }

      this.batchWuliuVisible = true;
      // 默认带出上次选的物流公司
      this.batchWuliuCom = this.lastUsedWuliuCom || '';

      // 深拷贝一份数据到批量表格中，避免取消时影响外层表格，并初始化 new_wuliu_num
      this.batchTableData = this.tableData.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
          // 默认把原有的单号填进去，方便修改；如果是空的就是发新货
          new_wuliu_num: item.wuliu_num || ''
        });
      });
    },


    // 2. 批量提交
    batchEditSubmit: function batchEditSubmit() {
      var _this5 = this;

      if (!this.batchWuliuCom) {
        return this.$message.warning('请选择统一物流单位');
      }

      // 筛选出填写了单号的订单
      var validItems = this.batchTableData.filter(function (item) {
        return item.new_wuliu_num && item.new_wuliu_num.trim() !== '';
      });

      if (validItems.length === 0) {
        return this.$message.warning('请至少为一个子订单填写物流单号');
      }

      this.batchSubmitLoading = true;

      // 使用 Promise.all 包装所有请求，不需要后端改接口，前端并发发送
      var requestPromises = validItems.map(function (item) {
        return _this5.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/suborder/' + _this5.orderNum + '/' + item.suborder_num + '/' + item.new_wuliu_num + '/' + _this5.batchWuliuCom);
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(requestPromises).then(function (responses) {
        _this5.batchSubmitLoading = false;

        // 检查是否有失败的请求 (根据你们后端的 data.state 逻辑)
        var hasError = responses.some(function (res) {
          return !res.data.state;
        });
        if (hasError) {
          _this5.$message.warning('部分订单提交失败，请检查列表');
        } else {
          _this5.$message.success('批量发货成功！');
          _this5.batchWuliuVisible = false;
          _this5.lastUsedWuliuCom = _this5.batchWuliuCom; // 记住本次使用的快递
        }
        _this5.getList(); // 刷新列表
      }).catch(function (error) {
        console.log(error);
        _this5.batchSubmitLoading = false;
        _this5.$message.error('网络异常，请刷新后查看状态');
        _this5.getList();
      });
    },

    //查询物流状态
    getWuliuStatus: function getWuliuStatus(wuliuNum, orderNum) {
      var _this6 = this;

      if (wuliuNum) {
        this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/wuliu/' + wuliuNum + '/' + orderNum).then(function (response) {
          var data = response.data;
          if (data.state) {
            var result = data.msg;
            // this.wuliuStatus = basicdata.wuliuStatus[result.wuliustatus];
            _this6.wuliuInfos = [];
            var obj = result.wuliuinfo ? JSON.parse(result.wuliuinfo) : '';
            if (obj && obj.length > 0) {
              _this6.wuliuInfos = obj;
            }
          } else {
            _this6.$message({
              message: '查询物流状态失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this6.$message({
            message: '查询物流状态异常，请联系管理员',
            type: 'error'
          });
        });
      } else {
        this.wuliuInfos = [];
        this.wuliuStatus = 0;
      }
    }
  },
  created: function created() {
    this.getList();
  }
});

/***/ }),

/***/ "2OQH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        category_name: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      showUploadList: false,
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl: ''
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/indexcategory/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/indexcategory', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(row) {
      var _this3 = this;

      var text = '是否删除？';
      var status = 1;
      if (row.status == 1) {
        text = '是否恢复？';
        status = 0;
      }

      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/indexcategory/delete/' + row.category_id + '/' + status).then(function (response) {
          if (response.data.state) {
            _this3.$message({
              message: '操作成功',
              type: 'success'
            });
            _this3.search();
          } else {
            _this3.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this3.$message({
            message: '删除异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.imageUrl = row.pic;
    },
    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.editForm);
            //异步请求
            _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/indexcategory', para).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this4.$refs['editForm'].resetFields();
                _this4.editFormVisible = false;
                _this4.search();
              } else {
                _this4.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this4.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.addFormVisible = true;
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dev_config__ = __webpack_require__("NFaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prod_config__ = __webpack_require__("cXLC");
/**
 * Created by Administrator on 2017/6/19.
 */




var config = void 0;
if (true) {
  config = __WEBPACK_IMPORTED_MODULE_1__prod_config__["a" /* default */];
} else if (process.env.NODE_ENV == 'development') {
  config = DEV;
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ "3jjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"prop":"spec_name","label":"规格"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"market_price","label":"市场价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cpprice","label":"宠品价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cost","label":"成本价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inventory","label":"库存"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_default","label":"是否默认"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isDefault[scope.row.is_default]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row.id)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"商品规格","prop":"spec_name"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.spec_name),callback:function ($$v) {_vm.editForm.spec_name=$$v},expression:"editForm.spec_name"}},_vm._l((_vm.prospecArr),function(item){return _c('el-option',{key:item.label,attrs:{"label":item.label,"value":item.label,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"市场价","prop":"market_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.market_price),callback:function ($$v) {_vm.editForm.market_price=$$v},expression:"editForm.market_price"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"宠品价","prop":"cpprice"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.cpprice),callback:function ($$v) {_vm.editForm.cpprice=$$v},expression:"editForm.cpprice"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"成本价","prop":"cost"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.cost),callback:function ($$v) {_vm.editForm.cost=$$v},expression:"editForm.cost"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"库存","prop":"inventory"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.inventory),callback:function ($$v) {_vm.editForm.inventory=$$v},expression:"editForm.inventory"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否默认","prop":"is_default"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.is_default),callback:function ($$v) {_vm.editForm.is_default=$$v},expression:"editForm.is_default"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5IAk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":20}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.beginTime),callback:function ($$v) {_vm.beginTime=$$v},expression:"beginTime"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}}),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":"商品名称","size":"small"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.export2Excel}},[_vm._v("导出数据")])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"ID","prop":"arrid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品编号","prop":"pro_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品名称","prop":"pro_name","align":"center","min-width":"500"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"当前价格","prop":"cpprice","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.cpprice > scope.row.avg_price)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.cpprice))]):_vm._e(),_vm._v(" "),(scope.row.cpprice == scope.row.avg_price)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.cpprice))]):_vm._e(),_vm._v(" "),(scope.row.cpprice < scope.row.avg_price)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.cpprice))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"平均售价","prop":"avg_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"平均成本","prop":"avg_cost","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"数量","prop":"num","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.num < 11)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.num))]):(scope.row.num > 30)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.num))]):(scope.row.num > 20)?_c('el-button',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(scope.row.num))]):(scope.row.num > 10)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.num))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"销售额","prop":"sum_price","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.sum_price < 1001)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 10000)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 5000)?_c('el-button',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 1000)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"产出额","prop":"sum_profit","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.sum_profit < 101)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 1000)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 500)?_c('el-button',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 100)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"利润率","prop":"profit_margin","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.editSpecHandler(scope.row.pro_id)}}},[_vm._v("修改价格")])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5b5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__ = __webpack_require__("0iuG");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      tableData: [],
      sels: [], // 存储选中的商品行
      total: 0,
      page: 1,
      pageSize: 30,
      copy_proid: '',
      copy_title: '1',
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      updateProVisible: false,
      addForm: {
        pro_name: '',
        brand_id: '',
        category_id: '',
        sec_id: '',
        weight: '',
        suit_pet: '',
        pro_mainpic: '',
        pro_pic: '',
        prosales: '',
        prointro_pic: '',
        pro_status: '1',
        related_proids: '',
        remark: '',
        create_time: '',
        update_time: '',
        status: 0,
        recommend: '0',
        upc: '',
        beianjia: '',
        origin_place: '',
        is_oversea: '1',
        admin_id: 0,
        dianpu_id: '',
        add_cart: '1',
        five_pifa: '0',
        one_daifa: '1',
        is_baoyou: '1',
        moban_id: '',
        referer_proid: '',
        referer_specid: ''
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      indexcategory: [],
      brand: [],
      secondMenu: [],
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl: '',
      imageName: '',
      fileListPro: [],
      fileListProintro: [],
      proPic: [],
      prointroPic: [],
      iswhiteProStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].iswhiteProStatus,
      recommendStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].recommendStatus,
      isoverseaStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].isoverseaStatus,
      baoyouStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].baoyouStatus,
      proStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].proStatus,
      indexStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].indexStatus,
      showUploadList: false,
      mainPicUrl: '',
      prospecArr: [],
      prospecForm: {
        spec_name: '',
        market_price: '',
        cpprice: '',
        cost: '',
        inventory: '908',
        is_default: '1'
      },
      selectProStatus: "200",
      isDefault: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].isDefault
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'proStatus', __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].proStatus), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'prospecTable', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'proid', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'selectGoodsVisible', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'goodsTypeData', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'goodsData', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'selectGoodsData', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'overseaArr', __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].overseaArr), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'mobanArr', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'dianpuList', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'selectDianpu', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'selectIndexStatus', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'selectWhite', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'currentProId', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'specListVisible', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'specListLoading', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'specTableData', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'specEditFormVisible', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'specEditForm', {}), _ref;
  },

  methods: {
    // 1. 打开规格弹窗并获取数据 (替换原有的 editSpecHandler)
    editSpecHandler: function editSpecHandler(proid) {
      this.currentProId = proid;
      this.specListVisible = true;
      this.getSpecList();
    },


    // 2. 获取当前商品的规格列表
    getSpecList: function getSpecList() {
      var _this = this;

      this.specListLoading = true;
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/specification/' + this.currentProId).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.specTableData = data.msg;
        }
        _this.specListLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$message.error('获取规格数据异常，请联系管理员');
        _this.specListLoading = false;
      });
    },


    // 3. 规格删除操作
    specDeleteHandler: function specDeleteHandler(id) {
      var _this2 = this;

      if (id != 0) {
        this.$confirm('是否删除该规格?', '提示', { type: 'warning' }).then(function () {
          _this2.$axios.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/specification/' + id).then(function (response) {
            if (!response.data.state) {
              _this2.$message.warning('删除规格失败');
            }
            _this2.getSpecList(); // 重新拉取刷新列表
          }).catch(function (error) {
            console.log(error);
            _this2.$message.error('删除规格异常');
          });
        }).catch(function () {});
      }
    },


    // 4. 打开规格修改子弹窗
    specEditHandler: function specEditHandler(row) {
      this.specEditFormVisible = true;
      this.specEditForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, row); // 浅拷贝，避免双向绑定直接污染表格
      this.specEditForm.is_default = row.is_default.toString();
    },


    // 5. 提交规格修改
    specEditSubmit: function specEditSubmit() {
      var _this3 = this;

      this.$refs.specEditForm.validate(function (valid) {
        if (valid) {
          _this3.submitLoading = true;
          var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this3.specEditForm);
          para.is_default = parseInt(para.is_default);
          para.inventory = parseInt(para.inventory);
          para.cpprice = parseFloat(para.cpprice);
          para.cost = parseFloat(para.cost);
          para.market_price = parseFloat(para.market_price);

          var paras = [para]; // 接口要求是数组格式

          _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/specification', paras).then(function (response) {
            _this3.submitLoading = false;
            if (response.data.state) {
              _this3.$message.success('提交成功');
              _this3.specEditFormVisible = false;
              _this3.getSpecList(); // 刷新表格
            } else {
              _this3.$message.error('提交失败，请联系管理员');
            }
          }).catch(function (error) {
            console.log(error);
            _this3.submitLoading = false;
            _this3.$message.error('提交异常，请联系管理员');
          });
        }
      });
    },


    // 统一处理上传前逻辑：生成本地预览占位，严格保证顺序
    handleBeforeUpload: function handleBeforeUpload(file, type) {
      var imageName = 'product/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      if (mime) {
        imageName += '.' + mime;
      }
      this.uploadForm.key = imageName;
      var qiniuUrl = __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + imageName;

      // 生成本地预览地址，提前展示图片体验更好
      var localPreviewUrl = URL.createObjectURL(file);

      if (type === 'pro') {
        this.proPic.push(qiniuUrl); // 最终传给后端的真实七牛云URL数组
        this.fileListPro.push({
          name: imageName,
          url: localPreviewUrl, // 临时展示本地图片
          uid: file.uid
        });
      } else if (type === 'intro') {
        this.prointroPic.push(qiniuUrl);
        this.fileListProintro.push({
          name: imageName,
          url: localPreviewUrl,
          uid: file.uid
        });
      }
      return true;
    },


    // 统一处理上传成功逻辑：将本地预览图替换为远端七牛云链接释放内存
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList, type) {
      var targetList = type === 'pro' ? this.fileListPro : this.fileListProintro;
      var targetFile = targetList.find(function (item) {
        return item.uid === file.uid;
      });
      if (targetFile) {
        targetFile.url = __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + response.key;
      }
    },


    // 统一处理上传失败逻辑：移除占位图及对应的真实链接
    handleUploadError: function handleUploadError(error, file, fileList, type) {
      console.log(error);
      this.$message.error('部分图片上传异常，请检查网络或联系管理员');

      if (type === 'pro') {
        this.fileListPro = this.fileListPro.filter(function (item) {
          return item.uid !== file.uid;
        });
        // 重构 proPic 保证数据与视图同步
        this.proPic = this.fileListPro.map(function (item) {
          return item.url;
        });
      } else if (type === 'intro') {
        this.fileListProintro = this.fileListProintro.filter(function (item) {
          return item.uid !== file.uid;
        });
        this.prointroPic = this.fileListProintro.map(function (item) {
          return item.url;
        });
      }
    },

    // 记录选中的行
    handleSelectionChange: function handleSelectionChange(sels) {
      this.sels = sels;
    },

    // 批量上下架处理
    batchStatusHandler: function batchStatusHandler(status) {
      var _this4 = this;

      var text = status === 1 ? '上架' : '下架';
      var ids = this.sels.map(function (item) {
        return item.pro_id;
      }); // 假设后端接收商品ID数组

      this.$confirm('\u786E\u8BA4\u6279\u91CF' + text + '\u9009\u4E2D\u7684 ' + ids.length + ' \u4E2A\u5546\u54C1\u5417\uFF1F', '提示', {
        type: 'warning'
      }).then(function () {
        _this4.listLoading = true;
        // 注意：这里的请求路由 /product/batchstatus 和入参结构需根据您的后端接口实际情况调整
        _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/batchstatus', {
          ids: ids,
          pro_status: status
        }).then(function (response) {
          _this4.listLoading = false;
          if (response.data.state) {
            _this4.$message({ message: '\u6279\u91CF' + text + '\u6210\u529F', type: 'success' });
            _this4.search(); // 刷新列表
          } else {
            _this4.$message({ message: response.data.msg || '\u6279\u91CF' + text + '\u5931\u8D25', type: 'error' });
          }
        }).catch(function (error) {
          _this4.listLoading = false;
          console.log(error);
          _this4.$message({ message: '批量操作异常，请联系管理员', type: 'error' });
        });
      }).catch(function () {});
    },

    // 动态调整图片顺序方法
    moveImage: function moveImage(type, index, direction) {
      var fileList = type === 'pro' ? this.fileListPro : this.fileListProintro;
      var picArr = type === 'pro' ? this.proPic : this.prointroPic;

      // 计算目标位置
      var targetIndex = direction === 'up' ? index - 1 : index + 1;

      // 1. 交换前端显示的 fileList 元素位置
      var tempFile = fileList[index];
      this.$set(fileList, index, fileList[targetIndex]);
      this.$set(fileList, targetIndex, tempFile);

      // 2. 交换实际提交给后端的 picArr 数组里的图片 URL 顺序
      var tempPic = picArr[index];
      this.$set(picArr, index, picArr[targetIndex]);
      this.$set(picArr, targetIndex, tempPic);
    },


    // 代替原生 remove 的删除图片方法
    deleteImage: function deleteImage(type, index) {
      if (type === 'pro') {
        this.fileListPro.splice(index, 1);
        this.proPic.splice(index, 1);
      } else {
        this.fileListProintro.splice(index, 1);
        this.prointroPic.splice(index, 1);
      }
    },

    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getGoodsList(this.query);
    },

    //获取商品列表
    getGoodsList: function getGoodsList(query) {
      var _this5 = this;

      this.listLoading = true;
      query = this.selectDianpu + "|" + this.selectIndexStatus + "|" + this.selectProStatus + "|" + this.selectWhite + "|" + query;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this5.total = data.count;
          _this5.tableData = data.msg;
          _this5.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
        _this5.listLoading = false;
      });
    },

    // 导出Excel
    export2Excel: function export2Excel() {
      var _this6 = this;

      var query = this.selectDianpu + "|" + this.selectProStatus + "|" + this.query;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/excel', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        if (response.data.state) {
          if (response.data.msg) {
            console.log(response.data.msg);
            __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
              var _require = __webpack_require__("zKXg"),
                  export_json_to_excel = _require.export_json_to_excel;

              var tHeader = ['商品名称', '品牌', '二级目录', '首页分类', '规格名称', '商品状态', '市场价', '宠品仓价', '库存', '店铺名称', '备注', '关联商品ID', '关联规格ID']; //对应表格输出的title
              var filterVal = ['pro_name', 'brand_name', 'sec_name', 'category_name', 'spec_name', 'pro_status_str', 'market_price', 'price', 'inventory', 'dianpu_name', 'remark', 'referer_proid', 'referer_specid']; // 对应表格输出的数据
              var list = response.data.msg;
              var data = _this6.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '商品列表_' + new Date().toLocaleString()); //对应下载文件的名字
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          } else {
            _this6.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        } else {
          _this6.$message({
            message: '无数据，请联系管理员！',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$message({
          message: '导出异常，请联系管理员！',
          type: 'error'
        });
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },


    //新增数据提交
    addSubmit: function addSubmit() {
      var _this7 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this7.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this7.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this7.addForm));
            para.prosales = parseInt(para.prosales);
            para.pro_pic = _this7.proPic.toString();
            para.prointro_pic = _this7.prointroPic.toString();
            para.pro_status = parseInt(para.pro_status);
            para.recommend = parseInt(para.recommend);
            para.pro_mainpic = _this7.mainPicUrl;
            para.beianjia = parseInt(para.beianjia);
            para.add_cart = parseInt(para.add_cart);
            para.five_pifa = parseInt(para.five_pifa);
            para.one_daifa = parseInt(para.one_daifa);
            para.is_baoyou = parseInt(para.is_baoyou);
            para.moban_id = parseInt(para.moban_id);
            para.is_oversea = parseInt(para.is_oversea);
            para.referer_proid = parseInt(para.referer_proid);
            para.referer_specid = parseInt(para.referer_specid);
            //异步请求
            _this7.$axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product', para).then(function (response) {
              if (response.data.state) {
                //新增商品规格
                _this7.addProspec(response.data.msg);
                _this7.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this7.$refs['addForm'].resetFields();
                _this7.mainPicUrl = '';
                _this7.proPic = [];
                _this7.prointroPic = [];
                _this7.fileListPro = [];
                _this7.fileListProintro = [];
                _this7.prospecTable = [];
                _this7.referer_proid = '';
                _this7.referer_specid = '';
                _this7.addFormVisible = false;
                _this7.search();
              } else {
                _this7.$message({
                  message: '提交失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this7.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this7.submitLoading = false;
          });
        }
      });
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      var _this8 = this;

      this.editFormVisible = true;
      this.editForm = row;
      this.editForm.pro_status = row.pro_status.toString();
      this.editForm.recommend = row.recommend.toString();
      this.editForm.is_oversea = row.is_oversea.toString();
      this.editForm.add_cart = row.add_cart.toString();
      this.editForm.five_pifa = row.five_pifa.toString();
      this.editForm.one_daifa = row.one_daifa.toString();
      this.editForm.is_baoyou = row.is_baoyou.toString();

      //this.editForm.moban_id = row.moban_id.toString();
      this.proPic = row.pro_pic.split(',');
      this.prointroPic = row.prointro_pic.split(',');
      var that = this;
      this.fileListPro = [];
      this.proPic.forEach(function (item, i) {
        that.fileListPro.push({
          name: item.replace(__WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl, ''),
          url: item
        });
      });
      this.fileListProintro = [];
      this.prointroPic.forEach(function (item, i) {
        that.fileListProintro.push({
          name: item.replace(__WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl, ''),
          url: item
        });
      });
      this.mainPicUrl = row.pro_mainpic;
      //获取商品规格列表
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/specification/' + row.pro_id).then(function (response) {
        _this8.prospecTable = [];
        var i = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            item.index = i;
            _this8.prospecTable.push(item);
            i++;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    //修改提交
    editSubmit: function editSubmit() {
      var _this9 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this9.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this9.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this9.editForm));
            para.prosales = parseInt(para.prosales);
            para.pro_pic = _this9.proPic.toString();
            para.prointro_pic = _this9.prointroPic.toString();
            para.pro_status = parseInt(para.pro_status);
            para.recommend = parseInt(para.recommend);
            para.pro_mainpic = _this9.mainPicUrl;
            para.beianjia = parseInt(para.beianjia);
            para.add_cart = parseInt(para.add_cart);
            para.five_pifa = parseInt(para.five_pifa);
            para.one_daifa = parseInt(para.one_daifa);
            para.is_baoyou = parseInt(para.is_baoyou);
            // para.moban_id = parseInt(para.moban_id);
            para.is_oversea = parseInt(para.is_oversea);
            para.referer_proid = parseInt(para.referer_proid);
            para.referer_specid = parseInt(para.referer_specid);
            //异步请求
            _this9.$axios.put(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product', para).then(function (response) {
              if (response.data.state) {
                //新增商品规格
                _this9.addProspec(response.data.msg);
                _this9.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this9.$refs['editForm'].resetFields();
                _this9.mainPicUrl = '';
                _this9.proPic = [];
                _this9.prointroPic = [];
                _this9.fileListPro = [];
                _this9.fileListProintro = [];
                _this9.prospecTable = [];
                _this9.referer_proid = '';
                _this9.referer_specid = '';
                _this9.editFormVisible = false;
                _this9.search();
              } else {
                _this9.$message({
                  message: '提交失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this9.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this9.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {

      this.addFormVisible = true;
      this.proPic = [];
      this.fileListPro = [];
      this.prointroPic = [];
      this.fileListProintro = [];
      this.mainPicUrl = '';
      this.prospecTable = [];
      this.referer_proid = '';
      this.referer_specid = '';
    },

    //上传图片到七牛
    beforeUpload: function beforeUpload(file) {
      this.imageName = 'product/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      this.imageName += '.' + mime;
      this.uploadForm.key = this.imageName;
      this.imageUrl = __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + this.imageName;
    },

    //上传失败
    uploadError: function uploadError(error) {
      console.log(error);
      this.$message({
        message: '图片上传异常，请联系管理员',
        type: 'error'
      });
    },

    //商品图片上传
    uploadPro: function uploadPro() {
      this.proPic.push(this.imageUrl);
      this.fileListPro.push({
        name: this.imageName,
        url: this.imageUrl
      });
    },

    //商品详情图片上传
    uploadProintro: function uploadProintro() {
      this.prointroPic.push(this.imageUrl);
      this.fileListProintro.push({
        name: this.imageName,
        url: this.imageUrl
      });
    },

    //商品图片删除
    removePicPro: function removePicPro(file, fileList) {
      this.proPic = this.proPic.filter(function (x) {
        return x !== __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + file.name;
      });
      this.proPic = this.proPic.filter(function (x) {
        return x !== file.name;
      });
    },

    //商品详情图片删除
    removePicProintro: function removePicProintro(file, fileList) {
      this.prointroPic = this.prointroPic.filter(function (x) {
        return x !== __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + file.name;
      });
      this.prointroPic = this.prointroPic.filter(function (x) {
        return x !== file.name;
      });
    },

    //获取品牌列表
    getBrand: function getBrand() {
      var _this10 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/brand/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.msg), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              _this10.brand.push({
                label: item.brand_name,
                value: item.brand_id
              });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        } else {
          _this10.$message({
            message: '获取品牌失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this10.$message({
          message: '获取品牌异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取首页分类列表
    getIndexCategory: function getIndexCategory() {
      var _this11 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/indexcategory/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.msg), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              _this11.indexcategory.push({
                label: item.category_name,
                value: item.category_id
              });
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else {
          _this11.$message({
            message: '获取首页分类失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this11.$message({
          message: '获取首页分类异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取二级分类列表
    getSecondMenu: function getSecondMenu() {
      var _this12 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/menu/tree').then(function (response) {
        var data = response.data;
        if (data && data.length > 0) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var item = _step4.value;
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(item.sec_menu), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var item1 = _step5.value;

                  _this12.secondMenu.push({
                    label: item1.sec_name,
                    value: item1.sec_id
                  });
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        } else {
          _this12.$message({
            message: '获取分类失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this12.$message({
          message: '获取分类异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //上传商品主图片
    mainBeforeUpload: function mainBeforeUpload(file) {
      var fileName = 'product/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      fileName += '.' + mime;
      this.uploadForm.key = fileName;
    },
    mainHandleSuccess: function mainHandleSuccess(response, file, fileList) {
      this.mainPicUrl = __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
      this.result = '上传成功';
    },
    mainHandleError: function mainHandleError(error, response, file) {
      this.result = error.toString();
    },

    //获取规格列表
    getSpec: function getSpec() {
      var _this13 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/specification/list').then(function (response) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var item = _step6.value;

            _this13.prospecArr.push({
              label: item.name,
              value: item.id
            });
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    //保存规格，暂存在本地
    saveSpec: function saveSpec() {
      var para = this.prospecForm;
      para.is_default = parseInt(para.is_default);
      para.inventory = parseInt(para.inventory);
      para.cpprice = parseInt(para.cpprice);
      para.cost = parseInt(para.cost);
      para.market_price = parseInt(para.market_price);
      para.index = this.prospecTable.length;
      this.prospecTable.push(para);
      this.prospecForm = {
        spec_name: '',
        market_price: '',
        cpprice: '',
        cost: '',
        inventory: '',
        is_default: '0'
      };
    },

    //删除所有规格
    deleteSpec: function deleteSpec(id, index) {
      var _this14 = this;

      if (id > 0) {
        //删除数据库
        this.$axios.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/specification/' + id).then(function (response) {
          if (!response.data.state) {
            _this14.$message({
              message: '删除规格失败',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this14.$message({
            message: '删除规格异常',
            type: 'error'
          });
        });
      }
      //删除数组
      this.prospecTable.splice(index, 1);
      for (var i = 0; i < this.prospecTable.length; i++) {
        this.prospecTable[i].index = i;
      }
    },

    //新增商品规格
    addProspec: function addProspec(proid) {
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/specification/' + proid, this.prospecTable).then(function (response) {}).catch(function (error) {
        console.log(error);
      });
    },

    // //修改规格
    // editSpecHandler(proid) {
    //   this.$router.push("/goods/prospec/" + proid);
    // },
    //打开更新宝贝
    updatePro: function updatePro(row) {
      this.updateProVisible = true;
      this.pro_id = row.pro_id;
      this.copy_proid = row.copy_proid;
    },

    //修改更新宝贝
    updateProSubmit: function updateProSubmit() {
      var _this15 = this;

      this.submitLoading = true;
      this.$axios.put(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/goods/updateprosubmit', {
        "pro_id": this.pro_id,
        "copy_title": parseInt(this.copy_title),
        "copy_proid": this.copy_proid
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this15.$message({
            message: '更新成功！',
            type: 'success'
          });
          _this15.submitLoading = false;
          _this15.updateProVisible = false;
          _this15.search();
        } else {
          _this15.$message({
            message: '更新宝贝失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this15.$message({
          message: '修改备注异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取商品分类树
    showGoodsForm: function showGoodsForm(row) {
      var _this16 = this;

      this.proid = row.pro_id;
      this.goodsData = [];
      this.selectGoodsData = [];
      this.selectGoodsVisible = true;
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/menu/tree').then(function (response) {
        var data = response.data;
        if (data && data.length > 0) {
          var allmenu = [];
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var item = _step7.value;

              if (item.sec_menu && item.sec_menu.length > 0) {
                var secMenu = [];
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                  for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(item.sec_menu), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var item1 = _step8.value;

                    secMenu.push({
                      label: item1.sec_name,
                      value: item1.sec_id,
                      isFirst: 0
                    });
                  }
                } catch (err) {
                  _didIteratorError8 = true;
                  _iteratorError8 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                      _iterator8.return();
                    }
                  } finally {
                    if (_didIteratorError8) {
                      throw _iteratorError8;
                    }
                  }
                }

                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                  children: secMenu
                });
              } else {
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1
                });
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          _this16.goodsTypeData = allmenu;
        } else {
          _this16.$message({
            message: '获取树失败',
            type: 'error'
          });
        }
      }).catch(function (error) {
        _this16.$message({
          message: '获取树异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //点击树节点，获取商品
    handleNodeClick: function handleNodeClick(data) {
      var _this17 = this;

      if (data.isFirst === 0) {
        this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/type/' + data.value).then(function (response) {
          var data = response.data;
          if (data && data.length > 0) {
            var goodsData = [];
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
              for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var item = _step9.value;

                goodsData.push({
                  name: item.pro_name,
                  value: item.pro_id
                });
              }
            } catch (err) {
              _didIteratorError9 = true;
              _iteratorError9 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }
              } finally {
                if (_didIteratorError9) {
                  throw _iteratorError9;
                }
              }
            }

            _this17.goodsData = goodsData;
            //获取已关联商品
            _this17.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/relateds/' + _this17.proid).then(function (response) {
              if (response.data) {
                var selectData = [];
                var _iteratorNormalCompletion10 = true;
                var _didIteratorError10 = false;
                var _iteratorError10 = undefined;

                try {
                  for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.split(',')), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var id = _step10.value;
                    var _iteratorNormalCompletion11 = true;
                    var _didIteratorError11 = false;
                    var _iteratorError11 = undefined;

                    try {
                      for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(goodsData), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                        var _item = _step11.value;

                        if (_item.value === parseInt(id)) {
                          selectData.push(_item.name + '-' + id);
                        }
                      }
                    } catch (err) {
                      _didIteratorError11 = true;
                      _iteratorError11 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                          _iterator11.return();
                        }
                      } finally {
                        if (_didIteratorError11) {
                          throw _iteratorError11;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError10 = true;
                  _iteratorError10 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                      _iterator10.return();
                    }
                  } finally {
                    if (_didIteratorError10) {
                      throw _iteratorError10;
                    }
                  }
                }

                _this17.selectGoodsData = selectData;
              }
            }).catch(function (error) {
              console.log(error);
              _this17.$message({
                message: '获取商品异常，请联系管理员',
                type: 'error'
              });
            });
          } else {
            _this17.$message({
              message: '未获取到商品',
              type: 'info'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this17.$message({
            message: '获取商品异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },

    //提交选择商品
    selectGoodsSubmit: function selectGoodsSubmit() {
      var _this18 = this;

      if (this.selectGoodsData && this.selectGoodsData.length > 0) {
        var proIds = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectGoodsData), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var item = _step12.value;

            proIds.push(item.split('-')[1]);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        this.$axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/related', {
          related_proids: proIds.toString(),
          pro_id: this.proid
        }).then(function (response) {
          if (response.data.state) {
            _this18.$message({
              message: '提交成功',
              type: 'success'
            });
            _this18.selectGoodsVisible = false;
          } else {
            _this18.$message({
              message: '未获取到商品',
              type: 'info'
            });
          }
        }).catch(function (error) {
          _this18.$message({
            message: '获取商品异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
    onekeyCopy: function onekeyCopy(pro_id) {
      var _this19 = this;

      this.$confirm('确认一键复制吗？', '提示', {}).then(function () {

        _this19.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/onekeycopy/' + pro_id).then(function (response) {
          var data = response.data;
          if (data.state) {
            _this19.$message({
              message: '复制成功',
              type: 'success'
            });
            _this19.search();
          } else {
            _this19.$message({
              message: '一键复制失败',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this19.$message({
            message: '一键复制异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },
    setWhiteList: function setWhiteList(pro_id) {
      var _this20 = this;

      this.$confirm('确认设置为白名单吗？', '提示', {}).then(function () {

        _this20.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/setwhitelist/' + pro_id).then(function (response) {
          var data = response.data;
          if (data.state) {
            _this20.$message({
              message: '白名单成功',
              type: 'success'
            });
            _this20.search();
          } else {
            _this20.$message({
              message: '设置失败',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this20.$message({
            message: '设置异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },
    deleteRemark: function deleteRemark(pro_id) {
      var _this21 = this;

      this.$confirm('确认清空备注上架吗？', '提示', {}).then(function () {

        _this21.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/deleteremark/' + pro_id).then(function (response) {
          var data = response.data;
          if (data.state) {
            _this21.$message({
              message: '清空备注成功',
              type: 'success'
            });
            _this21.search();
          } else {
            _this21.$message({
              message: '清空备注失败',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this21.$message({
            message: '清空备注异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },
    getDianpuList: function getDianpuList() {
      var _this22 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/dianpu/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.msg), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var item = _step13.value;

              _this22.dianpuList.push({
                label: item.dianpu_name,
                value: item.id
              });
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }
        } else {
          _this22.$message({
            message: '获取店铺失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this22.$message({
          message: '获取店铺异常，请联系管理员',
          type: 'error'
        });
      });
    },
    getKuaidiMoban: function getKuaidiMoban() {
      var _this23 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/kuaidi/moban').then(function (response) {
        if (response.data.state) {
          _this23.mobanArr = [];
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var item = _step14.value;

              _this23.mobanArr.push({
                label: item.name,
                value: item.id
              });
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        } else {
          _this23.$message({
            message: '获取快递模板失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this23.$message({
          message: '获取快递模板异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },

  created: function created() {
    this.search();
    this.getBrand();
    this.getIndexCategory();
    this.getSecondMenu();
    this.getSpec();
    this.getKuaidiMoban();
    this.getDianpuList();
  }
});

/***/ }),

/***/ "6I0w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6IBZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6d14":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8dVu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rule_vue__ = __webpack_require__("ZKPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03af0ecd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_rule_vue__ = __webpack_require__("8dcC");
function injectStyle (ssrContext) {
  __webpack_require__("u164")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03af0ecd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03af0ecd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_rule_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8dcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"ID","prop":"id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"快递模板","prop":"name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"省份","prop":"sheng","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"首重","prop":"shou_zhong","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"首重价格","prop":"shouzhong_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"续重价格","prop":"xuzhong_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"small","type":"danger"},on:{"click":function($event){_vm.deleteHandler(scope.row.id)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"快递模板","prop":"moban_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"请选择","size":"small"},model:{value:(_vm.mobanId),callback:function ($$v) {_vm.mobanId=$$v},expression:"mobanId"}},_vm._l((_vm.moban),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省份","prop":"sheng"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.sheng),callback:function ($$v) {_vm.addForm.sheng=$$v},expression:"addForm.sheng"}},_vm._l((_vm.shengFen),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首重","prop":"shou_zhong"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.shou_zhong),callback:function ($$v) {_vm.addForm.shou_zhong=$$v},expression:"addForm.shou_zhong"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首重价格","prop":"shouzhong_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.shouzhong_price),callback:function ($$v) {_vm.addForm.shouzhong_price=$$v},expression:"addForm.shouzhong_price"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"续重价格","prop":"xuzhong_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.xuzhong_price),callback:function ($$v) {_vm.addForm.xuzhong_price=$$v},expression:"addForm.xuzhong_price"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"快递模板","prop":"moban_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"请选择","size":"small"},model:{value:(_vm.editForm.moban_id),callback:function ($$v) {_vm.editForm.moban_id=$$v},expression:"editForm.moban_id"}},_vm._l((_vm.moban),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省份","prop":"sheng"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.sheng),callback:function ($$v) {_vm.editForm.sheng=$$v},expression:"editForm.sheng"}},_vm._l((_vm.shengFen),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首重","prop":"shou_zhong"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.shou_zhong),callback:function ($$v) {_vm.editForm.shou_zhong=$$v},expression:"editForm.shou_zhong"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首重价格","prop":"shouzhong_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.shouzhong_price),callback:function ($$v) {_vm.editForm.shouzhong_price=$$v},expression:"editForm.shouzhong_price"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"续重价格","prop":"xuzhong_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.xuzhong_price),callback:function ($$v) {_vm.editForm.xuzhong_price=$$v},expression:"editForm.xuzhong_price"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "92jO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prospec_vue__ = __webpack_require__("aETj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b41df70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_prospec_vue__ = __webpack_require__("3jjg");
function injectStyle (ssrContext) {
  __webpack_require__("sYY/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b41df70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prospec_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b41df70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_prospec_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "938p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_writecopy_vue__ = __webpack_require__("ze7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70205c34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_writecopy_vue__ = __webpack_require__("BSDU");
function injectStyle (ssrContext) {
  __webpack_require__("G81h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70205c34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_writecopy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70205c34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_writecopy_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "9SPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":15}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small","disabled":this.sels.length===0},on:{"click":function($event){_vm.batchStatusHandler(1)}}},[_vm._v("批量上架")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"small","disabled":this.sels.length===0},on:{"click":function($event){_vm.batchStatusHandler(0)}}},[_vm._v("批量下架")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"店铺","size":"small"},model:{value:(_vm.selectDianpu),callback:function ($$v) {_vm.selectDianpu=$$v},expression:"selectDianpu"}},[_c('el-option',{key:"0",attrs:{"label":"全部","value":"0"}}),_vm._v(" "),_vm._l((_vm.dianpuList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value,"size":"small"}})})],2),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"首页分类","size":"small"},model:{value:(_vm.selectIndexStatus),callback:function ($$v) {_vm.selectIndexStatus=$$v},expression:"selectIndexStatus"}},[_c('el-option',{key:"0",attrs:{"label":"无","value":"0"}}),_vm._v(" "),_vm._l((_vm.indexStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"是否上架","size":"small"},model:{value:(_vm.selectProStatus),callback:function ($$v) {_vm.selectProStatus=$$v},expression:"selectProStatus"}},[_c('el-option',{key:"0",attrs:{"label":"全部","value":"200"}}),_vm._v(" "),_vm._l((_vm.proStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"是否白名单","size":"small"},model:{value:(_vm.selectWhite),callback:function ($$v) {_vm.selectWhite=$$v},expression:"selectWhite"}},[_c('el-option',{key:"0",attrs:{"label":"全部","value":"0"}}),_vm._v(" "),_vm._l((_vm.iswhiteProStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.export2Excel}},[_vm._v("导出数据")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"80","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品编号","prop":"pro_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品名称","prop":"pro_name","align":"center","min-width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"首页分类","prop":"category_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"品牌","prop":"brand_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分类","prop":"sec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"默认规格","align":"center","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"padding":"5px 0","line-height":"28px"}},[_c('div',{staticStyle:{"margin-bottom":"4px"}},[_c('span',{staticStyle:{"font-size":"12px","color":"#606266","margin-right":"4px"}},[_vm._v("市场价:")]),_vm._v(" "),(Number(scope.row.market_price) <= 100)?_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"success","size":"mini"}},[_vm._v("\n          ￥"+_vm._s(scope.row.market_price)+"\n        ")]):_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"danger","size":"mini"}},[_vm._v("\n          ￥"+_vm._s(scope.row.market_price)+"\n        ")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"4px"}},[_c('span',{staticStyle:{"font-size":"12px","color":"#606266","margin-right":"4px"}},[_vm._v("宠品价:")]),_vm._v(" "),(Number(scope.row.cpprice) <= 100)?_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"success","size":"mini"}},[_vm._v("\n          ￥"+_vm._s(scope.row.cpprice)+"\n        ")]):_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"danger","size":"mini"}},[_vm._v("\n          ￥"+_vm._s(scope.row.cpprice)+"\n        ")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"4px"}},[_c('span',{staticStyle:{"font-size":"12px","color":"#606266","margin-right":"4px"}},[_vm._v("成本价:")]),_vm._v(" "),(Number(scope.row.cost) <= 100)?_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"success","size":"mini"}},[_vm._v("\n          ￥"+_vm._s(scope.row.cost)+"\n        ")]):_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"danger","size":"mini"}},[_vm._v("\n          ￥"+_vm._s(scope.row.cost)+"\n        ")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"4px"}},[_c('span',{staticStyle:{"font-size":"12px","color":"#606266","margin-right":"4px"}},[_vm._v("利润值:")]),_vm._v(" "),((Number(scope.row.cpprice) - Number(scope.row.cost)) < 0)?_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"danger","size":"mini"}},[_vm._v("\n          ￥"+_vm._s((Number(scope.row.cpprice) - Number(scope.row.cost)).toFixed(0))+"\n        ")]):_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"success","size":"mini"}},[_vm._v("\n          ￥"+_vm._s((Number(scope.row.cpprice) - Number(scope.row.cost)).toFixed(0))+"\n        ")])],1),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"12px","color":"#606266","margin-right":"4px"}},[_vm._v("库存:")]),_vm._v(" "),(Number(scope.row.inventory) <= 10)?_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"warning","size":"mini"}},[_vm._v("\n          "+_vm._s(scope.row.inventory)+" 件\n        ")]):_c('el-button',{staticStyle:{"cursor":"default","padding":"3px 8px"},attrs:{"type":"primary","size":"mini"}},[_vm._v("\n          "+_vm._s(scope.row.inventory)+" 件\n        ")])],1)])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否包邮","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.is_baoyou == 1)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("包邮")]):_vm._e(),_vm._v(" "),(scope.row.is_baoyou == 0)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(" 不包邮")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.pro_status == 1)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("已上架")]):_vm._e(),_vm._v(" "),(scope.row.pro_status == 0)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(" 未上架")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"推荐状态","prop":"recommend","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.recommendStatus[scope.row.recommend]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"关联商品ID","prop":"referer_proid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"关联规格ID","prop":"referer_specid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"更新时间","prop":"update_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"备注","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center","min-width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.editSpecHandler(scope.row.pro_id)}}},[_vm._v("修改规格")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.updatePro(scope.row)}}},[_vm._v("更新宝贝")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.onekeyCopy(scope.row.pro_id)}}},[_vm._v("一键复制")]),_vm._v(" "),(scope.row.remark == '' )?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.setWhiteList(scope.row.pro_id)}}},[_vm._v("设白名单")]):_vm._e(),_vm._v(" "),(scope.row.remark != '' )?_c('el-button',{attrs:{"size":"small","type":"success"},on:{"click":function($event){_vm.deleteRemark(scope.row.pro_id)}}},[_vm._v("清备上架")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增","size":"large"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"商品名称","prop":"pro_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.pro_name),callback:function ($$v) {_vm.addForm.pro_name=$$v},expression:"addForm.pro_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"品牌","prop":"brand_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.brand_id),callback:function ($$v) {_vm.addForm.brand_id=$$v},expression:"addForm.brand_id"}},_vm._l((_vm.brand),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首页分类","prop":"category_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.category_id),callback:function ($$v) {_vm.addForm.category_id=$$v},expression:"addForm.category_id"}},_vm._l((_vm.indexcategory),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"二级分类","prop":"sec_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.sec_id),callback:function ($$v) {_vm.addForm.sec_id=$$v},expression:"addForm.sec_id"}},_vm._l((_vm.secondMenu),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品主图","prop":"pro_mainpic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.mainHandleSuccess,"on-error":_vm.mainHandleError,"before-upload":_vm.mainBeforeUpload,"data":_vm.uploadForm}},[(_vm.mainPicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.mainPicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品图片","prop":"pro_pic"}},[_c('el-upload',{attrs:{"multiple":"","action":"https://up.qbox.me","on-success":function (res, file, fileList) { return _vm.handleUploadSuccess(res, file, fileList, 'pro'); },"on-error":function (err, file, fileList) { return _vm.handleUploadError(err, file, fileList, 'pro'); },"on-remove":_vm.removePicPro,"before-upload":function (file) { return _vm.handleBeforeUpload(file, 'pro'); },"data":_vm.uploadForm,"file-list":_vm.fileListPro,"list-type":"picture","show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击多选上传")])],1),_vm._v(" "),(_vm.fileListPro.length > 0)?_c('div',{staticClass:"image-sort-container"},_vm._l((_vm.fileListPro),function(file,index){return _c('div',{key:index,staticClass:"image-sort-item"},[_c('img',{staticClass:"sort-img",attrs:{"src":file.url}}),_vm._v(" "),_c('div',{staticClass:"sort-btns"},[_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-left","disabled":index === 0},on:{"click":function($event){_vm.moveImage('pro', index, 'up')}}},[_vm._v("前移")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-right","disabled":index === _vm.fileListPro.length - 1},on:{"click":function($event){_vm.moveImage('pro', index, 'down')}}},[_vm._v("后移")]),_vm._v(" "),_c('el-button',{staticStyle:{"color":"#ff4949"},attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.deleteImage('pro', index)}}},[_vm._v("删除")])],1)])})):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品详情图片","prop":"prointro_pic"}},[_c('el-upload',{attrs:{"multiple":"","action":"https://up.qbox.me","on-success":function (res, file, fileList) { return _vm.handleUploadSuccess(res, file, fileList, 'intro'); },"on-error":function (err, file, fileList) { return _vm.handleUploadError(err, file, fileList, 'intro'); },"on-remove":_vm.removePicProintro,"before-upload":function (file) { return _vm.handleBeforeUpload(file, 'intro'); },"data":_vm.uploadForm,"file-list":_vm.fileListProintro,"list-type":"picture","show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击多选上传")])],1),_vm._v(" "),(_vm.fileListProintro.length > 0)?_c('div',{staticClass:"image-sort-container"},_vm._l((_vm.fileListProintro),function(file,index){return _c('div',{key:index,staticClass:"image-sort-item"},[_c('img',{staticClass:"sort-img",attrs:{"src":file.url}}),_vm._v(" "),_c('div',{staticClass:"sort-btns"},[_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-left","disabled":index === 0},on:{"click":function($event){_vm.moveImage('intro', index, 'up')}}},[_vm._v("前移")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-right","disabled":index === _vm.fileListProintro.length - 1},on:{"click":function($event){_vm.moveImage('intro', index, 'down')}}},[_vm._v("后移")]),_vm._v(" "),_c('el-button',{staticStyle:{"color":"#ff4949"},attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.deleteImage('intro', index)}}},[_vm._v("删除")])],1)])})):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品状态","prop":"pro_status"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.pro_status),callback:function ($$v) {_vm.addForm.pro_status=$$v},expression:"addForm.pro_status"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"推荐状态","prop":"recommend"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.recommend),callback:function ($$v) {_vm.addForm.recommend=$$v},expression:"addForm.recommend"}},_vm._l((_vm.recommendStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加入购物车","prop":"add_cart"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.add_cart),callback:function ($$v) {_vm.addForm.add_cart=$$v},expression:"addForm.add_cart"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"五件批发","prop":"five_pifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.five_pifa),callback:function ($$v) {_vm.addForm.five_pifa=$$v},expression:"addForm.five_pifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"一件代发","prop":"one_daifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.one_daifa),callback:function ($$v) {_vm.addForm.one_daifa=$$v},expression:"addForm.one_daifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否包邮","prop":"is_baoyou"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.is_baoyou),callback:function ($$v) {_vm.addForm.is_baoyou=$$v},expression:"addForm.is_baoyou"}})],1),_vm._v(" "),(_vm.addForm.is_baoyou === '0')?_c('el-form-item',{attrs:{"label":"快递模版","prop":"moban_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.moban_id),callback:function ($$v) {_vm.addForm.moban_id=$$v},expression:"addForm.moban_id"}},_vm._l((_vm.mobanArr),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属店铺","prop":"dianpu_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.dianpu_id),callback:function ($$v) {_vm.addForm.dianpu_id=$$v},expression:"addForm.dianpu_id"}},_vm._l((_vm.dianpuList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"仓库","prop":"is_oversea"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.is_oversea),callback:function ($$v) {_vm.addForm.is_oversea=$$v},expression:"addForm.is_oversea"}},_vm._l((_vm.overseaArr),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"UPC","prop":"upc"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.upc),callback:function ($$v) {_vm.addForm.upc=$$v},expression:"addForm.upc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"关联商品ID","prop":"referer_proid"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.referer_proid),callback:function ($$v) {_vm.addForm.referer_proid=$$v},expression:"addForm.referer_proid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"关联规格ID","prop":"referer_specid"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.referer_specid),callback:function ($$v) {_vm.addForm.referer_specid=$$v},expression:"addForm.referer_specid"}})],1),_vm._v(" "),_c('div',{staticClass:"spec_border"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"商品规格"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.prospecForm.spec_name),callback:function ($$v) {_vm.prospecForm.spec_name=$$v},expression:"prospecForm.spec_name"}},_vm._l((_vm.prospecArr),function(item){return _c('el-option',{key:item.label,attrs:{"label":item.label,"value":item.label,"size":"small"}})})),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必选,可新增不同规格 如 16kg 32kg  一包  两包")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"库存"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.inventory),callback:function ($$v) {_vm.prospecForm.inventory=$$v},expression:"prospecForm.inventory"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"市场价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.market_price),callback:function ($$v) {_vm.prospecForm.market_price=$$v},expression:"prospecForm.market_price"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"宠品价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.cpprice),callback:function ($$v) {_vm.prospecForm.cpprice=$$v},expression:"prospecForm.cpprice"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"成本价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.cost),callback:function ($$v) {_vm.prospecForm.cost=$$v},expression:"prospecForm.cost"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否默认"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.prospecForm.is_default),callback:function ($$v) {_vm.prospecForm.is_default=$$v},expression:"prospecForm.is_default"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("商品必选一个默认规格")])],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"padding":"5px 0 0 150px"},attrs:{"span":12}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.saveSpec}},[_vm._v("保存规格")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-table',{attrs:{"data":_vm.prospecTable}},[_c('el-table-column',{attrs:{"prop":"spec_name","label":"规格"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"market_price","label":"市场价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cpprice","label":"宠品价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cost","label":"成本价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inventory","label":"库存"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_default","label":"是否默认"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isDefault[scope.row.is_default]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","plain":true,"type":"danger"},on:{"click":function($event){_vm.deleteSpec(scope.row.id, scope.row.index)}}},[_vm._v("删除")])]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.remark),callback:function ($$v) {_vm.addForm.remark=$$v},expression:"addForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑","size":"large"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"商品名称","prop":"pro_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.pro_name),callback:function ($$v) {_vm.editForm.pro_name=$$v},expression:"editForm.pro_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"品牌","prop":"brand_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.brand_id),callback:function ($$v) {_vm.editForm.brand_id=$$v},expression:"editForm.brand_id"}},_vm._l((_vm.brand),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首页分类","prop":"category_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.category_id),callback:function ($$v) {_vm.editForm.category_id=$$v},expression:"editForm.category_id"}},_vm._l((_vm.indexcategory),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"二级分类","prop":"sec_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.sec_id),callback:function ($$v) {_vm.editForm.sec_id=$$v},expression:"editForm.sec_id"}},_vm._l((_vm.secondMenu),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品主图","prop":"pro_mainpic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.mainHandleSuccess,"on-error":_vm.mainHandleError,"before-upload":_vm.mainBeforeUpload,"data":_vm.uploadForm}},[(_vm.mainPicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.mainPicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品图片","prop":"pro_pic"}},[_c('el-upload',{attrs:{"multiple":"","action":"https://up.qbox.me","on-success":function (res, file, fileList) { return _vm.handleUploadSuccess(res, file, fileList, 'pro'); },"on-error":function (err, file, fileList) { return _vm.handleUploadError(err, file, fileList, 'pro'); },"on-remove":_vm.removePicPro,"before-upload":function (file) { return _vm.handleBeforeUpload(file, 'pro'); },"data":_vm.uploadForm,"file-list":_vm.fileListPro,"list-type":"picture","show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击多选上传")])],1),_vm._v(" "),(_vm.fileListPro.length > 0)?_c('div',{staticClass:"image-sort-container"},_vm._l((_vm.fileListPro),function(file,index){return _c('div',{key:index,staticClass:"image-sort-item"},[_c('img',{staticClass:"sort-img",attrs:{"src":file.url}}),_vm._v(" "),_c('div',{staticClass:"sort-btns"},[_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-left","disabled":index === 0},on:{"click":function($event){_vm.moveImage('pro', index, 'up')}}},[_vm._v("前移")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-right","disabled":index === _vm.fileListPro.length - 1},on:{"click":function($event){_vm.moveImage('pro', index, 'down')}}},[_vm._v("后移")]),_vm._v(" "),_c('el-button',{staticStyle:{"color":"#ff4949"},attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.deleteImage('pro', index)}}},[_vm._v("删除")])],1)])})):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品详情图片","prop":"prointro_pic"}},[_c('el-upload',{attrs:{"multiple":"","action":"https://up.qbox.me","on-success":function (res, file, fileList) { return _vm.handleUploadSuccess(res, file, fileList, 'intro'); },"on-error":function (err, file, fileList) { return _vm.handleUploadError(err, file, fileList, 'intro'); },"on-remove":_vm.removePicProintro,"before-upload":function (file) { return _vm.handleBeforeUpload(file, 'intro'); },"data":_vm.uploadForm,"file-list":_vm.fileListProintro,"list-type":"picture","show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击多选上传")])],1),_vm._v(" "),(_vm.fileListProintro.length > 0)?_c('div',{staticClass:"image-sort-container"},_vm._l((_vm.fileListProintro),function(file,index){return _c('div',{key:index,staticClass:"image-sort-item"},[_c('img',{staticClass:"sort-img",attrs:{"src":file.url}}),_vm._v(" "),_c('div',{staticClass:"sort-btns"},[_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-left","disabled":index === 0},on:{"click":function($event){_vm.moveImage('intro', index, 'up')}}},[_vm._v("前移")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-arrow-right","disabled":index === _vm.fileListProintro.length - 1},on:{"click":function($event){_vm.moveImage('intro', index, 'down')}}},[_vm._v("后移")]),_vm._v(" "),_c('el-button',{staticStyle:{"color":"#ff4949"},attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.deleteImage('intro', index)}}},[_vm._v("删除")])],1)])})):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品状态","prop":"pro_status"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.pro_status),callback:function ($$v) {_vm.editForm.pro_status=$$v},expression:"editForm.pro_status"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"推荐状态","prop":"recommend"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.recommend),callback:function ($$v) {_vm.editForm.recommend=$$v},expression:"editForm.recommend"}},_vm._l((_vm.recommendStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加入购物车","prop":"add_cart"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.add_cart),callback:function ($$v) {_vm.editForm.add_cart=$$v},expression:"editForm.add_cart"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"五件批发","prop":"five_pifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.five_pifa),callback:function ($$v) {_vm.editForm.five_pifa=$$v},expression:"editForm.five_pifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"一件代发","prop":"one_daifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.one_daifa),callback:function ($$v) {_vm.editForm.one_daifa=$$v},expression:"editForm.one_daifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否包邮","prop":"is_baoyou"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.is_baoyou),callback:function ($$v) {_vm.editForm.is_baoyou=$$v},expression:"editForm.is_baoyou"}})],1),_vm._v(" "),(_vm.editForm.is_baoyou === '0')?_c('el-form-item',{attrs:{"label":"快递模版","prop":"moban_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.moban_id),callback:function ($$v) {_vm.editForm.moban_id=$$v},expression:"editForm.moban_id"}},_vm._l((_vm.mobanArr),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属店铺","prop":"dianpu_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.dianpu_id),callback:function ($$v) {_vm.editForm.dianpu_id=$$v},expression:"editForm.dianpu_id"}},_vm._l((_vm.dianpuList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"仓库","prop":"is_oversea"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.is_oversea),callback:function ($$v) {_vm.editForm.is_oversea=$$v},expression:"editForm.is_oversea"}},_vm._l((_vm.overseaArr),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"UPC","prop":"upc"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.upc),callback:function ($$v) {_vm.editForm.upc=$$v},expression:"editForm.upc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"关联商品ID","prop":"referer_proid"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.referer_proid),callback:function ($$v) {_vm.editForm.referer_proid=$$v},expression:"editForm.referer_proid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"关联规格ID","prop":"referer_specid"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.referer_specid),callback:function ($$v) {_vm.editForm.referer_specid=$$v},expression:"editForm.referer_specid"}})],1),_vm._v(" "),_c('div',{staticClass:"spec_border"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"商品规格"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.prospecForm.spec_name),callback:function ($$v) {_vm.prospecForm.spec_name=$$v},expression:"prospecForm.spec_name"}},_vm._l((_vm.prospecArr),function(item){return _c('el-option',{key:item.label,attrs:{"label":item.label,"value":item.label,"size":"small"}})})),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必选,可新增不同规格 如 16kg 32kg  一包  两包")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"库存"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.inventory),callback:function ($$v) {_vm.prospecForm.inventory=$$v},expression:"prospecForm.inventory"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"市场价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.market_price),callback:function ($$v) {_vm.prospecForm.market_price=$$v},expression:"prospecForm.market_price"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"宠品价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.cpprice),callback:function ($$v) {_vm.prospecForm.cpprice=$$v},expression:"prospecForm.cpprice"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"成本价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.cost),callback:function ($$v) {_vm.prospecForm.cost=$$v},expression:"prospecForm.cost"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否默认"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.prospecForm.is_default),callback:function ($$v) {_vm.prospecForm.is_default=$$v},expression:"prospecForm.is_default"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("商品必选一个默认规格")])],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"padding":"5px 0 0 150px"},attrs:{"span":12}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.saveSpec}},[_vm._v("保存规格")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-table',{attrs:{"data":_vm.prospecTable}},[_c('el-table-column',{attrs:{"prop":"spec_name","label":"规格"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"market_price","label":"市场价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cpprice","label":"宠品价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cost","label":"成本价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inventory","label":"库存"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_default","label":"是否默认"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isDefault[scope.row.is_default]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","plain":true,"type":"danger"},on:{"click":function($event){_vm.deleteSpec(scope.row.id, scope.row.index)}}},[_vm._v("删除")])]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.remark),callback:function ($$v) {_vm.editForm.remark=$$v},expression:"editForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"更新存在的宝贝(主图、分类、之类)"},model:{value:(_vm.updateProVisible),callback:function ($$v) {_vm.updateProVisible=$$v},expression:"updateProVisible"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("当前宝贝编号:")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',[_vm._v(_vm._s(_vm.pro_id))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("复制宝贝编号:")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"rows":"3","placeholder":"复制已存在的宝贝ID"},model:{value:(_vm.copy_proid),callback:function ($$v) {_vm.copy_proid=$$v},expression:"copy_proid"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("是否复制标题")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.copy_title),callback:function ($$v) {_vm.copy_title=$$v},expression:"copy_title"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.updateProSubmit}},[_vm._v("确认")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"选择商品"},model:{value:(_vm.selectGoodsVisible),callback:function ($$v) {_vm.selectGoodsVisible=$$v},expression:"selectGoodsVisible"}},[_c('div',{staticClass:"select-goods"},[_c('el-tree',{staticClass:"goods-tree",attrs:{"highlight-current":"","data":_vm.goodsTypeData},on:{"node-click":_vm.handleNodeClick}}),_vm._v(" "),_c('div',{staticClass:"goods-data"},[(_vm.goodsData && _vm.goodsData.length > 0)?_c('el-checkbox-group',{model:{value:(_vm.selectGoodsData),callback:function ($$v) {_vm.selectGoodsData=$$v},expression:"selectGoodsData"}},_vm._l((_vm.goodsData),function(item){return _c('el-checkbox',{key:item.value,attrs:{"label":item.name+'-'+item.value}})})):_c('div',{staticClass:"no-goods"},[_vm._v("暂无数据")])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.selectGoodsSubmit}},[_vm._v("提交")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"管理商品规格","size":"large"},model:{value:(_vm.specListVisible),callback:function ($$v) {_vm.specListVisible=$$v},expression:"specListVisible"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.specListLoading),expression:"specListLoading"}],attrs:{"data":_vm.specTableData,"border":""}},[_c('el-table-column',{attrs:{"prop":"spec_name","label":"规格"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"market_price","label":"市场价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cpprice","label":"宠品价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cost","label":"成本价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inventory","label":"库存"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_default","label":"是否默认"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isDefault[scope.row.is_default]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.specEditHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"danger"},on:{"click":function($event){_vm.specDeleteHandler(scope.row.id)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.specListVisible = false; _vm.search()}}},[_vm._v("关闭")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑规格信息"},model:{value:(_vm.specEditFormVisible),callback:function ($$v) {_vm.specEditFormVisible=$$v},expression:"specEditFormVisible"}},[_c('el-form',{ref:"specEditForm",attrs:{"model":_vm.specEditForm,"label-width":"150px"}},[_c('el-form-item',{attrs:{"label":"商品规格","prop":"spec_name"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.specEditForm.spec_name),callback:function ($$v) {_vm.specEditForm.spec_name=$$v},expression:"specEditForm.spec_name"}},_vm._l((_vm.prospecArr),function(item){return _c('el-option',{key:item.label,attrs:{"label":item.label,"value":item.label,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"市场价","prop":"market_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.specEditForm.market_price),callback:function ($$v) {_vm.specEditForm.market_price=$$v},expression:"specEditForm.market_price"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"宠品价","prop":"cpprice"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.specEditForm.cpprice),callback:function ($$v) {_vm.specEditForm.cpprice=$$v},expression:"specEditForm.cpprice"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"成本价","prop":"cost"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.specEditForm.cost),callback:function ($$v) {_vm.specEditForm.cost=$$v},expression:"specEditForm.cost"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"库存","prop":"inventory"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.specEditForm.inventory),callback:function ($$v) {_vm.specEditForm.inventory=$$v},expression:"specEditForm.inventory"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否默认","prop":"is_default"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.specEditForm.is_default),callback:function ($$v) {_vm.specEditForm.is_default=$$v},expression:"specEditForm.is_default"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.specEditSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9gjt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9iOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.addFormVisible = true}}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""},on:{"selection-change":_vm.selsChange}},[_c('el-table-column',{attrs:{"label":"用户名","prop":"name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺名称","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"用户等级","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm.adminLevel[scope.row.level])+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"用户状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm.userStatus[scope.row.status])+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"修改时间","prop":"update_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.authHandler(scope.row.id)}}},[_vm._v("谷歌")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("恢复")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"二维码","size":"tiny"},model:{value:(_vm.qrcodeFormVisible),callback:function ($$v) {_vm.qrcodeFormVisible=$$v},expression:"qrcodeFormVisible"}},[_c('div',{staticStyle:{"text-align":"center"},attrs:{"id":"qrcode"}}),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.qrcodeFormVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.qrcodeFormVisible = false}}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"200px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"用户名","prop":"name"}},[_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.name),callback:function ($$v) {_vm.addForm.name=$$v},expression:"addForm.name"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"密码","prop":"pwd"}},[_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.pwd),callback:function ($$v) {_vm.addForm.pwd=$$v},expression:"addForm.pwd"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"等级","prop":"level"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.level),callback:function ($$v) {_vm.addForm.level=$$v},expression:"addForm.level"}},_vm._l((_vm.adminLevel),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属店铺","prop":"dianpu_id"}},[_c('el-select',{staticStyle:{"width":"30%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.dianpu_id),callback:function ($$v) {_vm.addForm.dianpu_id=$$v},expression:"addForm.dianpu_id"}},_vm._l((_vm.dianpuList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"200px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"用户名","prop":"name"}},[_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.name),callback:function ($$v) {_vm.editForm.name=$$v},expression:"editForm.name"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"密码","prop":"pwd"}},[_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.pwd),callback:function ($$v) {_vm.editForm.pwd=$$v},expression:"editForm.pwd"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"等级","prop":"level"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.level),callback:function ($$v) {_vm.editForm.level=$$v},expression:"editForm.level"}},_vm._l((_vm.adminLevel),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属店铺","prop":"dianpu_id"}},[_c('el-select',{staticStyle:{"width":"30%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.dianpu_id),callback:function ($$v) {_vm.editForm.dianpu_id=$$v},expression:"editForm.dianpu_id"}},_vm._l((_vm.dianpuList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "APnN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var qr = __webpack_require__("Vh0/");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      qrcodeFormVisible: false,
      addForm: {
        name: '',
        pwd: '',
        create_time: '',
        update_time: '',
        auth: '',
        coins: 0,
        level: '',
        status: 0,
        dianpu_id: 0
      },
      dianpuList: [],
      editFormVisible: false,
      editForm: {},
      formRules: {},
      visible2: false,
      adminLevel: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].adminLevel,
      userStatus: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].userStatus
    };
  },

  methods: {
    authHandler: function authHandler(id) {
      var _this = this;

      this.$confirm('谷歌验证码确定将重新生成(手机需要重新扫描)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.qrcodeFormVisible = true;
        _this.$axios.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/cpcadmin/qrcode/' + id).then(function (response) {
          console.log(response);
          var data = response.data;
          var qrcode = qr(data, {
            width: 250,
            height: 250
          });
          document.getElementById('qrcode').innerHTML = "";
          document.getElementById('qrcode').appendChild(qrcode);
        }).catch(function (error) {
          console.log(error);
          _this.$message({
            message: '请求异常，请联系管理员',
            type: 'warning'
          });
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this2 = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/cpcadmin/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this2.total = data.count;
          _this2.tableData = data.msg;
          _this2.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this3 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(_this3.addForm);
            para.level = parseInt(para.level);
            //异步请求
            _this3.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/cpcadmin', para).then(function (response) {
              if (response.data.state) {
                _this3.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this3.$refs['addForm'].resetFields();
                _this3.addFormVisible = false;
                _this3.search();
              } else {
                _this3.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this3.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this3.submitLoading = false;
          });
        }
      });
    },
    deleteHandler: function deleteHandler(row) {
      var _this4 = this;

      var text = '是否删除？';
      var status = 1;
      if (row.status == 1) {
        text = '是否恢复？';
        status = 0;
      }
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/cpcadmin/delete/' + row.id + '/' + status).then(function (response) {
          if (response.data.state) {
            _this4.$message({
              message: '操作成功',
              type: 'success'
            });
            _this4.search();
          } else {
            _this4.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this4.$message({
            message: '操作异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },


    //勾选删除数据
    removeData: function removeData() {
      var _this5 = this;

      if (this.selectRow.length > 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          if (_this5.selectRow.length == 1) {
            _this5.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/cpcadmin/delete/' + _this5.selectRow[0].id).then(function (response) {
              if (response.data.state) {
                _this5.$message({
                  message: '删除成功',
                  type: 'success'
                });
                _this5.search();
              } else {
                _this5.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this5.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          } else {
            var ids = '',
                para = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this5.selectRow), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var row = _step.value;

                ids += row.id + ',';
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            ids = ids.substring(0, ids.length - 1);
            _this5.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/cpcadmin/batch/delete/' + ids).then(function (response) {
              if (response.data.state) {
                _this5.$message({
                  message: '删除成功',
                  type: 'success'
                });
                _this5.search();
              } else {
                _this5.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this5.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }
        }).catch(function () {
          _this5.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      } else {
        this.$message({
          message: '请选择一条数据操作',
          type: 'warning'
        });
      }
    },

    //获取选中的数据
    selsChange: function selsChange(row) {
      this.selectRow = row;
    },
    getDianpuList: function getDianpuList() {
      var _this6 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/dianpu/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.msg), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              _this6.dianpuList.push({
                label: item.dianpu_name,
                value: item.id
              });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        } else {
          _this6.$message({
            message: '获取店铺失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$message({
          message: '获取店铺异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.editForm.level = row.level.toString();
    },
    editSubmit: function editSubmit() {
      var _this7 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this7.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this7.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(_this7.editForm);
            para.level = parseInt(para.level);
            //异步请求
            _this7.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/cpcadmin', para).then(function (response) {
              if (response.data.state) {
                _this7.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this7.$refs['editForm'].resetFields();
                _this7.editFormVisible = false;
                _this7.search();
              } else {
                _this7.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this7.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this7.submitLoading = false;
          });
        }
      });
    }
  },

  created: function created() {
    this.search();
    this.getDianpuList();
  }
});

/***/ }),

/***/ "B1xp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_config_basicdata_js__ = __webpack_require__("0iuG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_util_js__ = __webpack_require__("Tiwh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        fid: '',
        sec_name: '',
        pic: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      firstMenu: [],
      showUploadList: false,
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl: ''
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/secondmenu/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            para.pic = _this2.imageUrl;
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/secondmenu', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(row) {
      var _this3 = this;

      var text = '是否删除？';
      var status = 1;
      if (row.status == 1) {
        text = '是否恢复？';
        status = 0;
      }

      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/secondmenu/delete/' + row.sec_id + '/' + status).then(function (response) {
          if (response.data.state) {
            _this3.$message({
              message: '操作成功',
              type: 'success'
            });
            _this3.search();
          } else {
            _this3.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this3.$message({
            message: '删除异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.imageUrl = row.pic;
    },
    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this4.editForm);
            para.pic = _this4.imageUrl;
            //异步请求
            _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/secondmenu', para).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this4.$refs['editForm'].resetFields();
                _this4.editFormVisible = false;
                _this4.search();
              } else {
                _this4.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this4.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.addFormVisible = true;
      this.imageUrl = '';
    },
    getFirstMenu: function getFirstMenu() {
      var _this5 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/menu/tree').then(function (response) {
        var data = response.data;
        if (data && data.length > 0) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              _this5.firstMenu.push({
                label: item.fname,
                value: item.fid
              });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          _this5.$message({
            message: '获取一级分类失败',
            type: 'error'
          });
        }
      }).catch(function (error) {
        _this5.$message({
          message: '获取一级分类异常，请联系管理员',
          type: 'error'
        });
      });
    },
    beforeUpload: function beforeUpload(file) {
      var fileName = 'secmenu/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      fileName += '.' + mime;
      this.uploadForm.key = fileName;
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.imageUrl = __WEBPACK_IMPORTED_MODULE_4__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
      this.result = '上传成功';
    },
    handleError: function handleError(error, response, file) {
      this.result = error.toString();
    }
  },
  created: function created() {
    this.search();
    this.getFirstMenu();
  }
});

/***/ }),

/***/ "B9vy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"编号","prop":"category_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"首页分类","prop":"category_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("恢复")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"首页分类","prop":"category_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.category_name),callback:function ($$v) {_vm.addForm.category_name=$$v},expression:"addForm.category_name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"首页分类","prop":"category_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.category_name),callback:function ($$v) {_vm.editForm.category_name=$$v},expression:"editForm.category_name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BSDU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"row-key":_vm.getRowKeys,"expand-row-keys":_vm.expands},on:{"expand":_vm.expand}},[_c('el-table-column',{attrs:{"label":"用户ID","prop":"usid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"用户名称","prop":"username","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"文案内容","prop":"writecontent","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"链接","prop":"schemeurl","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"createtime","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"修改时间","prop":"updatetime","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"推荐状态","prop":"isrecommend","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.recommend[scope.row.isrecommend]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"审核状态","prop":"isverify","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.verify[scope.row.isverify]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"记录状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.status[scope.row.status]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"event_unique_key","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isverify != 0)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.setVerify(scope.row._id)}}},[_vm._v("审核")]):_vm._e(),_vm._v(" "),(scope.row.isrecommend == 0)?_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){_vm.setRecommend(scope.row._id, 1)}}},[_vm._v("推荐")]):_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.setRecommend(scope.row._id, 0)}}},[_vm._v("取消推荐")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.showEditForm(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),(scope.row.pic)?_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.getPicUrl(scope.row)}}},[_vm._v("查看图片")]):_vm._e(),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.deleteData(scope.row._id)}}},[_vm._v("删除记录")]):_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.recoveryData(scope.row._id)}}},[_vm._v("恢复记录")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"查看图片"},model:{value:(_vm.picVisible),callback:function ($$v) {_vm.picVisible=$$v},expression:"picVisible"}},[_c('div',{staticClass:"piclist"},_vm._l((_vm.picList),function(pic,index){return _c('a',{key:index,attrs:{"target":"_blank","href":pic}},[_c('img',{attrs:{"src":pic}})])}))]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"100px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"链接","prop":"schemeurl"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small"},model:{value:(_vm.editForm.schemeurl),callback:function ($$v) {_vm.editForm.schemeurl=$$v},expression:"editForm.schemeurl"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Blo5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tixian_vue__ = __webpack_require__("dgBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7879e6b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tixian_vue__ = __webpack_require__("uqi2");
function injectStyle (ssrContext) {
  __webpack_require__("+QYB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7879e6b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tixian_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7879e6b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_tixian_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bnsx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bzfq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        fname: '',
        pic: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      showUploadList: false,
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl: ''
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/brand/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            para.pic = _this2.imageUrl;
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/brand', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(row) {
      var _this3 = this;

      var text = '是否删除？';
      var status = 1;
      if (row.status == 1) {
        text = '是否恢复？';
        status = 0;
      }

      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/brand/delete/' + row.brand_id + '/' + status).then(function (response) {
          if (response.data.state) {
            _this3.$message({
              message: '操作成功',
              type: 'success'
            });
            _this3.search();
          } else {
            _this3.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this3.$message({
            message: '删除异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //操作删除
    monitorHandler: function monitorHandler(row) {
      var _this4 = this;

      var text = '是否加入监控？';
      var status = 1;
      if (row.status == 1) {
        text = '是否取消监控？';
        status = 0;
      }

      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/brand/monitor/' + row.brand_id + '/' + status).then(function (response) {
          if (response.data.state) {
            _this4.$message({
              message: '操作成功',
              type: 'success'
            });
            _this4.search();
          } else {
            _this4.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this4.$message({
            message: '异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.imageUrl = row.pic;
    },
    editSubmit: function editSubmit() {
      var _this5 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this5.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this5.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this5.editForm);
            para.pic = _this5.imageUrl;
            //异步请求
            _this5.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/brand', para).then(function (response) {
              if (response.data.state) {
                _this5.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this5.$refs['editForm'].resetFields();
                _this5.editFormVisible = false;
                _this5.search();
              } else {
                _this5.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this5.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this5.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.addFormVisible = true;
      this.imageUrl = '';
    },
    beforeUpload: function beforeUpload(file) {
      var fileName = 'brand/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      fileName += '.' + mime;
      this.uploadForm.key = fileName;
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.imageUrl = __WEBPACK_IMPORTED_MODULE_4__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
      this.result = '上传成功';
    },
    handleError: function handleError(error, response, file) {
      this.result = error.toString();
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "CL04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.addFormVisible = true}}},[_vm._v("新增")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.removeData}},[_vm._v("删除")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""},on:{"selection-change":_vm.selsChange}},[_c('el-table-column',{attrs:{"label":"编号","prop":"fid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分类名","prop":"fname","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row.fid)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"分类名称","prop":"fname"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.fname),callback:function ($$v) {_vm.addForm.fname=$$v},expression:"addForm.fname"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"分类名称","prop":"fname"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.fname),callback:function ($$v) {_vm.editForm.fname=$$v},expression:"editForm.fname"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D6r2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      logining: false,
      loginModel: {
        username: '',
        password: '',
        verification: ''
      },
      rules2: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    loginSubmit: function loginSubmit(ev) {
      var _this = this;

      this.$refs.loginModel.validate(function (valid) {
        if (valid) {
          _this.logining = true;
          __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
          var loginParams = { name: _this.loginModel.username, pwd: _this.loginModel.password, auth: _this.loginModel.verification };
          _this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/login', loginParams).then(function (response) {
            _this.logining = false;
            __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
            if (response.data.state) {
              var token = response.data.msg;
              _this.$cookie.set('token_admin', token, { expires: '8755h' });
              _this.$router.push({ path: '/' });
              _this.$router.push("/");
            } else {
              _this.$message({
                message: '登录失败，' + response.data.msg,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            _this.logining = false;
            console.log(error);
            _this.$message({
              message: '登录异常，请联系管理员',
              type: 'warning'
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ "EOco":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_date_js__ = __webpack_require__("bAtJ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 导入echarts





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      orderCount: 0,
      orderSum: 0,
      profitSum: 0,
      profitSumMonth: 0,
      profitSumGongChuangMonth: 0,
      orderSumGongChuangMonth: 0,
      proCount: 0,
      userZongCount: 0,
      userCount: 0,
      danhaoCount: 0,
      tuihuoCount: 0,
      kucunCount: 0,
      orderEchart: null,
      orderSumEchart: null,
      orderGongChuangEchart: null,
      orderGongChuangSumEchart: null,
      userEchart: null,
      orderProfitEchart: null,
      time: '',
      startTime: '',
      endTime: '',
      orderCountMonth: 0,
      orderSumMonth: 0
    };
  },

  methods: {
    //获取订单数量
    getOrderCount: function getOrderCount() {
      var _this = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/count/' + this.time).then(function (response) {
        _this.orderCount = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取订单数量异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单趋势
    getOrderEchart: function getOrderEchart() {
      var _this2 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/echart/' + this.startTime + '/' + this.endTime).then(function (response) {
        var data = response.data.msg,
            timeArr = [],
            dataArr = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            timeArr.push(item.time);
            dataArr.push(item.count);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this2.setOrderEchart(timeArr, dataArr);
      }).catch(function (error) {
        console.log(error);
        _this2.$message({
          message: '获取订单数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单趋势
    getOrderGongChuangEchart: function getOrderGongChuangEchart() {
      var _this3 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/ordergongchuang/echart/' + this.startTime + '/' + this.endTime).then(function (response) {
        var data = response.data.msg,
            timeArr = [],
            dataArr = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            timeArr.push(item.time);
            dataArr.push(item.count);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this3.setOrderGongChuangEchart(timeArr, dataArr);
      }).catch(function (error) {
        console.log(error);
        _this3.$message({
          message: '获取订单数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单数量
    getOrderMonthCount: function getOrderMonthCount() {
      var _this4 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/countmonth').then(function (response) {
        _this4.orderCountMonth = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this4.$message({
          message: '获取订单数量异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单利润
    getProfitSumMonth: function getProfitSumMonth() {
      var _this5 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/profitmonth').then(function (response) {
        _this5.profitSumMonth = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          message: '获取订单金额异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单金额
    getOrderMonthSum: function getOrderMonthSum() {
      var _this6 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/summonth').then(function (response) {
        _this6.orderSumMonth = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this6.$message({
          message: '获取订单金额异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取共创订单利润
    getProfitSumGongChuangMonth: function getProfitSumGongChuangMonth() {
      var _this7 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/profitgongchuangmonth').then(function (response) {
        _this7.profitSumGongChuangMonth = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this7.$message({
          message: '获取共创订单金额异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取共创订单金额
    getOrderSumGongChuangMonth: function getOrderSumGongChuangMonth() {
      var _this8 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/sumgongchuanmonth').then(function (response) {
        _this8.orderSumGongChuangMonth = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this8.$message({
          message: '获取共创订单金额异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取共创订单金额
    getProCount: function getProCount() {
      var _this9 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/procount').then(function (response) {
        _this9.proCount = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this9.$message({
          message: '获取总商品异常，请联系管理员',
          type: 'error'
        });
      });
    },


    //获取共创订单金额
    getuserZongCount: function getuserZongCount() {
      var _this10 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/userzongcount').then(function (response) {
        _this10.userZongCount = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this10.$message({
          message: '获取总分销异常，请联系管理员',
          type: 'error'
        });
      });
    },
    setOrderEchart: function setOrderEchart(timeArr, dataArr) {
      this.orderEchart.setOption({
        title: {
          text: '订单趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        color: ["#00BFFF", "#FF00FF", "#1ce322", "#000000", '#EE7942'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeArr
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: {
          name: '订单趋势',
          type: 'line',
          lineStyle: {
            normal: {
              width: 2
            }
          },
          data: dataArr
        }
      });
    },
    setOrderGongChuangEchart: function setOrderGongChuangEchart(timeArr, dataArr) {
      this.orderGongChuangEchart.setOption({
        title: {
          text: '共创订单',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        color: ["#00BFFF", "#FF00FF", "#1ce322", "#000000", '#EE7942'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeArr
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: {
          name: '共创订单',
          type: 'line',
          lineStyle: {
            normal: {
              width: 2
            }
          },
          data: dataArr
        }
      });
    },

    //获取订单金额
    getOrderSum: function getOrderSum() {
      var _this11 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/sum/' + this.time).then(function (response) {
        _this11.orderSum = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this11.$message({
          message: '获取订单金额异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单利润
    getOrderProfitSum: function getOrderProfitSum() {
      var _this12 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/profit/' + this.time).then(function (response) {
        _this12.profitSum = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this12.$message({
          message: '获取订单金额异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单金额趋势
    getOrderSumEchart: function getOrderSumEchart() {
      var _this13 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/sum/echart/' + this.startTime + '/' + this.endTime).then(function (response) {
        var data = response.data.msg,
            timeArr = [],
            dataArr = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            timeArr.push(item.time);
            dataArr.push(item.sum);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        _this13.setOrderSumEchart(timeArr, dataArr);
      }).catch(function (error) {
        console.log(error);
        _this13.$message({
          message: '获取订单数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单金额趋势
    getOrderGongChuangSumEchart: function getOrderGongChuangSumEchart() {
      var _this14 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/gongchuangsum/echart/' + this.startTime + '/' + this.endTime).then(function (response) {
        var data = response.data.msg,
            timeArr = [],
            dataArr = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            timeArr.push(item.time);
            dataArr.push(item.sum);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this14.setOrderGongChuangSumEchart(timeArr, dataArr);
      }).catch(function (error) {
        console.log(error);
        _this14.$message({
          message: '获取订单数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    setOrderSumEchart: function setOrderSumEchart(timeArr, dataArr) {
      this.orderSumEchart.setOption({
        title: {
          text: '订单金额趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        color: ["#FF00FF", "#1ce322", "#000000", '#EE7942'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeArr
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: {
          name: '订单金额趋势',
          type: 'line',
          lineStyle: {
            normal: {
              width: 2
            }
          },
          data: dataArr
        }
      });
    },
    setOrderGongChuangSumEchart: function setOrderGongChuangSumEchart(timeArr, dataArr) {
      this.orderGongChuangSumEchart.setOption({
        title: {
          text: '共创订单金额',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        color: ["#FF00FF", "#1ce322", "#000000", '#EE7942'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeArr
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: {
          name: '共创订单金额',
          type: 'line',
          lineStyle: {
            normal: {
              width: 2
            }
          },
          data: dataArr
        }
      });
    },


    //获取批发商数量
    getUserCount: function getUserCount() {
      var _this15 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/userinfo/count/' + this.time).then(function (response) {
        _this15.userCount = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this15.$message({
          message: '获取批发商数量异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取单号数量
    getDanhaoCount: function getDanhaoCount() {
      var _this16 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/danhaocount').then(function (response) {
        _this16.danhaoCount = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this16.$message({
          message: '获取单号数量异常，请联系管理员',
          type: 'error'
        });
      });
    },


    //获取库存告急
    getkuncunCount: function getkuncunCount() {
      var _this17 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/product/kucun').then(function (response) {
        _this17.kucunCount = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this17.$message({
          message: '获取用户数量异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单趋势
    getUserEchart: function getUserEchart() {
      var _this18 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/userinfo/echart/' + this.startTime + '/' + this.endTime).then(function (response) {
        var data = response.data.msg,
            timeArr = [],
            dataArr = [];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var item = _step5.value;

            timeArr.push(item.time);
            dataArr.push(item.count);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        _this18.setUserEchart(timeArr, dataArr);
      }).catch(function (error) {
        console.log(error);
        _this18.$message({
          message: '获取批发商数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    setUserEchart: function setUserEchart(timeArr, dataArr) {
      this.userEchart.setOption({
        title: {
          text: '新增分销趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        color: ["#1ce322", "#000000", '#EE7942'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeArr
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: {
          name: '新增批发商趋势',
          type: 'line',
          lineStyle: {
            normal: {
              width: 2
            }
          },
          data: dataArr
        }
      });
    },

    // 获取利润图表
    getOrderProfitEchart: function getOrderProfitEchart() {
      var _this19 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/profit/echart/' + this.startTime + '/' + this.endTime).then(function (response) {
        var data = response.data.msg,
            timeArr = [],
            dataArr = [];
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var item = _step6.value;

            timeArr.push(item.time);
            dataArr.push(item.sum);
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        _this19.setOrderProfitEchart(timeArr, dataArr);
      }).catch(function (error) {
        console.log(error);
        _this19.$message({
          message: '获取利润数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    setOrderProfitEchart: function setOrderProfitEchart(timeArr, dataArr) {
      this.orderProfitEchart.setOption({
        title: {
          text: '订单利润趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        color: ['#EE7942'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeArr
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: {
          name: '订单利润趋势',
          type: 'line',
          lineStyle: {
            normal: {
              width: 2
            }
          },
          data: dataArr
        }
      });
    },

    // 截取当前数据到小数点后两位
    numFilter: function numFilter(value) {
      var realVal = parseFloat(value).toFixed(1);
      return realVal;
    },

    // 获取供应商图表
    // getCpcAdminEchart() {
    //   this.$axios.get(config.api_url + '/cpcadmin/echart/'+this.startTime+'/'+this.endTime
    //   ).then(response => {
    //     let data = response.data.msg,
    //       timeArr = [],
    //       dataArr = [];
    //     for(const item of data) {
    //       timeArr.push(item.time);
    //       dataArr.push(item.count);
    //     }
    //     this.setCpcadminEchart(timeArr, dataArr);
    //   }).catch(error => {
    //     console.log(error);
    //     this.$message({
    //       message: '获取供应商数据异常，请联系管理员',
    //       type: 'error'
    //     });
    //   });
    // },
    // setCpcadminEchart(timeArr, dataArr) {
    //   this.cpcAdminEchart.setOption({
    //     title: {
    //       text: '新增供应商趋势',
    //       left: 'center'
    //     },
    //     tooltip: {
    //       trigger: 'axis'
    //     },
    //     color: ['#EE7942'],
    //     xAxis: {
    //       type: 'category',
    //       boundaryGap: false,
    //       data: timeArr
    //     },
    //     yAxis: [{
    //       type: 'value',
    //       axisLabel: {
    //         formatter: '{value}'
    //       }
    //     }],
    //     series: {
    //       name: '新增供应商趋势',
    //       type: 'line',
    //       lineStyle: {
    //         normal: {
    //           width: 2,
    //         }
    //       },
    //       data: dataArr
    //     }
    //   })
    // },

    //获取退货退款数量
    getTuihuoCount: function getTuihuoCount() {
      var _this20 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url + '/order/tuihuo/count/' + this.time).then(function (response) {
        _this20.tuihuoCount = response.data.count;
      }).catch(function (error) {
        console.log(error);
        _this20.$message({
          message: '获取退货订单数量异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },
  towNumber: function towNumber(val) {
    return val.toFixed(2);
  },

  // keypoint：执行方法
  // “将回调延迟到下次 DOM 更新循环之后执行。在修改数据之后立即使用它，然后等待 DOM 更新。”
  mounted: function mounted() {
    this.time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), "yyyy-MM-dd");
    var myDate = new Date();
    myDate.setDate(myDate.getDate() - 365);
    this.startTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(myDate, "yyyy-MM-dd");
    this.endTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), "yyyy-MM-dd");
    //初始化图表
    this.orderEchart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById('order'));
    this.orderSumEchart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById('orderSum'));
    this.orderGongChuangEchart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById('gongChuangOrder'));
    this.orderGongChuangSumEchart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById('gongChuangOrderSum'));
    this.userEchart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById('user'));
    //this.cpcAdminEchart = echarts.init(document.getElementById('cpcadmin'));
    this.orderProfitEchart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById('profitSum'));
    this.getOrderCount();
    this.getDanhaoCount();
    this.getOrderEchart();
    this.getOrderGongChuangEchart();
    this.getOrderGongChuangSumEchart();

    this.getOrderSum();
    this.getOrderSumEchart();

    this.getUserCount();
    this.getUserEchart();
    //this.getCpcAdminEchart();
    this.getOrderProfitEchart();
    this.getkuncunCount();

    this.getOrderMonthCount();
    this.getOrderMonthSum();
    //this.getTuihuoCount();

    this.getOrderProfitSum();
    this.getProfitSumMonth();

    this.getOrderSumGongChuangMonth();
    this.getProfitSumGongChuangMonth();
    this.getProCount();
    this.getuserZongCount();

    var that = this;
    this.$nextTick(function () {
      //图表兼容处理
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).resize(function () {
        window.onresize = that.orderEchart.resize();
        window.onresize = that.orderSumEchart.resize();
        window.onresize = that.orderGongChuangEchart.resize();
        window.onresize = that.orderGongChuangSumEchart.resize();
        window.onresize = that.userEchart.resize();
        window.onresize = that.orderProfitEchart.resize();
      });
    });
  }
});

/***/ }),

/***/ "EZUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",staticStyle:{"padding-bottom":"0px","margin-bottom":"15px"},attrs:{"span":24}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showBatchWuliu}},[_vm._v("批量修改物流")])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"row-key":_vm.getRowKeys,"expand-row-keys":_vm.expands},on:{"expand":_vm.expand}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"商品列表","name":"1"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-table',{attrs:{"data":_vm.tableDataProduct,"border":""}},[_c('el-table-column',{attrs:{"label":"名称","prop":"pro_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"价格","prop":"price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"规格","prop":"spec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"数量","prop":"pronum","align":"center"}})],1)],1)]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"物流状态","name":"2"}},[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.wuliuAction),callback:function ($$v) {_vm.wuliuAction=$$v},expression:"wuliuAction"}},_vm._l((_vm.wuliuStatusTabs),function(item,index){return _c('el-tab-pane',{key:index,staticStyle:{"text-align":"center"},attrs:{"label":item,"name":item}},[(_vm.wuliuInfos && _vm.wuliuInfos.length > 0)?_c('div',{staticStyle:{"text-align":"left"}},[_vm._v("物流信息："),_vm._l((_vm.wuliuInfos),function(item,index){return _c('p',{key:index},[_vm._v(_vm._s(item.context)+"  "+_vm._s(item.time))])})],2):_vm._e()])}))],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"订单编号","prop":"order_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"子订单编号","prop":"suborder_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流单位","prop":"wuliu_company","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流编号","prop":"wuliu_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.showWuliu(scope.row)}}},[_vm._v("修改物流")])]}}])})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改物流"},model:{value:(_vm.wuliuVisbile),callback:function ($$v) {_vm.wuliuVisbile=$$v},expression:"wuliuVisbile"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-select',{attrs:{"placeholder":"选择物流单位"},model:{value:(_vm.wuliuCom),callback:function ($$v) {_vm.wuliuCom=$$v},expression:"wuliuCom"}},_vm._l((_vm.wuliuCompany),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item,"size":"small"}})}))],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"15px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-input',{attrs:{"placeholder":"物流编号"},model:{value:(_vm.wuliuNum),callback:function ($$v) {_vm.wuliuNum=$$v},expression:"wuliuNum"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量发货 / 修改物流","width":"60%"},model:{value:(_vm.batchWuliuVisible),callback:function ($$v) {_vm.batchWuliuVisible=$$v},expression:"batchWuliuVisible"}},[_c('el-row',{staticStyle:{"margin-bottom":"15px"}},[_c('el-col',{attrs:{"span":24}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("统一物流单位：")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"选择物流单位（对以下所有订单生效）"},model:{value:(_vm.batchWuliuCom),callback:function ($$v) {_vm.batchWuliuCom=$$v},expression:"batchWuliuCom"}},_vm._l((_vm.wuliuCompany),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item,"size":"small"}})}))],1)],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.batchTableData,"border":"","max-height":"400"}},[_c('el-table-column',{attrs:{"label":"子订单编号","prop":"suborder_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"当前物流状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.wuliu_num)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("已发货")]):_c('el-tag',{attrs:{"type":"info"}},[_vm._v("未发货")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流单号","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"placeholder":"请输入物流单号","clearable":""},model:{value:(scope.row.new_wuliu_num),callback:function ($$v) {scope.row.new_wuliu_num=$$v},expression:"scope.row.new_wuliu_num"}})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{nativeOn:{"click":function($event){_vm.batchWuliuVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.batchSubmitLoading},nativeOn:{"click":function($event){_vm.batchEditSubmit($event)}}},[_vm._v("批量提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F+31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      updateProVisible: false,
      addForm: {
        title: '',
        pic: '',
        create_time: '',
        status: '0'
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      shanchustatus: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].status,
      imageUrl: '',
      imageName: '',
      proPic: [],
      fileListPro: []
    };
  },

  methods: {
    // 统一处理上传前逻辑：生成本地预览占位，严格保证顺序
    handleBeforeUpload: function handleBeforeUpload(file) {
      var imageName = 'zhuanti/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      if (mime) {
        imageName += '.' + mime;
      }
      this.uploadForm.key = imageName;
      var qiniuUrl = __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].picUrl + imageName;

      // 生成本地预览地址，提升交互体验
      var localPreviewUrl = URL.createObjectURL(file);

      this.proPic.push(qiniuUrl); // 存放最终提给后端的 URL
      this.fileListPro.push({
        name: imageName,
        url: localPreviewUrl,
        uid: file.uid
      });
      return true;
    },


    // 统一处理上传成功逻辑：将本地预览替换为七牛云远程链接
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      var targetFile = this.fileListPro.find(function (item) {
        return item.uid === file.uid;
      });
      if (targetFile) {
        targetFile.url = __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].picUrl + response.key;
      }
    },


    // 统一处理上传失败逻辑：移除未上传成功的项
    handleUploadError: function handleUploadError(error, file, fileList) {
      console.log(error);
      this.$message.error('图片上传异常，请联系管理员');
      this.fileListPro = this.fileListPro.filter(function (item) {
        return item.uid !== file.uid;
      });
      this.proPic = this.fileListPro.map(function (item) {
        return item.url;
      });
    },


    // 动态调整图片顺序方法
    moveImage: function moveImage(index, direction) {
      var targetIndex = direction === 'up' ? index - 1 : index + 1;

      // 1. 交换前端显示的 fileList 元素位置
      var tempFile = this.fileListPro[index];
      this.$set(this.fileListPro, index, this.fileListPro[targetIndex]);
      this.$set(this.fileListPro, targetIndex, tempFile);

      // 2. 交换实际提交给后端的 proPic 数组里的图片 URL 顺序
      var tempPic = this.proPic[index];
      this.$set(this.proPic, index, this.proPic[targetIndex]);
      this.$set(this.proPic, targetIndex, tempPic);
    },


    // 手动删除图片
    deleteImage: function deleteImage(index) {
      this.fileListPro.splice(index, 1);
      this.proPic.splice(index, 1);
    },


    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getList(this.query);
    },

    //获取专题列表
    getList: function getList(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/zhuanti/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
        _this.listLoading = false;
      });
    },


    //新增数据提交
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm));
            para.pic = _this2.proPic.toString();
            para.status = parseInt(para.status);

            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/zhuanti', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.fileListPro = [];
                _this2.proPic = [];
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },


    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row);
      this.editForm.status = row.status.toString();

      if (row.pic) {
        this.proPic = row.pic.split(',').filter(function (item) {
          return item !== '';
        });
      } else {
        this.proPic = [];
      }

      var that = this;
      this.fileListPro = [];
      this.proPic.forEach(function (item, i) {
        that.fileListPro.push({
          name: item.replace(__WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].picUrl, ''),
          url: item
        });
      });
    },


    //修改提交
    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.editForm));
            para.pic = _this3.proPic.toString();
            para.status = parseInt(para.status);

            _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/zhuanti', para).then(function (response) {
              if (response.data.state) {
                _this3.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this3.$refs['editForm'].resetFields();
                _this3.fileListPro = [];
                _this3.proPic = [];
                _this3.editFormVisible = false;
                _this3.search();
              } else {
                _this3.$message({
                  message: '提交失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this3.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this3.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.addFormVisible = true;
      this.proPic = [];
      this.fileListPro = [];
    }
  },

  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "F+7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      anjianStatus: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].anjianStatus,
      tongyongStatus: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].tongyongStatus,
      addForm: {
        name: '',
        wuliu_company: '',
        an_jian: 0,
        is_currency: 1,
        currency_price: 0,
        admin_id: 0,
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      an_jian: '1',
      is_currency: '0'
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/kuaidi/moban/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            para.an_jian = parseInt(_this2.an_jian);
            para.is_currency = parseInt(_this2.is_currency);
            para.currency_price = parseInt(para.currency_price);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/kuaidi/moban', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(id) {
      var _this3 = this;

      if (id != 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/kuaidi/moban/' + id).then(function (response) {
            if (response.data.state) {
              _this3.$message({
                message: '删除成功',
                type: 'success'
              });
              _this3.search();
            } else {
              _this3.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(function (error) {
            _this3.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(function () {
          _this3.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.is_currency = row.is_currency.toString();
      this.an_jian = row.an_jian.toString();
    },
    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.editForm);
            para.is_currency = parseInt(_this4.is_currency);
            para.an_jian = parseInt(_this4.an_jian);
            para.currency_price = parseInt(para.currency_price);
            //异步请求
            _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/kuaidi/moban', para).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this4.$refs['editForm'].resetFields();
                _this4.editFormVisible = false;
                _this4.search();
              } else {
                _this4.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this4.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.addFormVisible = true;
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "FYJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JamP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f2665c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("HmDi");
function injectStyle (ssrContext) {
  __webpack_require__("6d14")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30f2665c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f2665c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fa1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__ = __webpack_require__("0iuG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_date_js__ = __webpack_require__("bAtJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      listLoading: false,
      query: '',
      beginTime: '',
      profitSum: '',
      userLevel: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].userLevel,
      endTime: ''
    };
  },

  methods: {
    search: function search() {
      this.getMovingPinList(this.query);
    },
    showOrder: function showOrder(usid, orderNum) {
      this.$router.push('/order/list/' + usid + '/' + orderNum);
    },
    export2Excel: function export2Excel() {
      var _this = this;

      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/order/distristatics';
      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + this.query;
      this.$axios.post(url, {
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          if (data.msg) {
            console.log(response.data.msg);
            __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
              var _require = __webpack_require__("zKXg"),
                  export_json_to_excel = _require.export_json_to_excel;

              var tHeader = ['分销编号', '店铺段位', '店铺名称', '平均价格', '订单数量', '销售额', '产出额', '利润率', '店铺备注']; //对应表格输出的title
              var filterVal = ['usid', 'level_str', 'dianpu_name', 'avg_price', 'num', 'sum_price', 'sum_profit', 'profit_margin', 'remark']; // 对应表格输出的数据
              var list = response.data.msg;
              var data = _this.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '分销罗盘_' + '_' + _this.query + '_' + '开始时间_' + _this.beginTime + '_' + '结束时间_' + _this.endTime + '_' + '导出时间_' + new Date().toLocaleString()); //对应下载文件的名字
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          } else {
            _this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        } else {
          _this.$message({
            message: '无数据，请联系管理员！',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '导出异常，请联系管理员！',
          type: 'error'
        });
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    getMovingPinList: function getMovingPinList(query) {
      var _this2 = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/order/distristatics';

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + query;
      this.$axios.post(url, {
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this2.tableData = data.msg;
          _this2.profitSum = data.count;
          _this2.listLoading = false;
        }
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "Fzhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_secmenu_vue__ = __webpack_require__("B1xp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd6a3ce0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_secmenu_vue__ = __webpack_require__("S5K5");
function injectStyle (ssrContext) {
  __webpack_require__("bG0k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd6a3ce0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_secmenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd6a3ce0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_secmenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G2MP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adver_vue__ = __webpack_require__("ac73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c08a88c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_adver_vue__ = __webpack_require__("veHb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c08a88c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_adver_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G81h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GCxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":20}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.beginTime),callback:function ($$v) {_vm.beginTime=$$v},expression:"beginTime"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}}),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":"店铺编号","size":"small"},model:{value:(_vm.shopusid),callback:function ($$v) {_vm.shopusid=$$v},expression:"shopusid"}})],1),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"是否删除","size":"small"},model:{value:(_vm.selectRecordStatus),callback:function ($$v) {_vm.selectRecordStatus=$$v},expression:"selectRecordStatus"}},[_c('el-option',{key:"0",attrs:{"label":"全部","value":"200"}}),_vm._v(" "),_vm._l((_vm.recordStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.search}},[_vm._v("查询")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":"商品名称","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"店铺编号","prop":"usid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺名称","prop":"dianpu_name","align":"center","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品编号","prop":"pro_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品名称","prop":"pro_name","align":"center","min-width":"500"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"规格","prop":"spec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"数量","prop":"count","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"收藏价格","prop":"col_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"当前价格","prop":"price","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.price > scope.row.col_price)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.price))]):_vm._e(),_vm._v(" "),(scope.row.price == scope.row.col_price)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.price))]):_vm._e(),_vm._v(" "),(scope.row.price < scope.row.col_price)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.price))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"修改时间","prop":"update_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"记录状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 0)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("正常")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v("删除")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GLF8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_advertype_vue__ = __webpack_require__("YRiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7620854_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_advertype_vue__ = __webpack_require__("Ormy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_advertype_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7620854_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_advertype_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gw3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_distristatics_vue__ = __webpack_require__("Fa1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba2579c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_distristatics_vue__ = __webpack_require__("0qLg");
function injectStyle (ssrContext) {
  __webpack_require__("WJMg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_distristatics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba2579c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_distristatics_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HmDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"编号","prop":"id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"标题","prop":"title","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"采购时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"采购内容","prop":"content","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"备注","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("恢复")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"标题","prop":"title"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.title),callback:function ($$v) {_vm.addForm.title=$$v},expression:"addForm.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择创建时间","size":"small","format":"yyyy-MM-dd"},model:{value:(_vm.addForm.create_time),callback:function ($$v) {_vm.addForm.create_time=$$v},expression:"addForm.create_time"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内容"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.addForm.content),callback:function ($$v) {_vm.addForm.content=$$v},expression:"addForm.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.addForm.remark),callback:function ($$v) {_vm.addForm.remark=$$v},expression:"addForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"标题","prop":"title"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.title),callback:function ($$v) {_vm.editForm.title=$$v},expression:"editForm.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择创建时间","size":"small","format":"yyyy-MM-dd"},model:{value:(_vm.editForm.create_time),callback:function ($$v) {_vm.editForm.create_time=$$v},expression:"editForm.create_time"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内容"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.editForm.content),callback:function ($$v) {_vm.editForm.content=$$v},expression:"editForm.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.editForm.remark),callback:function ($$v) {_vm.editForm.remark=$$v},expression:"editForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hqt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":20}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.beginTime),callback:function ($$v) {_vm.beginTime=$$v},expression:"beginTime"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}}),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":"店铺编号","size":"small"},model:{value:(_vm.shopusid),callback:function ($$v) {_vm.shopusid=$$v},expression:"shopusid"}})],1),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"是否删除","size":"small"},model:{value:(_vm.selectRecordStatus),callback:function ($$v) {_vm.selectRecordStatus=$$v},expression:"selectRecordStatus"}},[_c('el-option',{key:"0",attrs:{"label":"全部","value":"200"}}),_vm._v(" "),_vm._l((_vm.recordStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.search}},[_vm._v("查询")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":"商品名称","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"店铺编号","prop":"usid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺名称","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品编号","prop":"pro_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品名称","prop":"pro_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"规格","prop":"spec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"收藏价格","prop":"col_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"当前价格","prop":"price","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.price > scope.row.col_price)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.price))]):_vm._e(),_vm._v(" "),(scope.row.price == scope.row.col_price)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.price))]):_vm._e(),_vm._v(" "),(scope.row.price < scope.row.col_price)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.price))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"修改时间","prop":"update_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"记录状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 0)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("正常")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v("删除")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I94A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__ = __webpack_require__("0iuG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_date_js__ = __webpack_require__("bAtJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      listLoading: false,
      query: '',
      beginTime: '',
      profitSum: '',
      userLevel: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].userLevel,
      endTime: ''
    };
  },

  methods: {
    search: function search() {
      this.getMovingPinList(this.query);
    },
    showOrder: function showOrder(usid, orderNum) {
      this.$router.push('/order/list/' + usid + '/' + orderNum);
    },
    export2Excel: function export2Excel() {
      var _this = this;

      this.search();
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/order/partnerbrand';
      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + this.query;
      this.$axios.post(url, {
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          if (data.msg) {
            console.log(response.data.msg);
            __webpack_require__.e/* require.ensure */(0).then((function () {
              var _require = __webpack_require__("zKXg"),
                  export_json_to_excel = _require.export_json_to_excel;

              var tHeader = ['分销编号', '店铺段位', '店铺名称', '平均价格', '订单数量', '销售额', '产出额', '利润率', '店铺备注']; //对应表格输出的title
              var filterVal = ['usid', 'level_str', 'dianpu_name', 'avg_price', 'num', 'sum_price', 'sum_profit', 'profit_margin', 'remark']; //对应表格输出的数据
              var list = response.data.msg;
              var data = _this.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '品牌合伙_' + '_' + _this.query + '_' + '开始时间_' + _this.beginTime + '_' + '结束时间_' + _this.endTime + '_' + '导出时间_' + new Date().toLocaleString()); //对应下载文件的名字
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          } else {
            _this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        } else {
          _this.$message({
            message: '无数据，请联系管理员！',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '导出异常，请联系管理员！',
          type: 'error'
        });
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    getMovingPinList: function getMovingPinList(query) {
      var _this2 = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/order/partnerbrand';

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + query;
      this.$axios.post(url, {
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this2.tableData = data.msg;
          _this2.profitSum = data.count;
          _this2.listLoading = false;
        }
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "INGJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IQ0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__ = __webpack_require__("0iuG");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 100,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        pro_name: '',
        brand_id: '',
        category_id: '',
        sec_id: '',
        weight: '',
        suit_pet: '',
        pro_mainpic: '',
        pro_pic: '',
        prosales: '',
        prointro_pic: '',
        pro_status: '1',
        related_proids: '',
        remark: '',
        create_time: '',
        update_time: '',
        status: 0,
        recommend: '0',
        upc: '',
        beianjia: '',
        origin_place: '',
        is_oversea: '1',
        admin_id: 0,
        dianpu_id: '',
        add_cart: '1',
        five_pifa: '0',
        one_daifa: '1',
        is_baoyou: '0',
        moban_id: ''
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      indexcategory: [],
      brand: [],
      secondMenu: [],
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl: '',
      imageName: '',
      fileListPro: [],
      fileListProintro: [],
      proPic: [],
      prointroPic: [],
      recommendStatus: __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].recommendStatus,
      isoverseaStatus: __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].isoverseaStatus,
      showUploadList: false,
      mainPicUrl: '',
      prospecArr: [],
      prospecForm: {
        spec_name: '',
        market_price: '',
        cpprice: '',
        inventory: '',
        is_default: '0'
      },
      isDefault: __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].isDefault,
      proStatus: __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].proStatus,
      prospecTable: [],
      proid: 0,
      selectGoodsVisible: false,
      goodsTypeData: [],
      goodsData: [],
      selectGoodsData: [],
      overseaArr: __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].overseaArr,
      mobanArr: [],
      dianpuList: []
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getGoodsList(this.query);
    },

    //获取商品列表
    getGoodsList: function getGoodsList(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/kucun', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
        _this.listLoading = false;
      });
    },

    //新增数据提交
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.addForm));
            para.prosales = parseInt(para.prosales);
            para.pro_pic = _this2.proPic.toString();
            para.prointro_pic = _this2.prointroPic.toString();
            para.pro_status = parseInt(para.pro_status);
            para.recommend = parseInt(para.recommend);
            para.pro_mainpic = _this2.mainPicUrl;
            para.beianjia = parseInt(para.beianjia);
            para.add_cart = parseInt(para.add_cart);
            para.five_pifa = parseInt(para.five_pifa);
            para.one_daifa = parseInt(para.one_daifa);
            para.is_baoyou = parseInt(para.is_baoyou);
            para.moban_id = parseInt(para.moban_id);
            para.is_oversea = parseInt(para.is_oversea);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product', para).then(function (response) {
              if (response.data.state) {
                //新增商品规格
                _this2.addProspec(response.data.msg);
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.mainPicUrl = '';
                _this2.proPic = [];
                _this2.prointroPic = [];
                _this2.fileListPro = [];
                _this2.fileListProintro = [];
                _this2.prospecTable = [];
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      var _this3 = this;

      this.editFormVisible = true;
      this.editForm = row;
      this.editForm.pro_status = row.pro_status.toString();
      this.editForm.recommend = row.recommend.toString();
      this.editForm.is_oversea = row.is_oversea.toString();
      this.editForm.add_cart = row.add_cart.toString();
      this.editForm.five_pifa = row.five_pifa.toString();
      this.editForm.one_daifa = row.one_daifa.toString();
      this.editForm.is_baoyou = row.is_baoyou.toString();
      //this.editForm.moban_id = row.moban_id.toString();
      this.proPic = row.pro_pic.split(',');
      this.prointroPic = row.prointro_pic.split(',');
      var that = this;
      this.fileListPro = [];
      this.proPic.forEach(function (item, i) {
        that.fileListPro.push({
          name: item.replace(__WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].picUrl, ''),
          url: item
        });
      });
      this.fileListProintro = [];
      this.prointroPic.forEach(function (item, i) {
        that.fileListProintro.push({
          name: item.replace(__WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].picUrl, ''),
          url: item
        });
      });
      this.mainPicUrl = row.pro_mainpic;
      //获取商品规格列表
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/specification/' + row.pro_id).then(function (response) {
        _this3.prospecTable = [];
        var i = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            item.index = i;
            _this3.prospecTable.push(item);
            i++;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    //修改提交
    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this4.editForm));
            para.prosales = parseInt(para.prosales);
            para.pro_pic = _this4.proPic.toString();
            para.prointro_pic = _this4.prointroPic.toString();
            para.pro_status = parseInt(para.pro_status);
            para.recommend = parseInt(para.recommend);
            para.pro_mainpic = _this4.mainPicUrl;
            para.beianjia = parseInt(para.beianjia);
            para.add_cart = parseInt(para.add_cart);
            para.five_pifa = parseInt(para.five_pifa);
            para.one_daifa = parseInt(para.one_daifa);
            para.is_baoyou = parseInt(para.is_baoyou);
            // para.moban_id = parseInt(para.moban_id);
            para.is_oversea = parseInt(para.is_oversea);
            //异步请求
            _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product', para).then(function (response) {
              if (response.data.state) {
                //新增商品规格
                _this4.addProspec(response.data.msg);
                _this4.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this4.$refs['editForm'].resetFields();
                _this4.mainPicUrl = '';
                _this4.proPic = [];
                _this4.prointroPic = [];
                _this4.fileListPro = [];
                _this4.fileListProintro = [];
                _this4.prospecTable = [];
                _this4.editFormVisible = false;
                _this4.search();
              } else {
                _this4.$message({
                  message: '提交失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this4.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {

      this.addFormVisible = true;
      this.proPic = [];
      this.fileListPro = [];
      this.prointroPic = [];
      this.fileListProintro = [];
      this.mainPicUrl = '';
      this.prospecTable = [];
    },

    //上传图片到七牛
    beforeUpload: function beforeUpload(file) {
      this.imageName = 'product/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      this.imageName += '.' + mime;
      this.uploadForm.key = this.imageName;
      this.imageUrl = __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].picUrl + this.imageName;
    },

    //上传失败
    uploadError: function uploadError(error) {
      console.log(error);
      this.$message({
        message: '图片上传异常，请联系管理员',
        type: 'error'
      });
    },

    //商品图片上传
    uploadPro: function uploadPro() {
      this.proPic.push(this.imageUrl);
      this.fileListPro.push({
        name: this.imageName,
        url: this.imageUrl
      });
    },

    //商品详情图片上传
    uploadProintro: function uploadProintro() {
      this.prointroPic.push(this.imageUrl);
      this.fileListProintro.push({
        name: this.imageName,
        url: this.imageUrl
      });
    },

    //商品图片删除
    removePicPro: function removePicPro(file, fileList) {
      this.proPic = this.proPic.filter(function (x) {
        return x !== __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].picUrl + file.name;
      });
    },

    //商品详情图片删除
    removePicProintro: function removePicProintro(file, fileList) {
      this.prointroPic = this.prointroPic.filter(function (x) {
        return x !== __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].picUrl + file.name;
      });
    },

    //获取品牌列表
    getBrand: function getBrand() {
      var _this5 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/brand/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.msg), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              _this5.brand.push({
                label: item.brand_name,
                value: item.brand_id
              });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        } else {
          _this5.$message({
            message: '获取品牌失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          message: '获取品牌异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取首页分类列表
    getIndexCategory: function getIndexCategory() {
      var _this6 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/indexcategory/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.msg), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              _this6.indexcategory.push({
                label: item.category_name,
                value: item.category_id
              });
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else {
          _this6.$message({
            message: '获取首页分类失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$message({
          message: '获取首页分类异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取二级分类列表
    getSecondMenu: function getSecondMenu() {
      var _this7 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/menu/tree').then(function (response) {
        var data = response.data;
        if (data && data.length > 0) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var item = _step4.value;
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(item.sec_menu), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var item1 = _step5.value;

                  _this7.secondMenu.push({
                    label: item1.sec_name,
                    value: item1.sec_id
                  });
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        } else {
          _this7.$message({
            message: '获取分类失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.$message({
          message: '获取分类异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //上传商品主图片
    mainBeforeUpload: function mainBeforeUpload(file) {
      var fileName = 'product/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      fileName += '.' + mime;
      this.uploadForm.key = fileName;
    },
    mainHandleSuccess: function mainHandleSuccess(response, file, fileList) {
      this.mainPicUrl = __WEBPACK_IMPORTED_MODULE_6__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
      this.result = '上传成功';
    },
    mainHandleError: function mainHandleError(error, response, file) {
      this.result = error.toString();
    },

    //获取规格列表
    getSpec: function getSpec() {
      var _this8 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/specification/list').then(function (response) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var item = _step6.value;

            _this8.prospecArr.push({
              label: item.name,
              value: item.id
            });
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    //保存规格，暂存在本地
    saveSpec: function saveSpec() {
      var para = this.prospecForm;
      para.is_default = parseInt(para.is_default);
      para.inventory = parseInt(para.inventory);
      para.cpprice = parseInt(para.cpprice);
      para.market_price = parseInt(para.market_price);
      para.index = this.prospecTable.length;
      this.prospecTable.push(para);
      this.prospecForm = {
        spec_name: '',
        market_price: '',
        cpprice: '',
        inventory: '',
        is_default: '0'
      };
    },

    //删除所有规格
    deleteSpec: function deleteSpec(id, index) {
      var _this9 = this;

      if (id > 0) {
        //删除数据库
        this.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/specification/' + id).then(function (response) {
          if (!response.data.state) {
            _this9.$message({
              message: '删除规格失败',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this9.$message({
            message: '删除规格异常',
            type: 'error'
          });
        });
      }
      //删除数组
      this.prospecTable.splice(index, 1);
      for (var i = 0; i < this.prospecTable.length; i++) {
        this.prospecTable[i].index = i;
      }
    },

    //新增商品规格
    addProspec: function addProspec(proid) {
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/specification/' + proid, this.prospecTable).then(function (response) {}).catch(function (error) {
        console.log(error);
      });
    },

    //修改规格
    editSpecHandler: function editSpecHandler(proid) {
      this.$router.push("/goods/prospec/" + proid);
    },

    //获取商品分类树
    showGoodsForm: function showGoodsForm(row) {
      var _this10 = this;

      this.proid = row.pro_id;
      this.goodsData = [];
      this.selectGoodsData = [];
      this.selectGoodsVisible = true;
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/menu/tree').then(function (response) {
        var data = response.data;
        if (data && data.length > 0) {
          var allmenu = [];
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var item = _step7.value;

              if (item.sec_menu && item.sec_menu.length > 0) {
                var secMenu = [];
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                  for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(item.sec_menu), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var item1 = _step8.value;

                    secMenu.push({
                      label: item1.sec_name,
                      value: item1.sec_id,
                      isFirst: 0
                    });
                  }
                } catch (err) {
                  _didIteratorError8 = true;
                  _iteratorError8 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                      _iterator8.return();
                    }
                  } finally {
                    if (_didIteratorError8) {
                      throw _iteratorError8;
                    }
                  }
                }

                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                  children: secMenu
                });
              } else {
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1
                });
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          _this10.goodsTypeData = allmenu;
        } else {
          _this10.$message({
            message: '获取树失败',
            type: 'error'
          });
        }
      }).catch(function (error) {
        _this10.$message({
          message: '获取树异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //点击树节点，获取商品
    handleNodeClick: function handleNodeClick(data) {
      var _this11 = this;

      if (data.isFirst === 0) {
        this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/type/' + data.value).then(function (response) {
          var data = response.data;
          if (data && data.length > 0) {
            var goodsData = [];
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
              for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var item = _step9.value;

                goodsData.push({
                  name: item.pro_name,
                  value: item.pro_id
                });
              }
            } catch (err) {
              _didIteratorError9 = true;
              _iteratorError9 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }
              } finally {
                if (_didIteratorError9) {
                  throw _iteratorError9;
                }
              }
            }

            _this11.goodsData = goodsData;
            //获取已关联商品
            _this11.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/relateds/' + _this11.proid).then(function (response) {
              if (response.data) {
                var selectData = [];
                var _iteratorNormalCompletion10 = true;
                var _didIteratorError10 = false;
                var _iteratorError10 = undefined;

                try {
                  for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.split(',')), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var id = _step10.value;
                    var _iteratorNormalCompletion11 = true;
                    var _didIteratorError11 = false;
                    var _iteratorError11 = undefined;

                    try {
                      for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(goodsData), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                        var _item = _step11.value;

                        if (_item.value === parseInt(id)) {
                          selectData.push(_item.name + '-' + id);
                        }
                      }
                    } catch (err) {
                      _didIteratorError11 = true;
                      _iteratorError11 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                          _iterator11.return();
                        }
                      } finally {
                        if (_didIteratorError11) {
                          throw _iteratorError11;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError10 = true;
                  _iteratorError10 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                      _iterator10.return();
                    }
                  } finally {
                    if (_didIteratorError10) {
                      throw _iteratorError10;
                    }
                  }
                }

                _this11.selectGoodsData = selectData;
              }
            }).catch(function (error) {
              console.log(error);
              _this11.$message({
                message: '获取商品异常，请联系管理员',
                type: 'error'
              });
            });
          } else {
            _this11.$message({
              message: '未获取到商品',
              type: 'info'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this11.$message({
            message: '获取商品异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },

    //提交选择商品
    selectGoodsSubmit: function selectGoodsSubmit() {
      var _this12 = this;

      if (this.selectGoodsData && this.selectGoodsData.length > 0) {
        var proIds = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectGoodsData), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var item = _step12.value;

            proIds.push(item.split('-')[1]);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/related', {
          related_proids: proIds.toString(),
          pro_id: this.proid
        }).then(function (response) {
          if (response.data.state) {
            _this12.$message({
              message: '提交成功',
              type: 'success'
            });
            _this12.selectGoodsVisible = false;
          } else {
            _this12.$message({
              message: '未获取到商品',
              type: 'info'
            });
          }
        }).catch(function (error) {
          _this12.$message({
            message: '获取商品异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
    getDianpuList: function getDianpuList() {
      var _this13 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/dianpu/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.msg), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var item = _step13.value;

              _this13.dianpuList.push({
                label: item.dianpu_name,
                value: item.id
              });
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }
        } else {
          _this13.$message({
            message: '获取店铺失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this13.$message({
          message: '获取店铺异常，请联系管理员',
          type: 'error'
        });
      });
    },
    getKuaidiMoban: function getKuaidiMoban() {
      var _this14 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/kuaidi/moban').then(function (response) {
        if (response.data.state) {
          _this14.mobanArr = [];
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var item = _step14.value;

              _this14.mobanArr.push({
                label: item.name,
                value: item.id
              });
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        } else {
          _this14.$message({
            message: '获取快递模板失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this14.$message({
          message: '获取快递模板异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },

  created: function created() {
    this.search();
    this.getBrand();
    this.getIndexCategory();
    this.getSecondMenu();
    this.getSpec();
    this.getKuaidiMoban();
    this.getDianpuList();
  }
});

/***/ }),

/***/ "JX0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__ = __webpack_require__("0iuG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_token_js__ = __webpack_require__("eVHZ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      query: '',
      submitLoading: false,
      seeRemarkVisible: false,
      remark: '',
      sellerRemark: '',
      sellerReply: '',
      id: 0,
      addWuliuVisible: false,
      wuliuForm: {
        wuliucompany: '',
        ordernum: '',
        wuliunum: '',
        wuliuinfo: '',
        wuliustatus: 'canvassing',
        timestamp: 0,
        createtime: '',
        endtime: '',
        status: 0
      },
      partDeliver: '0',
      goodsData: [],
      selectGoodsData: [],
      showGoods: 'hidden',
      orderIds: '',
      wuliu_num: '',
      updatePriceVisible: false,
      actOrdersum: '',
      expands: [],
      getRowKeys: function getRowKeys(row) {
        return row.id;
      },

      activeNames: '1',
      getOrderStatus: function getOrderStatus(status) {
        if (status === 1 || status === 2 || status === 3 || status === 4 || status === 6) {
          return status;
        } else if (status === 601) {
          return 7;
        } else if (status === 0) {
          return 8;
        } else {
          return 5;
        }
      },

      wuliuStatusTabs: [],
      wuliuStatus: 0,
      wuliuInfos: [],
      wuliuAction: '',
      userInfo: {},
      userStatus: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].userStatus,
      userLevel: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].userLevel,
      userChannel: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].userChannel,
      deliverStatus: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].deliverStatus,
      orderStatus: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].orderStatus,
      wuliuCompany: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].wuliuCompany,
      jiesuanStatus: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].jiesuanStatus,
      updateAddressVisible: false,
      addressForm: {},
      showUploadList: false,
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl1: '',
      imageUrl2: '',
      refundVisible: false,
      reason: '',
      back_fee: '',
      isRefund: 0,
      tableDataProduct: [],
      beginTime: '',
      endTime: '',
      orderStatusExcel: "200",
      chaidanVisbile: false,
      batchWuliuVisible: false,
      batchWulius: ''
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getOrderList(this.query);
    },
    getOrderList: function getOrderList(query) {
      var _this = this;

      this.listLoading = true;
      query = "||6|||";
      var url = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/page';
      this.$axios.post(url, {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        } else {
          _this.$message({
            message: '获取数据失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //打开备注窗口
    openRemark: function openRemark(row) {
      this.seeRemarkVisible = true;
      this.remark = row.remark ? row.remark : '无';
      this.sellerRemark = row.seller_remark;
      this.sellerReply = row.seller_reply;
      this.id = row.id;
    },

    //修改卖家备注
    remarkSubmit: function remarkSubmit() {
      var _this2 = this;

      this.submitLoading = true;
      this.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/sellerRemark', {
        "id": this.id,
        "seller_remark": this.sellerRemark,
        "seller_reply": this.sellerReply
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this2.$message({
            message: '修改成功！',
            type: 'success'
          });
          _this2.submitLoading = false;
          _this2.seeRemarkVisible = false;
          _this2.search();
        } else {
          _this2.$message({
            message: '修改备注失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$message({
          message: '修改备注异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //打开物流窗口
    openWuliu: function openWuliu(row) {
      this.addWuliuVisible = true;
      this.id = row.id;
      this.wuliuForm.ordernum = row.order_num;
      this.orderIds = row.order_ids;
      this.wuliu_num = row.wuliu_num;
    },

    //打开批量物流
    batchWuliu: function batchWuliu() {
      this.batchWulius = '';
      this.batchWuliuVisible = true;
    },

    //是否部分发货切换
    deliverChange: function deliverChange(val) {
      if (val === '1') {
        this.showGoods = 'nohidden';
        this.getOrderProName();
      } else {
        this.showGoods = 'hidden';
      }
    },

    //提交物流
    wuliuSubmit: function wuliuSubmit() {
      var _this3 = this;

      this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/wuliu', this.wuliuForm).then(function (response) {
        var data = response.data;
        if (data.state) {
          //this.putOrderNum();
          _this3.$refs['wuliuForm'].resetFields();
        } else {
          _this3.$message({
            message: '提交失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this3.$message({
          message: '提交异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //修改订单编号
    putOrderNum: function putOrderNum() {
      var _this4 = this;

      var wuliunum = this.wuliu_num;
      wuliunum = this.wuliuForm.wuliunum;
      var partDeliver = 0;
      this.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/wuliunum', {
        "id": this.id,
        "wuliu_num": wuliunum,
        "wuliu_company": this.wuliuForm.wuliucompany,
        "part_deliver": parseInt(partDeliver)
      }).then(function (response) {
        if (response.data.state) {
          _this4.putOrderFormDeliver();
        } else {
          _this4.$message({
            message: '提交失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this4.$message({
          message: '提交异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //修改订单商品发货状态
    putOrderFormDeliver: function putOrderFormDeliver() {
      var _this5 = this;

      var idArr = [],
          ids = '';
      if (this.selectGoodsData.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectGoodsData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            idArr.push(item.split('-')[1]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        ids = idArr.toString();
      } else {
        ids = this.orderIds;
      }
      this.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/form/deliver/' + ids).then(function (response) {
        if (response.data.state) {
          _this5.$message({
            message: '提交成功！',
            type: 'success'
          });
          _this5.addWuliuVisible = false;
          _this5.search();
        } else {
          _this5.$message({
            message: '提交失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          message: '提交异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //获取订单关联的商品
    getOrderProName: function getOrderProName() {
      var _this6 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/form/proname/' + this.orderIds).then(function (response) {
        var data = response.data;
        _this6.goodsData = [];
        if (data.state) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.msg), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              for (var i = 1; i < item.pronum + 1; i++) {
                console.log(i);
                _this6.goodsData.push(item.pro_name + '-' + item.id + '-' + i);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$message({
          message: '获取商品异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //修改价格窗口
    openPrice: function openPrice(row) {
      this.updatePriceVisible = true;
      this.actOrdersum = row.act_ordersum;
      this.id = row.id;
    },

    //修改价格
    updatePrice: function updatePrice() {
      var _this7 = this;

      this.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/ordersum', {
        id: this.id,
        act_ordersum: parseFloat(this.actOrdersum)
      }).then(function (response) {
        if (response.data.state) {
          _this7.$message({
            message: '价格修改成功',
            type: 'success'
          });
          _this7.updatePriceVisible = false;
          _this7.search();
        } else {
          _this7.$message({
            message: '价格修改失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.$message({
          message: '价格修改异常，请联系管理员',
          type: 'error'
        });
      });
    },
    openAddress: function openAddress(row) {
      this.updateAddressVisible = true;
      this.addressForm.id = row.id;
      this.addressForm.addr_name = row.addr_name;
      this.addressForm.tel = row.tel;
      this.addressForm.sheng = row.sheng;
      this.addressForm.shi = row.shi;
      this.addressForm.xian = row.xian;
      this.addressForm.addr_detail = row.addr_detail;
      this.addressForm.card_num = row.card_num;
      this.imageUrl1 = row.card_pic.split(',')[0];
      this.imageUrl2 = row.card_pic.split(',')[1];
    },
    updateAddress: function updateAddress() {
      var _this8 = this;

      this.$confirm('确认提交吗？', '提示', {}).then(function () {
        _this8.submitLoading = true;
        var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this8.addressForm);
        para.card_pic = _this8.imageUrl1 + ',' + _this8.imageUrl2;
        _this8.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/address', para).then(function (response) {
          if (response.data.state) {
            _this8.$message({
              message: '提交成功',
              type: 'success'
            });
            _this8.$refs['addressForm'].resetFields();
            _this8.updateAddressVisible = false;
            _this8.search();
          } else {
            _this8.$message({
              message: '提交失败，请联系管理员',
              type: 'error'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this8.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //取消订单
    closeOrder: function closeOrder(id) {
      var _this9 = this;

      this.$confirm('是否确认取消订单？', '提示', {}).then(function () {
        _this9.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/close/' + id).then(function (response) {
          if (response.data.state) {
            _this9.$message({
              message: '订单取消成功!',
              type: 'success'
            });
            _this9.search();
          } else {
            _this9.$message({
              message: '取消订单失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this9.$message({
            message: '取消订单异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //查询订单状态，物流状态等。
    expand: function expand(row, expanded) {
      if (expanded) {
        this.wuliuStatusTabs = row.wuliu_num ? row.wuliu_num.split(',') : [];
        this.wuliuAction = this.wuliuStatusTabs[0];
        this.getWuliuStatus(this.wuliuStatusTabs[0], row.order_num);
        this.getUserInfo(row.usid);
        this.expands = [];
        this.expands.push(row.id);
        this.getProduct(row.order_ids);
      }
    },
    wuliuStatusClick: function wuliuStatusClick(tab, event) {
      this.getWuliuStatus(tab.name);
    },

    //查询物流状态
    getWuliuStatus: function getWuliuStatus(wuliuNum, orderNum) {
      var _this10 = this;

      if (wuliuNum) {
        this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/wuliu/' + wuliuNum + '/' + orderNum).then(function (response) {
          var data = response.data;
          if (data.state) {
            var result = data.msg;
            _this10.wuliuStatus = __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].wuliuStatus[result.wuliustatus];
            _this10.wuliuInfos = [];
            var obj = result.wuliuinfo ? JSON.parse(result.wuliuinfo) : '';
            if (obj && obj.length > 0) {
              _this10.wuliuInfos = obj;
            }
          } else {
            _this10.$message({
              message: '查询物流状态失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this10.$message({
            message: '查询物流状态异常，请联系管理员',
            type: 'error'
          });
        });
      } else {
        this.wuliuInfos = [];
        this.wuliuStatus = 0;
      }
    },

    //获取用户信息
    getUserInfo: function getUserInfo(usid) {
      var _this11 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/userinfo/' + usid).then(function (response) {
        if (response.data.state) {
          _this11.userInfo = response.data.msg;
        } else {
          _this11.$message({
            message: '查询用户数据失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this11.$message({
          message: '查询用户数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    // 获取商品列表
    getProduct: function getProduct(orderIds) {
      var _this12 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/form/' + orderIds).then(function (response) {
        if (response.data.state) {
          _this12.tableDataProduct = response.data.msg;
        } else {
          _this12.$message({
            message: '获取商品列表失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this12.$message({
          message: '获取商品列表异常，请联系管理员',
          type: 'error'
        });
      });
    },
    makeImageName: function makeImageName(file) {
      var fileName = 'card/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      fileName += '.' + mime;
      this.uploadForm.key = fileName;
      return fileName;
    },
    beforeUpload1: function beforeUpload1(file) {
      this.imageUrl1 = __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].picUrl + this.makeImageName(file);
    },
    beforeUpload2: function beforeUpload2(file) {
      this.imageUrl2 = __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].picUrl + this.makeImageName(file);
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.result = '上传成功';
    },
    handleError: function handleError(error, response, file) {
      this.result = error.toString();
    },

    //重置物流
    resetWuliu: function resetWuliu(row) {
      var _this13 = this;

      this.$confirm('是否重置物流数据？', '提示', {}).then(function () {
        _this13.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/resetwuliu/' + row.id).then(function (response) {
          if (response.data.state) {
            _this13.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/form/resetwuliu/' + row.order_ids).then(function (response) {
              if (response.data.state) {
                _this13.$message({
                  message: '重置物流数据成功!',
                  type: 'success'
                });
                _this13.search();
              } else {
                _this13.$message({
                  message: '重置物流数据失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this13.$message({
                message: '重置物流数据异常，请联系管理员',
                type: 'error'
              });
            });
          } else {
            _this13.$message({
              message: '重置物流数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this13.$message({
            message: '重置物流数据异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //退款确认框
    refund: function refund(row, isRefund) {
      this.back_fee = row.back_fee;
      this.reason = row.reason;
      this.orderNum = row.order_num;
      this.refundVisible = true;
      this.isRefund = isRefund;
    },

    //退款提交
    refundSubmit: function refundSubmit() {
      var _this14 = this;

      this.$confirm('是否确认退款？', '提示', {}).then(function () {
        _this14.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/status/' + _this14.orderNum + '/601').then(function (response) {
          if (!response.data.state) {
            _this14.$message({
              message: '退款失败，请联系管理员',
              type: 'warning'
            });
          }
          _this14.refundVisible = false;
          _this14.search();
        }).catch(function (error) {
          console.log(error);
          _this14.$message({
            message: '退款异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    // 导出Excel
    export2Excel: function export2Excel() {
      var _this15 = this;

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      if (!this.beginTime || !this.endTime) {
        this.$message({
          message: '时间不能为空！',
          type: 'warning'
        });
        return;
      }
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/excel/' + this.beginTime + '/' + this.endTime + '/' + this.orderStatusExcel).then(function (response) {
        if (response.data.state) {
          if (response.data.msg) {
            console.log(response.data.msg);
            __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
              var _require = __webpack_require__("zKXg"),
                  export_json_to_excel = _require.export_json_to_excel;

              var tHeader = ['订单编号', '订单日期', '发货人', '发货人联系电话', '订购人注册号', '订购人姓名', '订购人身份证号码', '订购人电话', '收货人姓名', '收件人身份证号码', '收货人电话', '省', '市', '区', '收货地址', '商品条形码', '商品序号', '商品名称', '商品外文名称', '规格【临时】', '件数', '单价', '总价', '商品规格', '法定计量单位', '单位', '行邮税号', '行邮税名称', '行邮税率', 'HS编码', '原产地', '代扣税款', '非现金抵扣金额', '实际支付金额', '运费', '主要货物信息', '备注', '保价费', '商品组合条形码', '是否良品', '总税金', '是否投保价险', '是否投延误险', '投保价值', 'UEQ运单号', '扫描号', '净重', '毛重', '是否导入小票', '是否使用smartpost', '外文品牌', '商品简称', '是否提供身份证', '商品成分', '支付企业编号', '支付企业名称', '支付交易号', '支付时间', '电商商户名称', '电商商户备案号', '支付币种']; //对应表格输出的title
              var filterVal = ['order_num', 'create_time', '', '', 'name', 'addr_name', 'card_num', 'tel', 'addr_name', 'card_num', 'tel', 'sheng', 'shi', 'xian', 'addr_detail', 'upc', '', 'pro_name', '', 'spec_name', 'pronum', 'unit_price', 'price', '', '', '', '', '', '', '', 'origin_place', '', '', 'cash_fee', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']; // 对应表格输出的数据
              var list = response.data.msg;
              var data = _this15.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '订单列表_' + _this15.beginTime + '_' + _this15.endTime); //对应下载文件的名字
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          } else {
            _this15.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        } else {
          _this15.$message({
            message: '无数据，请联系管理员！',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this15.$message({
          message: '导出异常，请联系管理员！',
          type: 'error'
        });
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },

    // 拆单
    chaiDan: function chaiDan(row) {
      var _this16 = this;

      this.$confirm('是否确定拆单？', '提示', {}).then(function () {
        _this16.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/part_deliver/' + row.id + '/1/3').then(function (response) {
          if (!response.data.state) {
            _this16.$message({
              message: '拆单失败，请联系管理员',
              type: 'warning'
            });
          }
          _this16.refundVisible = false;
          _this16.search();
        }).catch(function (error) {
          console.log(error);
          _this16.$message({
            message: '拆单异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    // 拆单规则
    chaidanGuize: function chaidanGuize(row) {
      this.chaidanVisbile = true;
      this.orderIds = row.order_ids;
      this.id = row.id;
      this.getOrderProName();
    },
    chaidanXiangxi: function chaidanXiangxi(row) {
      this.$router.push("/order/chaidan/" + row.order_num);
    },

    // 取消拆单
    cancelChaidan: function cancelChaidan(row) {
      var _this17 = this;

      this.$confirm('是否取消拆单？', '提示', {}).then(function () {
        _this17.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/part_deliver/' + row.id + '/-1/2').then(function (response) {
          if (!response.data.state) {
            _this17.$message({
              message: '取消拆单失败，请联系管理员',
              type: 'warning'
            });
          } else {
            _this17.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/delete/wuliu/' + row.order_num).then(function (response) {
              if (response.data.state) {
                _this17.$message({
                  message: '取消成功！',
                  type: 'success'
                });
                _this17.refundVisible = false;
                _this17.search();
              }
            }).catch(function (error) {
              console.log(error);
              _this17.$message({
                message: '取消拆单异常，请联系管理员',
                type: 'error'
              });
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this17.$message({
            message: '取消拆单异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    // 拆单
    chaidanSubmit: function chaidanSubmit() {
      var _this18 = this;

      var idArr = [],
          ids = '';
      if (this.selectGoodsData.length > 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectGoodsData), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            idArr.push(item.split('-')[1]);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        ids = idArr.toString();
        this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/chaidan/' + this.id + '/' + ids).then(function (response) {
          if (!response.data.state) {
            _this18.$message({
              message: '拆单失败，请联系管理员',
              type: 'warning'
            });
          } else {
            _this18.$message({
              message: '拆单成功',
              type: 'success'
            });
            _this18.selectGoodsData = [];
          }
        }).catch(function (error) {
          console.log(error);
          _this18.$message({
            message: '拆单异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
    cancelChaidanSubmit: function cancelChaidanSubmit() {
      var _this19 = this;

      this.$confirm('是否确认所有操作完成？', '提示', {}).then(function () {
        _this19.chaidanVisbile = false;
      });
    },

    //提交批量物流
    batchWuliuSubmit: function batchWuliuSubmit() {
      var _this20 = this;

      console.log(1111);
      console.log(this.batchWulius);
      this.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/order/batchwuliu/' + this.batchWulius).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this20.$message({
            message: '提交成功！',
            type: 'success'
          });
          _this20.batchWulius = '';
          _this20.batchWuliuVisible = false;
          _this20.search();
        } else {
          _this20.$message({
            message: '提交批量物流失败，请联系管理员' + response.data.msg,
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this20.$message({
          message: '提交批量物流异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "JamP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        id: 0,
        title: '',
        content: '',
        create_time: '',
        remark: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      showUploadList: false,
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl: ''
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/procure/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/procure', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(row) {
      var _this3 = this;

      var text = '是否删除？';
      var status = 1;
      if (row.status == 1) {
        text = '是否恢复？';
        status = 0;
      }

      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/procure/delete/' + row.id + '/' + status).then(function (response) {
          if (response.data.state) {
            _this3.$message({
              message: '操作成功',
              type: 'success'
            });
            _this3.search();
          } else {
            _this3.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this3.$message({
            message: '删除异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.imageUrl = row.pic;
    },
    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.editForm);
            //异步请求
            _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/procure', para).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this4.$refs['editForm'].resetFields();
                _this4.editFormVisible = false;
                _this4.search();
              } else {
                _this4.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this4.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.addFormVisible = true;
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "JiTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"row-key":_vm.getRowKeys,"expand-row-keys":_vm.expands},on:{"expand":_vm.expand}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"订单状态","name":"1"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-steps',{attrs:{"space":100,"active":_vm.getOrderStatus(scope.row.order_status),"finish-status":"success"}},[_c('el-step',{attrs:{"title":"待支付"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已支付"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已发货"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已收货"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已完成"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"退货"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已退款"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"失效"}})],1)],1)]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"商品列表","name":"2"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-table',{attrs:{"data":_vm.tableDataProduct,"border":""}},[_c('el-table-column',{attrs:{"label":"名称","prop":"pro_name","align":"center","min-width":"500"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"价格","prop":"price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"规格","prop":"spec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"数量","prop":"pronum","align":"center"}})],1)],1)]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"物流状态","name":"3"}},[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.wuliuAction),callback:function ($$v) {_vm.wuliuAction=$$v},expression:"wuliuAction"}},_vm._l((_vm.wuliuStatusTabs),function(item,index){return _c('el-tab-pane',{key:index,staticStyle:{"text-align":"center"},attrs:{"label":item,"name":item}},[(_vm.wuliuInfos && _vm.wuliuInfos.length > 0)?_c('div',{staticStyle:{"text-align":"left"}},[_vm._v("物流信息："),_vm._l((_vm.wuliuInfos),function(item,index){return _c('p',{key:index},[_vm._v(_vm._s(item.context)+"  "+_vm._s(item.time))])})],2):_vm._e()])}))],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"用户信息","name":"4"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("微信编号：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.open_id))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("昵称：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.name))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("联系方式：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[(_vm.userInfo.tel)?_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.tel))]):_c('div',{staticClass:"user-font"},[_vm._v("暂无")])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("用户状态：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userStatus[_vm.userInfo.user_status]))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("用户等级：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userLevel[_vm.userInfo.level]))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("来源：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userChannel[_vm.userInfo.channel]))])])],1)],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"收货地址","name":"5"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("收货人姓名：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.addr_name))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("联系方式：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.tel))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("省市县：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.sheng)+_vm._s(scope.row.shi)+_vm._s(scope.row.xian))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("详细地址：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.addr_detail))])])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"订单编号","prop":"order_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"开始时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"收件人","prop":"addr_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"手机号","prop":"tel","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"省份","prop":"sheng","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"运费","prop":"yunfei","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"应付款","prop":"ordersum","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"实付款","prop":"act_ordersum","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"成本","prop":"all_cost","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"产出额","prop":"profit","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否拆单","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.deliverStatus[scope.row.part_deliver]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"订单状态","prop":"order_status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.orderStatus[scope.row.order_status]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流单位","prop":"wuliu_company","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"付款时间","prop":"pay_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分销","prop":"fen_xiao_dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"供应","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"流水号","prop":"transaction_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"买家留言","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"卖家留言","prop":"seller_reply","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"自己备注","prop":"seller_remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"event_unique_key","align":"center","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.openRemark(scope.row)}}},[_vm._v("查看备注")]),_vm._v(" "),(scope.row.order_status == 6)?_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.refund(scope.row, 1)}}},[_vm._v("退款")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"查看备注"},model:{value:(_vm.seeRemarkVisible),callback:function ($$v) {_vm.seeRemarkVisible=$$v},expression:"seeRemarkVisible"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("买家留言：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',[_vm._v(_vm._s(_vm.remark))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("卖家留言：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"type":"textarea","rows":"3","placeholder":"请输入留言"},model:{value:(_vm.sellerReply),callback:function ($$v) {_vm.sellerReply=$$v},expression:"sellerReply"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("自己备注：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"type":"textarea","rows":"3","placeholder":"请输入备注"},model:{value:(_vm.sellerRemark),callback:function ($$v) {_vm.sellerRemark=$$v},expression:"sellerRemark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.remarkSubmit}},[_vm._v("确认")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"添加物流"},model:{value:(_vm.addWuliuVisible),callback:function ($$v) {_vm.addWuliuVisible=$$v},expression:"addWuliuVisible"}},[_c('el-form',{ref:"wuliuForm",attrs:{"model":_vm.wuliuForm,"label-width":"150px"}},[_c('el-form-item',{attrs:{"label":"订单编号","prop":"ordernum"}},[_c('el-input',{attrs:{"disabled":true,"auto-complete":"off","size":"small","required":""},model:{value:(_vm.wuliuForm.ordernum),callback:function ($$v) {_vm.wuliuForm.ordernum=$$v},expression:"wuliuForm.ordernum"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物流单位","prop":"wuliucompany"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.wuliuForm.wuliucompany),callback:function ($$v) {_vm.wuliuForm.wuliucompany=$$v},expression:"wuliuForm.wuliucompany"}},_vm._l((_vm.wuliuCompany),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物流编号","prop":"wuliunum"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.wuliuForm.wuliunum),callback:function ($$v) {_vm.wuliuForm.wuliunum=$$v},expression:"wuliuForm.wuliunum"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.wuliuSubmit}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改价格","size":"tiny"},model:{value:(_vm.updatePriceVisible),callback:function ($$v) {_vm.updatePriceVisible=$$v},expression:"updatePriceVisible"}},[_c('el-row',[_c('el-col',{staticStyle:{"line-height":"30px"},attrs:{"offset":1,"span":6}},[_vm._v("实际付款：")]),_vm._v(" "),_c('el-col',{attrs:{"span":17}},[_c('el-input',{attrs:{"placeholder":"请输入价格","size":"small"},model:{value:(_vm.actOrdersum),callback:function ($$v) {_vm.actOrdersum=$$v},expression:"actOrdersum"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.updatePrice}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改收货地址","size":"small"},model:{value:(_vm.updateAddressVisible),callback:function ($$v) {_vm.updateAddressVisible=$$v},expression:"updateAddressVisible"}},[_c('el-form',{ref:"addressForm",attrs:{"model":_vm.addressForm,"label-width":"150px"}},[_c('el-form-item',{attrs:{"label":"姓名","prop":"addr_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.addr_name),callback:function ($$v) {_vm.addressForm.addr_name=$$v},expression:"addressForm.addr_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系方式","prop":"tel"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.tel),callback:function ($$v) {_vm.addressForm.tel=$$v},expression:"addressForm.tel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"地址","prop":"sheng"}},[_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.sheng),callback:function ($$v) {_vm.addressForm.sheng=$$v},expression:"addressForm.sheng"}})],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2,"offset":1}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.shi),callback:function ($$v) {_vm.addressForm.shi=$$v},expression:"addressForm.shi"}})],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2,"offset":1}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.xian),callback:function ($$v) {_vm.addressForm.xian=$$v},expression:"addressForm.xian"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"详细地址","prop":"addr_detail"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.addr_detail),callback:function ($$v) {_vm.addressForm.addr_detail=$$v},expression:"addressForm.addr_detail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号","prop":"card_num"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.card_num),callback:function ($$v) {_vm.addressForm.card_num=$$v},expression:"addressForm.card_num"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证","prop":"card_pic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload1,"data":_vm.uploadForm}},[(_vm.imageUrl1)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl1}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})]),_vm._v(" "),_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload2,"data":_vm.uploadForm}},[(_vm.imageUrl2)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl2}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.updateAddress}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"退款确认","size":"tiny"},model:{value:(_vm.refundVisible),callback:function ($$v) {_vm.refundVisible=$$v},expression:"refundVisible"}},[_c('el-row',[_c('el-col',{attrs:{"offset":1,"span":6}},[_vm._v("退款金额：")]),_vm._v(" "),_c('el-col',{attrs:{"span":17}},[_vm._v("\n        "+_vm._s(_vm.back_fee)+"\n      ")])],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding-top":"10px"}},[_c('el-col',{attrs:{"offset":1,"span":6}},[_vm._v("退款原因：")]),_vm._v(" "),_c('el-col',{attrs:{"span":17}},[_vm._v("\n        "+_vm._s(_vm.reason)+"\n      ")])],1),_vm._v(" "),(_vm.isRefund == 1)?_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.refundSubmit}},[_vm._v("确认")])],1):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"拆单规则","close-on-click-modal":false,"close-on-press-escape":false,"show-close":false},model:{value:(_vm.chaidanVisbile),callback:function ($$v) {_vm.chaidanVisbile=$$v},expression:"chaidanVisbile"}},[_c('el-row',[_c('el-col',{staticClass:"goods-data",attrs:{"span":24}},[_c('el-checkbox-group',{model:{value:(_vm.selectGoodsData),callback:function ($$v) {_vm.selectGoodsData=$$v},expression:"selectGoodsData"}},_vm._l((_vm.goodsData),function(item,i){return _c('el-checkbox',{key:item,attrs:{"label":item}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.chaidanSubmit}},[_vm._v("拆单")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.cancelChaidanSubmit}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量物流"},model:{value:(_vm.batchWuliuVisible),callback:function ($$v) {_vm.batchWuliuVisible=$$v},expression:"batchWuliuVisible"}},[_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("批量物流：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"type":"textarea","rows":"25","placeholder":"只支持【非拆单】物流，订单号|物流公司|运单号（每条按逗号隔开，快递公司必须按例子的名称）\n          1524861378848092680|UEQ|3934980308849,\n          1524861378848092680|中通速递|3934980308849,\n          1524861378848092680|圆通速递|3934980308849,\n          1524861378848092680|天天快递|3934980308849,\n          1524861378848092680|韵达快递|3934980308849,"},model:{value:(_vm.batchWulius),callback:function ($$v) {_vm.batchWulius=$$v},expression:"batchWulius"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.batchWuliuSubmit}},[_vm._v("确认")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jp6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerbrand_vue__ = __webpack_require__("I94A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57523d17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_partnerbrand_vue__ = __webpack_require__("M/vG");
function injectStyle (ssrContext) {
  __webpack_require__("u4nf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerbrand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57523d17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_partnerbrand_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Khrh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LBJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_vue__ = __webpack_require__("APnN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39669134_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_admin_vue__ = __webpack_require__("9iOM");
function injectStyle (ssrContext) {
  __webpack_require__("6I0w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39669134"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39669134_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_admin_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LBU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_date_js__ = __webpack_require__("bAtJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      listLoading: false,
      query: '',
      beginTime: '',
      endTime: ''
    };
  },

  methods: {
    search: function search() {
      this.getMovingPinList(this.query);
    },
    export2Excel: function export2Excel() {
      var _this = this;

      this.search();
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/order/movingpin';
      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + this.query;
      this.$axios.post(url, {
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          if (data.msg) {
            console.log(response.data.msg);
            __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
              var _require = __webpack_require__("zKXg"),
                  export_json_to_excel = _require.export_json_to_excel;

              var tHeader = ['商品编号', '商品名称', '当前价格', '平均售价', '平均成本', '销售数量', '销售额', '产出额', '利润率']; //对应表格输出的title
              var filterVal = ['pro_id', 'pro_name', 'cpprice', 'avg_price', 'avg_cost', 'num', 'sum_price', 'sum_profit', 'profit_margin']; // 对应表格输出的数据
              var list = response.data.msg;
              var data = _this.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '商品罗盘_' + '_' + _this.query + '_' + '开始时间_' + _this.beginTime + '_' + '结束时间_' + _this.endTime + '_' + '导出时间_' + new Date().toLocaleString()); //对应下载文件的名字
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          } else {
            _this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        } else {
          _this.$message({
            message: '无数据，请联系管理员！',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '导出异常，请联系管理员！',
          type: 'error'
        });
      });
    },

    //修改规格
    editSpecHandler: function editSpecHandler(proid) {
      this.$router.push("/goods/prospec/" + proid);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    getMovingPinList: function getMovingPinList(query) {
      var _this2 = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/order/movingpin';

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + query;
      this.$axios.post(url, {
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this2.tableData = data.msg;
          _this2.listLoading = false;
        }
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "Luci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("D6r2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b9b982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("zDZK");
function injectStyle (ssrContext) {
  __webpack_require__("zdzv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68b9b982"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b9b982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M/vG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":20}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.beginTime),callback:function ($$v) {_vm.beginTime=$$v},expression:"beginTime"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}}),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":"店铺名称","size":"small"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.export2Excel}},[_vm._v("导出数据")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(_vm.profitSum))])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"ID","prop":"arrid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分销编号","prop":"usid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺等级","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.userLevel[scope.row.level]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺名称","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"平均价格","prop":"avg_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"订单数量","prop":"num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"销售额","prop":"sum_price","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.sum_price < 1001)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 10000)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 5000)?_c('el-button',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):(scope.row.sum_price > 1000)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.sum_price))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"产出额","prop":"sum_profit","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.sum_profit < 101)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 1000)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 500)?_c('el-button',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):(scope.row.sum_profit > 100)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v(_vm._s(scope.row.sum_profit))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"利润率","prop":"profit_margin","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺备注","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showOrder(scope.row.usid, '')}}},[_vm._v("查看订单")])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360f3ca5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Rxvl");
function injectStyle (ssrContext) {
  __webpack_require__("Ob7b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360f3ca5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MOB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MxQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_firstmenu_vue__ = __webpack_require__("Ygy3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_461cd6ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_firstmenu_vue__ = __webpack_require__("CL04");
function injectStyle (ssrContext) {
  __webpack_require__("tPPp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-461cd6ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_firstmenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_461cd6ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_firstmenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NFaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by Administrator on 2017/6/19.
 */
/* unused harmony default export */ var _unused_webpack_default_export = ({
  api_url: '/v1/admin'
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_font_awesome_css_font_awesome_css__ = __webpack_require__("5W1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__("2uFj");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_7_axios___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  //设置菜单隐藏
  // router.options.routes[1].hidden = true;
  if (to.path == '/login') {
    __WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a.delete('token_admin');
  }
  var token = __WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a.get('token_admin');
  if (!token && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

//请求拦截
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (__WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a.get('token_admin')) {
    config.headers["Authorization"] = __WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a.get('token_admin');
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

setInterval(function () {
  if (!__WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a.get("gys_qiniu_token")) {
    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].api_url + '/qiniu').then(function (response) {
      __WEBPACK_IMPORTED_MODULE_10_vue_cookie___default.a.set("gys_qiniu_token", response.data, { expires: '55m' });
    }).catch(function (error) {
      console.log(error);
    });
  }
}, 1000);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "Ob1u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ob7b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ormy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.addFormVisible = true}}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"编号","prop":"id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分类名称","prop":"type_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"广告名称","prop":"adver_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"标识","prop":"unique_key","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showAdver(scope.row)}}},[_vm._v("选择广告")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showEditForm(scope.row)}}},[_vm._v("更新名称")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"标识","prop":"unique_key"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.unique_key),callback:function ($$v) {_vm.addForm.unique_key=$$v},expression:"addForm.unique_key"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类名称","prop":"adver_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.type_name),callback:function ($$v) {_vm.addForm.type_name=$$v},expression:"addForm.type_name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"标识","prop":"unique_key"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.unique_key),callback:function ($$v) {_vm.editForm.unique_key=$$v},expression:"editForm.unique_key"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类名称","prop":"type_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.type_name),callback:function ($$v) {_vm.editForm.type_name=$$v},expression:"editForm.type_name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.adverFormVisible),callback:function ($$v) {_vm.adverFormVisible=$$v},expression:"adverFormVisible"}},[_c('el-row',[_c('el-col',{staticStyle:{"line-height":"30px"},attrs:{"offset":2,"span":4}},[_vm._v("选择广告：")]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"请选择","size":"small"},model:{value:(_vm.adverId),callback:function ($$v) {_vm.adverId=$$v},expression:"adverId"}},_vm._l((_vm.adver),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.adverSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PckH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("ewbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c190b14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("q0vN");
function injectStyle (ssrContext) {
  __webpack_require__("/hNX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c190b14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rxvl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S5K5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"编号","prop":"sec_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"一级分类名","prop":"fname","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"二级分类名","prop":"sec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("恢复")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"一级分类名称","prop":"fid"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.fid),callback:function ($$v) {_vm.addForm.fid=$$v},expression:"addForm.fid"}},_vm._l((_vm.firstMenu),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"二级分类名称","prop":"sec_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.sec_name),callback:function ($$v) {_vm.addForm.sec_name=$$v},expression:"addForm.sec_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类图片","prop":"pic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"一级分类名称","prop":"fid"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.fid),callback:function ($$v) {_vm.editForm.fid=$$v},expression:"editForm.fid"}},_vm._l((_vm.firstMenu),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"二级分类名称","prop":"sec_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.sec_name),callback:function ($$v) {_vm.editForm.sec_name=$$v},expression:"editForm.sec_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类图片","prop":"pic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sy9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monitor_vue__ = __webpack_require__("kYac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_794138ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_monitor_vue__ = __webpack_require__("Hqt7");
function injectStyle (ssrContext) {
  __webpack_require__("bNAt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-794138ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monitor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_794138ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_monitor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "T2pQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moban_vue__ = __webpack_require__("F+7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09290b2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_moban_vue__ = __webpack_require__("u1S3");
function injectStyle (ssrContext) {
  __webpack_require__("MOB2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09290b2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moban_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09290b2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_moban_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tiwh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPara;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_date_js__ = __webpack_require__("bAtJ");
/**
 * Created by Administrator on 2017/10/13.
 */


function formatPara(para) {
  if (para.start_time && typeof para.start_time != "string") para.start_time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js_date_js__["a" /* formatDate */])(para.start_time, 'yyyy-MM-dd hh:mm:ss');

  if (para.end_time && typeof para.end_time != "string") para.end_time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js_date_js__["a" /* formatDate */])(para.end_time, 'yyyy-MM-dd hh:mm:ss');

  if (typeof para.update_time === "string") para.update_time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js_date_js__["a" /* formatDate */])(new Date(), 'yyyy-MM-dd hh:mm:ss');

  if (!para.create_time) if (typeof para.create_time === "string") para.create_time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js_date_js__["a" /* formatDate */])(new Date(), 'yyyy-MM-dd hh:mm:ss');
  return para;
}

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UoFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"编号","prop":"id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"名称","prop":"name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"small","type":"danger"},on:{"click":function($event){_vm.deleteHandler(scope.row.id)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"名称","prop":"name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.name),callback:function ($$v) {_vm.addForm.name=$$v},expression:"addForm.name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"名称","prop":"name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.name),callback:function ($$v) {_vm.editForm.name=$$v},expression:"editForm.name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WJMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__ = __webpack_require__("EOco");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0982a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_vue__ = __webpack_require__("1gMY");
function injectStyle (ssrContext) {
  __webpack_require__("9gjt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c0982a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0982a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XTf0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        name: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {}
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/specification/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/specification', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(id) {
      var _this3 = this;

      if (id != 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/specification/' + id).then(function (response) {
            if (response.data.state) {
              _this3.$message({
                message: '删除成功',
                type: 'success'
              });
              _this3.search();
            } else {
              _this3.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(function (error) {
            _this3.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(function () {
          _this3.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.editForm);
            //异步请求
            _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/specification', para).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this4.$refs['editForm'].resetFields();
                _this4.editFormVisible = false;
                _this4.search();
              } else {
                _this4.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this4.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.addFormVisible = true;
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "Y26B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.addFormVisible = true}}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"关键词","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"关键词","prop":"keyword","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否热门","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isHot[scope.row.is_hot]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否默认","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isDefault[scope.row.is_default]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"排序","prop":"sort_order","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"链接","prop":"scheme_url","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"平台","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.channel[scope.row.channel]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showEditForm(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"danger","size":"small"},on:{"click":function($event){_vm.deleteDate(scope.row.id)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"关键词","prop":"keyword"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.keyword),callback:function ($$v) {_vm.addForm.keyword=$$v},expression:"addForm.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"链接","prop":"scheme_url"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.scheme_url),callback:function ($$v) {_vm.addForm.scheme_url=$$v},expression:"addForm.scheme_url"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否热门","prop":"is_hot"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.is_hot),callback:function ($$v) {_vm.addForm.is_hot=$$v},expression:"addForm.is_hot"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否默认","prop":"is_default"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.is_default),callback:function ($$v) {_vm.addForm.is_default=$$v},expression:"addForm.is_default"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"平台","prop":"channel"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.channel),callback:function ($$v) {_vm.addForm.channel=$$v},expression:"addForm.channel"}},_vm._l((_vm.channel),function(item,index){return _c('el-option',{key:index,attrs:{"label":_vm.channel[index],"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"排序","prop":"sort_order"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.sort_order),callback:function ($$v) {_vm.addForm.sort_order=$$v},expression:"addForm.sort_order"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"200px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"关键词","prop":"keyword"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.keyword),callback:function ($$v) {_vm.editForm.keyword=$$v},expression:"editForm.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"链接","prop":"scheme_url"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.scheme_url),callback:function ($$v) {_vm.editForm.scheme_url=$$v},expression:"editForm.scheme_url"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否热门","prop":"is_hot"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.is_hot),callback:function ($$v) {_vm.editForm.is_hot=$$v},expression:"editForm.is_hot"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否默认","prop":"is_default"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.is_default),callback:function ($$v) {_vm.editForm.is_default=$$v},expression:"editForm.is_default"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"平台","prop":"channel"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.channel),callback:function ($$v) {_vm.editForm.channel=$$v},expression:"editForm.channel"}},_vm._l((_vm.channel),function(item,index){return _c('el-option',{key:index,attrs:{"label":_vm.channel[index],"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"排序","prop":"sort_order"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.sort_order),callback:function ($$v) {_vm.editForm.sort_order=$$v},expression:"editForm.sort_order"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YRiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_util_js__ = __webpack_require__("Tiwh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        type_name: '',
        unique_key: '',
        create_time: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      adverFormVisible: false,
      adverId: '',
      adver: [],
      id: 0
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getAdverType(this.query);
    },
    getAdverType: function getAdverType(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/advertype/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
        } else {
          _this.$message({
            message: data.msg,
            type: 'warning'
          });
        }
        _this.listLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.addForm));
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/advertype', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: response.data.msg,
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },
    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this3.editForm));
            //异步请求
            _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/advertype', para).then(function (response) {
              if (response.data.state) {
                _this3.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this3.$refs['editForm'].resetFields();
                _this3.editFormVisible = false;
                _this3.search();
              } else {
                _this3.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this3.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this3.submitLoading = false;
          });
        }
      });
    },
    showEditForm: function showEditForm(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    showAdver: function showAdver(row) {
      this.adverFormVisible = true;
      this.getAdver();
      this.adverId = row.adver_name + '-' + row.adver_id;
      this.id = row.id;
    },
    adverSubmit: function adverSubmit() {
      var _this4 = this;

      this.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/advertype/adverid', {
        id: this.id,
        adver_id: this.adverId.split('-')[1],
        adver_name: this.adverId.split('-')[0]
      }).then(function (response) {
        if (response.data.state) {
          _this4.$message({
            message: '提交成功!',
            type: 'success'
          });
          _this4.adverFormVisible = false;
          _this4.search();
        } else {
          _this4.$message({
            message: '关联广告失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this4.$message({
          message: '关联广告异常，请联系管理员',
          type: 'error'
        });
      });
    },
    getAdver: function getAdver() {
      var _this5 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/adver').then(function (response) {
        if (response.data.state) {
          _this5.adver = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              _this5.adver.push({
                label: item.adver_name,
                value: item.adver_name + '-' + item.adver_id
              });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          _this5.$message({
            message: '获取广告失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          message: '获取广告异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__ = __webpack_require__("vkyI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_login_vue__ = __webpack_require__("Luci");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_dashboard_vue__ = __webpack_require__("XRHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_dianpu_index_vue__ = __webpack_require__("qJjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_goods_spec_vue__ = __webpack_require__("jPPW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_kuaidi_moban_vue__ = __webpack_require__("T2pQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_kuaidi_rule_vue__ = __webpack_require__("8dVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_goods_list_vue__ = __webpack_require__("q83E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_goods_writecopy_vue__ = __webpack_require__("938p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_order_list_vue__ = __webpack_require__("PckH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_order_chaidan_vue__ = __webpack_require__("e+bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_caiwu_tixian_vue__ = __webpack_require__("Blo5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_goods_prospec_vue__ = __webpack_require__("92jO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_order_list1_vue__ = __webpack_require__("m+Rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_advert_advertype_vue__ = __webpack_require__("GLF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_advert_adver_vue__ = __webpack_require__("G2MP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_advert_slide_vue__ = __webpack_require__("owsO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_advert_zhuanti_vue__ = __webpack_require__("gTdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_user_huiyuan_vue__ = __webpack_require__("/x53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_system_admin_vue__ = __webpack_require__("LBJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_system_keywords_vue__ = __webpack_require__("gBGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_goods_brand_vue__ = __webpack_require__("mBUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_goods_firstmenu_vue__ = __webpack_require__("MxQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_goods_secmenu_vue__ = __webpack_require__("Fzhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_goods_indexcategory_vue__ = __webpack_require__("YwTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_caigou_index_vue__ = __webpack_require__("FYJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_goods_kucun_vue__ = __webpack_require__("Ylbs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_goods_movingpin_vue__ = __webpack_require__("tLmn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_order_distristatics_vue__ = __webpack_require__("Gw3A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_order_partnerbrand_vue__ = __webpack_require__("Jp6A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_system_spider_vue__ = __webpack_require__("f/Jt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_goods_shopcar_vue__ = __webpack_require__("zVnG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_goods_monitor_vue__ = __webpack_require__("Sy9H");


































var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_login_vue__["a" /* default */],
  hidden: true
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '首页',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__pages_dashboard_vue__["a" /* default */], name: '首页' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '店铺管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/dianpu', component: __WEBPACK_IMPORTED_MODULE_3__pages_dianpu_index_vue__["a" /* default */], name: '店铺管理' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '广告管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/adver', component: __WEBPACK_IMPORTED_MODULE_15__pages_advert_adver_vue__["a" /* default */], name: '广告' }, { path: '/zhuanti', component: __WEBPACK_IMPORTED_MODULE_17__pages_advert_zhuanti_vue__["a" /* default */], name: '专题' }, { path: '/advert/advertype', component: __WEBPACK_IMPORTED_MODULE_14__pages_advert_advertype_vue__["a" /* default */], name: '场景' }, { path: '/slide/:id', component: __WEBPACK_IMPORTED_MODULE_16__pages_advert_slide_vue__["a" /* default */], name: '幻灯片', hidden: true }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '采购管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/caigou/index', component: __WEBPACK_IMPORTED_MODULE_25__pages_caigou_index_vue__["a" /* default */], name: '采购记录' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '商品管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/goods/brand', component: __WEBPACK_IMPORTED_MODULE_21__pages_goods_brand_vue__["a" /* default */], name: '品牌' }, { path: '/goods/indexcategory', component: __WEBPACK_IMPORTED_MODULE_24__pages_goods_indexcategory_vue__["a" /* default */], name: '首页分类' }, { path: '/goods/firstmenu', component: __WEBPACK_IMPORTED_MODULE_22__pages_goods_firstmenu_vue__["a" /* default */], name: '一级分类' }, { path: '/goods/secmenu', component: __WEBPACK_IMPORTED_MODULE_23__pages_goods_secmenu_vue__["a" /* default */], name: '二级分类' }, { path: '/goods/specification', component: __WEBPACK_IMPORTED_MODULE_4__pages_goods_spec_vue__["a" /* default */], name: '商品规格' }, { path: '/goods/prospec/:proid', component: __WEBPACK_IMPORTED_MODULE_12__pages_goods_prospec_vue__["a" /* default */], name: '商品规格', hidden: true }, { path: '/goods/list', component: __WEBPACK_IMPORTED_MODULE_7__pages_goods_list_vue__["a" /* default */], name: '商品列表' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '数据管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/shopcar', component: __WEBPACK_IMPORTED_MODULE_31__pages_goods_shopcar_vue__["a" /* default */], name: '购物车' },
  // { path: '/monitor', component: monitor, name: '订阅管理' },
  { path: '/goods/movingpin', component: __WEBPACK_IMPORTED_MODULE_27__pages_goods_movingpin_vue__["a" /* default */], name: '商品罗盘' }, { path: '/goods/kucun', component: __WEBPACK_IMPORTED_MODULE_26__pages_goods_kucun_vue__["a" /* default */], name: '库存警告'
    // { path: '/writecopy', component: writecopy, name: '文案管理' }
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '订单管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/order/list', component: __WEBPACK_IMPORTED_MODULE_9__pages_order_list_vue__["a" /* default */], name: '订单列表' }, { path: '/order/distristatics', component: __WEBPACK_IMPORTED_MODULE_28__pages_order_distristatics_vue__["a" /* default */], name: '分销罗盘' }, { path: '/order/partnerbrand', component: __WEBPACK_IMPORTED_MODULE_29__pages_order_partnerbrand_vue__["a" /* default */], name: '品牌合伙' }, { path: '/order/list1', component: __WEBPACK_IMPORTED_MODULE_13__pages_order_list1_vue__["a" /* default */], name: '退货订单' }, { path: '/order/list/:usid', component: __WEBPACK_IMPORTED_MODULE_9__pages_order_list_vue__["a" /* default */], name: '订单列表', hidden: true }, { path: '/order/list/:usid/:orderNum', component: __WEBPACK_IMPORTED_MODULE_9__pages_order_list_vue__["a" /* default */], name: '订单列表', hidden: true }, { path: '/order/chaidan/:orderNum', component: __WEBPACK_IMPORTED_MODULE_10__pages_order_chaidan_vue__["a" /* default */], name: '订单列表', hidden: true }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '快递管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/kuaidi/moban', component: __WEBPACK_IMPORTED_MODULE_5__pages_kuaidi_moban_vue__["a" /* default */], name: '快递模板' }, { path: '/kuaidi/rule', component: __WEBPACK_IMPORTED_MODULE_6__pages_kuaidi_rule_vue__["a" /* default */], name: '快递规则' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '用户管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/user/huiyuan', component: __WEBPACK_IMPORTED_MODULE_18__pages_user_huiyuan_vue__["a" /* default */], name: '会员管理' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '财务管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/tixian', component: __WEBPACK_IMPORTED_MODULE_11__pages_caiwu_tixian_vue__["a" /* default */], name: '账户提现' }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_home_vue__["a" /* default */],
  name: '系统管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/user', component: __WEBPACK_IMPORTED_MODULE_19__pages_system_admin_vue__["a" /* default */], name: '管理员' }, { path: '/keyword', component: __WEBPACK_IMPORTED_MODULE_20__pages_system_keywords_vue__["a" /* default */], name: '关键词' }, { path: '/spider', component: __WEBPACK_IMPORTED_MODULE_30__pages_system_spider_vue__["a" /* default */], name: '爬虫库' }]
}];
/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "Ygy3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        fname: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {}
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/firstmenu/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/firstmenu', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },


    //操作删除
    deleteHandler: function deleteHandler(id) {
      var _this3 = this;

      if (id != 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/firstmenu/delete/' + id).then(function (response) {
            if (response.data.state) {
              _this3.$message({
                message: '删除成功',
                type: 'success'
              });
              _this3.search();
            } else {
              _this3.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(function (error) {
            _this3.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(function () {
          _this3.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },


    //勾选删除数据
    removeData: function removeData() {
      var _this4 = this;

      if (this.selectRow.length > 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          if (_this4.selectRow.length == 1) {
            _this4.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/firstmenu/delete/' + _this4.selectRow[0].fid).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '删除成功',
                  type: 'success'
                });
                _this4.search();
              } else {
                _this4.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          } else {
            var ids = '',
                para = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this4.selectRow), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var row = _step.value;

                ids += row.fid + ',';
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            ids = ids.substring(0, ids.length - 1);
            _this4.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/firstmenu/batch/delete/' + ids).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '删除成功',
                  type: 'success'
                });
                _this4.search();
              } else {
                _this4.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }
        }).catch(function () {
          _this4.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      } else {
        this.$message({
          message: '请选择一条数据操作',
          type: 'warning'
        });
      }
    },

    //获取选中的数据
    selsChange: function selsChange(row) {
      this.selectRow = row;
    },


    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    editSubmit: function editSubmit() {
      var _this5 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this5.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this5.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this5.editForm);
            //异步请求
            _this5.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/firstmenu', para).then(function (response) {
              if (response.data.state) {
                _this5.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this5.$refs['editForm'].resetFields();
                _this5.editFormVisible = false;
                _this5.search();
              } else {
                _this5.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this5.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this5.submitLoading = false;
          });
        }
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "Ylbs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kucun_vue__ = __webpack_require__("IQ0H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3449141c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_kucun_vue__ = __webpack_require__("fvT7");
function injectStyle (ssrContext) {
  __webpack_require__("yje/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3449141c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kucun_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3449141c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_kucun_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YwTE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_indexcategory_vue__ = __webpack_require__("2OQH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f863a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_indexcategory_vue__ = __webpack_require__("B9vy");
function injectStyle (ssrContext) {
  __webpack_require__("6IBZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06f863a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_indexcategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f863a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_indexcategory_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKPh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__ = __webpack_require__("0iuG");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        moban_id: '',
        sheng: '',
        shou_zhong: 0,
        shouzhong_price: 0,
        xuzhong_price: 0,
        admin_id: 0,
        status: 0
      },
      shengFen: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].shengFen,
      editFormVisible: false,
      editForm: {},
      formRules: {},
      moban: [],
      mobanId: 0
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/kuaidi/rule/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            para.moban_id = parseInt(_this2.mobanId);
            para.shou_zhong = parseInt(para.shou_zhong);
            para.shouzhong_price = parseInt(para.shouzhong_price);
            para.xuzhong_price = parseInt(para.xuzhong_price);
            para.sheng = _this2.addForm.sheng;
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/kuaidi/rule', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(id) {
      var _this3 = this;

      if (id != 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/kuaidi/rule/' + id).then(function (response) {
            if (response.data.state) {
              _this3.$message({
                message: '删除成功',
                type: 'success'
              });
              _this3.search();
            } else {
              _this3.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(function (error) {
            _this3.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(function () {
          _this3.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.getKuaidiMoban();
      this.editFormVisible = true;
      this.editForm = row;
    },
    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this4.editForm);
            para.moban_id = parseInt(para.moban_id);
            para.shou_zhong = parseInt(para.shou_zhong);
            para.shouzhong_price = parseInt(para.shouzhong_price);
            para.xuzhong_price = parseInt(para.xuzhong_price);
            para.sheng = _this4.editForm.sheng;
            //异步请求
            _this4.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/kuaidi/rule', para).then(function (response) {
              if (response.data.state) {
                _this4.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this4.$refs['editForm'].resetFields();
                _this4.editFormVisible = false;
                _this4.search();
              } else {
                _this4.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this4.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this4.submitLoading = false;
          });
        }
      });
    },
    addHandler: function addHandler() {
      this.getKuaidiMoban();
      this.addFormVisible = true;
    },
    getKuaidiMoban: function getKuaidiMoban() {
      var _this5 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/kuaidi/moban').then(function (response) {
        if (response.data.state) {
          _this5.moban = [];
          var i = 0;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              _this5.moban.push({
                label: item.name,
                value: item.id
              });
              if (i === 0) _this5.mobanId = item.id;
              i++;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          _this5.$message({
            message: '获取快递模板失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          message: '获取快递模板异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "aETj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__ = __webpack_require__("0iuG");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      listLoading: false,
      query: '',
      submitLoading: false,
      editFormVisible: false,
      editForm: {},
      formRules: {},
      isDefault: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].isDefault,
      prospecArr: [],
      proid: 0
    };
  },

  methods: {
    search: function search() {
      var _this = this;

      this.listLoading = true;
      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/specification/' + this.proid).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //操作删除
    deleteHandler: function deleteHandler(id) {
      var _this2 = this;

      if (id != 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.$axios.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/specification/' + id).then(function (response) {
            if (!response.data.state) {
              _this2.$message({
                message: '删除规格失败',
                type: 'warning'
              });
            }
            _this2.search();
          }).catch(function (error) {
            console.log(error);
            _this2.$message({
              message: '删除规格异常',
              type: 'error'
            });
          });
        }).catch(function () {
          _this2.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },

    //修改数据弹框
    editHandler: function editHandler(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.editForm.is_default = row.is_default.toString();
    },

    //修改提交
    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this3.editForm);
            para.is_default = parseInt(para.is_default);
            para.inventory = parseInt(para.inventory);
            para.cpprice = parseFloat(para.cpprice);
            para.cost = parseFloat(para.cost);
            para.market_price = parseFloat(para.market_price);
            var paras = [para];
            //异步请求
            _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/product/specification', paras).then(function (response) {
              if (response.data.state) {
                _this3.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this3.$refs['editForm'].resetFields();
                _this3.editFormVisible = false;
                _this3.search();
              } else {
                _this3.$message({
                  message: '提交失败，请联系管理员',
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this3.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this3.submitLoading = false;
          });
        }
      });
    },

    //获取规格列表
    getSpec: function getSpec() {
      var _this4 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/specification/list').then(function (response) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.msg), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            _this4.prospecArr.push({
              label: item.name,
              value: item.id
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    this.proid = parseInt(this.$route.params.proid);
    this.search();
    this.getSpec();
  }
});

/***/ }),

/***/ "ac73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_util_js__ = __webpack_require__("Tiwh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        adver_name: '',
        start_time: '',
        end_time: '',
        create_time: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {}
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getAdver(this.query);
    },
    getAdver: function getAdver(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adver/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
        } else {
          _this.$message({
            message: data.msg,
            type: 'warning'
          });
        }
        _this.listLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm));
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adver', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: response.data.msg,
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },
    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.editForm));
            //异步请求
            _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adver', para).then(function (response) {
              if (response.data.state) {
                _this3.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this3.$refs['editForm'].resetFields();
                _this3.editFormVisible = false;
                _this3.search();
              } else {
                _this3.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this3.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this3.submitLoading = false;
          });
        }
      });
    },
    deleteDate: function deleteDate(id) {
      var _this4 = this;

      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adver/' + id).then(function (response) {
          if (response.data.state) {
            _this4.$message({
              message: '删除成功',
              type: 'success'
            });
            _this4.search();
          } else {
            _this4.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this4.$message({
            message: '删除异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    showEditForm: function showEditForm(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    addPic: function addPic(row) {
      this.$router.push({ path: '/slide/' + row.adver_id });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "bAtJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/**
 * Created by Administrator on 2017/10/9.
 */
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

/***/ }),

/***/ "bG0k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bNAt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cMpV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__ = __webpack_require__("0iuG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      recordStatus: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].status,
      selectRecordStatus: "200",
      beginTime: '',
      endTime: '',
      shopusid: '',
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 30,
      listLoading: false,
      expands: [],
      getRowKeys: function getRowKeys(row) {
        return row._id;
      },

      query: '',
      status: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].status
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/shopcar/page';
      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + this.shopusid + "|" + this.selectRecordStatus + "|" + this.query;
      this.$axios.post(url, {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "cXLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by Administrator on 2017/6/19.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  api_url: '/v1/admin'
});

/***/ }),

/***/ "dgBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_config_basicdata_js__ = __webpack_require__("0iuG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            tableData: [],
            total: 0,
            page: 1,
            pageSize: 10,
            listLoading: false,
            tixian_status: '-1',
            tixianStatus: __WEBPACK_IMPORTED_MODULE_1__static_config_basicdata_js__["a" /* default */].tixianStatus,
            expands: [],
            getRowKeys: function getRowKeys(row) {
                return row.id;
            },

            activeNames: '1',
            cardForm: {},
            dianpu: {}
        };
    },

    methods: {
        //分页方法
        handleSizeChange: function handleSizeChange(size) {
            this.pageSize = size;
            this.search();
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.page = page;
            this.search();
        },
        search: function search() {
            this.getSearch();
        },
        getSearch: function getSearch() {
            var _this = this;

            this.listLoading = true;
            this.$axios.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/tixian/page/' + this.tixian_status, {
                "page": this.page,
                "size": this.pageSize,
                "query": ''
            }).then(function (response) {
                var data = response.data;
                if (data.state) {
                    _this.total = data.count;
                    _this.tableData = data.msg;
                    _this.listLoading = false;
                }
            }).catch(function (error) {
                console.log(error);
                _this.$message({
                    message: '获取数据异常，请联系管理员',
                    type: 'error'
                });
            });
        },
        tixian: function tixian(id) {
            var _this2 = this;

            this.$confirm('确认提现？', '提示', {}).then(function () {
                //异步请求
                _this2.$axios.put(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/tixian/' + id).then(function (response) {
                    if (response.data.state) {
                        _this2.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        _this2.search();
                    } else {
                        _this2.$message({
                            message: '提交失败，' + response.data.msg,
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                    _this2.$message({
                        message: '提交异常，请联系管理员',
                        type: 'error'
                    });
                });
            });
        },

        // 获取提现卡
        getCard: function getCard(dianpuId) {
            var _this3 = this;

            this.$axios.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/tixian/card/' + dianpuId).then(function (response) {
                if (response.data.state) {
                    _this3.cardForm = response.data.msg;
                } else {
                    _this3.$message({
                        message: '获取提现卡失败，请联系管理员',
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                console.log(error);
                _this3.$message({
                    message: '获取提现卡异常，请联系管理员',
                    type: 'error'
                });
            });
        },
        getDianpu: function getDianpu(dianpuId) {
            var _this4 = this;

            this.$axios.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/dianpu/' + dianpuId).then(function (response) {
                if (response.data.state) {
                    _this4.dianpu = response.data.msg;
                } else {
                    _this4.$message({
                        message: '获取店铺失败，请联系管理员',
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                console.log(error);
                _this4.$message({
                    message: '获取店铺异常，请联系管理员',
                    type: 'error'
                });
            });
        },

        //查询账号信息、店铺信息等。
        expand: function expand(row, expanded) {
            if (expanded) {
                this.expands = [];
                this.expands.push(row.id);
                this.getCard(row.dianpu_id);
                this.getDianpu(row.dianpu_id);
            }
        }
    },
    created: function created() {
        this.search();
    }
});

/***/ }),

/***/ "e+bu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chaidan_vue__ = __webpack_require__("26W3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d48537c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_chaidan_vue__ = __webpack_require__("EZUG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chaidan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d48537c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_chaidan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eVHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQiniuToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/**
 * Created by Administrator on 2017/10/13.
 */




function getQiniuToken() {
  return __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.get("gys_qiniu_token");
}

/***/ }),

/***/ "ewbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__ = __webpack_require__("0iuG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_token_js__ = __webpack_require__("eVHZ");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 30,
      listLoading: false,
      query: '',
      submitLoading: false,
      seeRemarkVisible: false,
      remark: '',
      sellerRemark: '',
      sellerReply: '',
      id: 0,
      addWuliuVisible: false,
      wuliuForm: {
        wuliucompany: '',
        ordernum: '',
        wuliunum: '',
        wuliuinfo: '',
        wuliustatus: 'canvassing',
        timestamp: 0,
        createtime: '',
        endtime: '',
        status: 0
      },
      partDeliver: '0',
      goodsData: [],
      selectGoodsData: [],
      showGoods: 'hidden',
      orderIds: '',
      wuliu_num: '',
      updatePriceVisible: false,
      actOrdersum: '',
      expands: [],
      getRowKeys: function getRowKeys(row) {
        return row.id;
      },

      activeNames: '1',
      getOrderStatus: function getOrderStatus(status) {
        if (status === 1 || status === 2 || status === 3 || status === 4 || status === 6) {
          return status;
        } else if (status === 601) {
          return 7;
        } else if (status === 0) {
          return 8;
        } else {
          return 5;
        }
      },

      wuliuStatusTabs: [],
      wuliuStatus: 0,
      wuliuInfos: [],
      wuliuAction: '',
      userInfo: {},
      userStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].userStatus,
      userLevel: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].userLevel,
      userChannel: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].userChannel,
      deliverStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].deliverStatus,
      orderStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].orderStatus,
      wuliuCompany: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].wuliuCompany,
      jiesuanStatus: __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].jiesuanStatus,
      updateAddressVisible: false,
      usid: 0,
      orderNum: '',
      addressForm: {},
      showUploadList: false,
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      imageUrl1: '',
      imageUrl2: '',
      refundVisible: false,
      reason: '',
      back_fee: '',
      isRefund: 0,
      tableDataProduct: [],
      beginTime: '',
      endTime: '',
      orderStatusExcel: "200",
      chaidanVisbile: false,
      batchWuliuVisible: false,
      viewFormVisible: false,
      autoSplitNum: 2, // 新增：默认拆成2个包裹
      batchWulius: '',
      dianpuList: [],
      adrname: '',
      telphone: '',
      pro_mainpic: '',
      wuliudanhao: '',
      selectDianpu: '',
      // ================== 新增：拆单物流弹窗相关的变量 ==================
      // 在 data 的 return 块中追加
      splitWuliuDialogVisible: false,
      subListLoading: false,
      subTableData: [],
      currentOrderNum: '', // 存储当前操作的主订单号

      subWuliuVisible: false,
      subWuliuCom: '',
      subWuliuNum: '',
      activeSubRow: null, // 存储当前修改的单行子订单数据

      subBatchWuliuVisible: false,
      subBatchWuliuCom: '',
      subBatchTableData: [],
      subBatchSubmitLoading: false,
      lastUsedWuliuCom: '' // 记忆上次使用的快递公司
    };
  },

  methods: {
    // ================== 新增：拆单物流弹窗内部的全部逻辑方法 ==================
    // 触发大弹窗：修改原主页面的拆单详情点击事件
    chaidanXiangxi: function chaidanXiangxi(row) {
      this.currentOrderNum = row.order_num;
      this.splitWuliuDialogVisible = true;
      this.getSubList();
    },


    // 获取子订单列表 (对应源码 /suborder/orderNum)
    getSubList: function getSubList() {
      var _this = this;

      this.subListLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/suborder/' + this.currentOrderNum).then(function (response) {
        if (response.data.state) {
          _this.subTableData = response.data.msg;
        } else {
          _this.$message.error(response.data.msg || '获取拆单物流列表失败');
        }
        _this.subListLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.subListLoading = false;
      });
    },


    // 打开单个修改弹窗
    showSubWuliu: function showSubWuliu(row) {
      this.activeSubRow = row;
      this.subWuliuNum = row.wuliu_num;
      this.subWuliuCom = row.wuliu_company || this.lastUsedWuliuCom;
      this.subWuliuVisible = true;
    },


    // 【单条修改修正】：完美还原源码中的特定格式 .put(url/orderNum/suborderNum/wuliuNum/wuliuCom)
    subEditSubmit: function subEditSubmit() {
      var _this2 = this;

      if (!this.subWuliuCom || !this.subWuliuNum) {
        this.$message.warning('请填写完整的物流公司和单号');
        return;
      }

      // 按照原系统规范拼接特定 PUT 路径
      var url = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/suborder/' + this.currentOrderNum + '/' + this.activeSubRow.suborder_num + '/' + this.subWuliuNum + '/' + this.subWuliuCom;

      this.$axios.put(url).then(function (response) {
        if (response.data.state) {
          _this2.$message.success('提交成功');
          _this2.lastUsedWuliuCom = _this2.subWuliuCom; // 记忆快递
          _this2.subWuliuVisible = false;
          _this2.getSubList(); // 自动刷新列表
        } else {
          _this2.$message.error(response.data.msg || '提交失败');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$message.error('提交异常，请联系管理员');
      });
    },


    // 打开批量修改弹窗
    showSubBatchWuliu: function showSubBatchWuliu() {
      if (!this.subTableData || this.subTableData.length === 0) {
        return this.$message.warning('当前没有子订单可以操作');
      }
      this.subBatchWuliuCom = this.lastUsedWuliuCom || '';
      this.subBatchTableData = this.subTableData.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
          new_wuliu_num: item.wuliu_num || ''
        });
      });
      this.subBatchWuliuVisible = true;
    },


    // 【批量修改修正】：还原原页面源码的 Promise.all 异步并发 PUT 提交机制，彻底解决批量不成功问题
    subBatchEditSubmit: function subBatchEditSubmit() {
      var _this3 = this;

      if (!this.subBatchWuliuCom) {
        return this.$message.warning('请选择统一物流单位');
      }

      // 筛选出填写了单号的行
      var validItems = this.subBatchTableData.filter(function (item) {
        return item.new_wuliu_num && item.new_wuliu_num.trim() !== '';
      });
      if (validItems.length === 0) {
        return this.$message.warning('请至少为一个子订单填写物流单号');
      }

      this.subBatchSubmitLoading = true;

      // 重点：深度还原原作者多条并发 PUT 的模式 
      var requestPromises = validItems.map(function (item) {
        return _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/suborder/' + _this3.currentOrderNum + '/' + item.suborder_num + '/' + item.new_wuliu_num + '/' + _this3.subBatchWuliuCom);
      });

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(requestPromises).then(function (responses) {
        _this3.subBatchSubmitLoading = false;

        var hasError = responses.some(function (res) {
          return !res.data.state;
        });
        if (hasError) {
          _this3.$message.warning('部分订单提交失败，请检查列表');
        } else {
          _this3.$message.success('批量发货成功！');
          _this3.subBatchWuliuVisible = false;
          _this3.lastUsedWuliuCom = _this3.subBatchWuliuCom; // 记住本次使用的快递
        }
        _this3.getSubList(); // 自动刷新列表
      }).catch(function (error) {
        console.log(error);
        _this3.subBatchSubmitLoading = false;
        _this3.$message.error('网络异常，请刷新后查看状态');
        _this3.getSubList();
      });
    },

    // 新增：单品自动拆多包裹方法
    autoChaidanSubmit: function autoChaidanSubmit() {
      var _this4 = this;

      // 1. 校验用户是否只选了一个商品
      if (this.selectGoodsData.length === 0) {
        this.$message.warning('请先在下方勾选一个需要拆分包裹的商品');
        return;
      }
      if (this.selectGoodsData.length > 1) {
        this.$message.warning('【单品自动拆单】每次只能勾选一个商品。如需多个商品组合发货，请使用下方的【手动组合拆单】');
        return;
      }

      // 2. 校验拆分数量
      if (!this.autoSplitNum || this.autoSplitNum < 2) {
        this.$message.warning('拆分包裹数量至少为 2');
        return;
      }

      // 3. 从勾选的字符串中解析出后端需要的 formId
      // 你的数据格式如: "商品名-formId-索引"
      var selectedItemStr = this.selectGoodsData[0];
      var formId = selectedItemStr.split('-')[1];
      var proName = selectedItemStr.split('-')[0];

      // 4. 弹窗二次确认
      this.$confirm('\u786E\u8BA4\u5C06\u5546\u54C1\u3010' + proName + '\u3011\u81EA\u52A8\u62C6\u5206\u6210 ' + this.autoSplitNum + ' \u4E2A\u72EC\u7ACB\u5305\u88F9\u53D1\u8D27\u5417\uFF1F', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 5. 请求你刚刚修改好的新后端 Golang 接口
        // 接口路由：/order/auto_chaidan/:orderId/:formId/:splitNum
        _this4.$axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/auto_chaidan/' + _this4.id + '/' + formId + '/' + _this4.autoSplitNum).then(function (response) {
          // 兼容后端的传参返回格式
          if (response.data.state) {
            _this4.$message({
              message: response.data.msg || '自动拆单成功！',
              type: 'success'
            });
            _this4.chaidanVisbile = false;
            _this4.selectGoodsData = []; // 清空勾选
            _this4.search(); // 刷新订单列表数据
          } else {
            _this4.$message.warning('拆单失败：' + (response.data.msg || '未知错误'));
          }
        }).catch(function (error) {
          console.log(error);
          _this4.$message.error('自动拆单请求异常，请联系管理员');
        });
      }).catch(function () {
        // 取消不操作
      });
    },

    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getOrderList(this.query);
    },
    getOrderList: function getOrderList(query) {
      var _this5 = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/page';
      if (this.usid > 0) {
        url += '/' + this.usid;
        if (this.orderNum) {
          url += '/' + this.orderNum;
        }
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(function (response) {
          var data = response.data;
          if (data.state) {
            _this5.total = data.count;
            _this5.tableData = data.msg;
            _this5.listLoading = false;
          } else {
            _this5.$message({
              message: '获取数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this5.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        });
      } else {
        this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
        this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
        query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu + "|" + this.adrname + "|" + this.telphone + "|" + this.wuliudanhao + "|" + query;
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(function (response) {
          var data = response.data;
          if (data.state) {
            _this5.total = data.count;
            _this5.tableData = data.msg;
            _this5.listLoading = false;
          } else {
            _this5.$message({
              message: '获取数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this5.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
    mail: function mail() {
      this.getMailList(this.query);
    },
    getMailList: function getMailList(query) {
      var _this6 = this;

      var url = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/ordermail';

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu + "|" + this.adrname + "|" + this.telphone + "|" + query;
      this.$axios.post(url, {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this6.$message({
            message: '邮件发送成功！',
            type: 'success'
          });
        } else {
          _this6.$message({
            message: '获取数据失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this6.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    suppsumry: function suppsumry() {
      this.supplySummary(this.query);
    },
    supplySummary: function supplySummary(query) {
      var _this7 = this;

      var url = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/supplysummary';

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu + "|" + this.adrname + "|" + this.telphone + "|" + query;
      this.$axios.post(url, {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this7.$message({
            message: '供应概要发送成功！',
            type: 'success'
          });
        } else {
          _this7.$message({
            message: '获取数据失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //打开备注窗口
    openRemark: function openRemark(row) {
      this.seeRemarkVisible = true;
      this.remark = row.remark ? row.remark : '无';
      this.sellerRemark = row.seller_remark;
      this.sellerReply = row.seller_reply;
      this.id = row.id;
    },

    //修改卖家备注
    remarkSubmit: function remarkSubmit() {
      var _this8 = this;

      this.submitLoading = true;
      this.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/sellerRemark', {
        "id": this.id,
        "seller_remark": this.sellerRemark,
        "seller_reply": this.sellerReply
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this8.$message({
            message: '修改成功！',
            type: 'success'
          });
          _this8.submitLoading = false;
          _this8.seeRemarkVisible = false;
          _this8.search();
        } else {
          _this8.$message({
            message: '修改备注失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this8.$message({
          message: '修改备注异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //打开物流窗口
    openWuliu: function openWuliu(row) {
      this.addWuliuVisible = true;
      this.id = row.id;
      this.wuliuForm.ordernum = row.order_num;
      this.orderIds = row.order_ids;
      this.wuliu_num = row.wuliu_num;
    },

    //打开批量物流
    batchWuliu: function batchWuliu() {
      this.batchWulius = '';
      this.batchWuliuVisible = true;
    },

    //查看图片
    viewPic: function viewPic(pro_mainpic) {
      // console.log(pro_mainpic)
      this.pro_mainpic = pro_mainpic;
      this.viewFormVisible = true;
    },

    //是否部分发货切换
    deliverChange: function deliverChange(val) {
      if (val === '1') {
        this.showGoods = 'nohidden';
        this.getOrderProName();
      } else {
        this.showGoods = 'hidden';
      }
    },

    //提交物流
    wuliuSubmit: function wuliuSubmit() {
      var _this9 = this;

      this.$axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/wuliu', this.wuliuForm).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this9.putOrderNum();
          _this9.$refs['wuliuForm'].resetFields();
          _this9.$message({
            message: '提交成功！',
            type: 'success'
          });
        } else {
          _this9.$message({
            message: '提交失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this9.$message({
          message: '提交异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //修改订单编号
    putOrderNum: function putOrderNum() {
      var _this10 = this;

      var wuliunum = this.wuliu_num;
      wuliunum = this.wuliuForm.wuliunum;
      var partDeliver = 0;
      this.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/wuliunum', {
        "id": this.id,
        "wuliu_num": wuliunum,
        "wuliu_company": this.wuliuForm.wuliucompany,
        "part_deliver": parseInt(partDeliver)
      }).then(function (response) {
        if (response.data.state) {
          _this10.addWuliuVisible = false;
          _this10.search();
        } else {
          _this10.$message({
            message: '提交失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this10.$message({
          message: '提交异常，请联系管理员',
          type: 'error'
        });
      });
    },


    //获取订单关联的商品
    getOrderProName: function getOrderProName() {
      var _this11 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/form/proname/' + this.orderIds).then(function (response) {
        var data = response.data;
        _this11.goodsData = [];
        if (data.state) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.msg), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              for (var i = 1; i < item.pronum + 1; i++) {
                console.log(i);
                _this11.goodsData.push(item.pro_name + '-' + item.id + '-' + i);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this11.$message({
          message: '获取商品异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //修改价格窗口
    openPrice: function openPrice(row) {
      this.updatePriceVisible = true;
      this.actOrdersum = row.act_ordersum;
      this.id = row.id;
    },

    //修改价格
    updatePrice: function updatePrice() {
      var _this12 = this;

      this.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/ordersum', {
        id: this.id,
        act_ordersum: parseFloat(this.actOrdersum)
      }).then(function (response) {
        if (response.data.state) {
          _this12.$message({
            message: '价格修改成功',
            type: 'success'
          });
          _this12.updatePriceVisible = false;
          _this12.search();
        } else {
          _this12.$message({
            message: '价格修改失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this12.$message({
          message: '价格修改异常，请联系管理员',
          type: 'error'
        });
      });
    },
    openAddress: function openAddress(row) {
      this.updateAddressVisible = true;
      this.addressForm.id = row.id;
      this.addressForm.addr_name = row.addr_name;
      this.addressForm.tel = row.tel;
      this.addressForm.sheng = row.sheng;
      this.addressForm.shi = row.shi;
      this.addressForm.xian = row.xian;
      this.addressForm.addr_detail = row.addr_detail;
      this.addressForm.card_num = row.card_num;
      this.imageUrl1 = row.card_pic.split(',')[0];
      this.imageUrl2 = row.card_pic.split(',')[1];
    },
    updateAddress: function updateAddress() {
      var _this13 = this;

      this.$confirm('确认提交吗？', '提示', {}).then(function () {
        _this13.submitLoading = true;
        var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this13.addressForm);
        para.card_pic = _this13.imageUrl1 + ',' + _this13.imageUrl2;
        _this13.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/address', para).then(function (response) {
          if (response.data.state) {
            _this13.$message({
              message: '提交成功',
              type: 'success'
            });
            _this13.$refs['addressForm'].resetFields();
            _this13.updateAddressVisible = false;
            _this13.search();
          } else {
            _this13.$message({
              message: '提交失败，请联系管理员',
              type: 'error'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this13.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //支付订单
    payOrder: function payOrder(id) {
      var _this14 = this;

      this.$confirm('是否确认支付订单？', '提示', {}).then(function () {
        _this14.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/pay/' + id).then(function (response) {
          if (response.data.state) {
            _this14.$message({
              message: '订单支付成功!',
              type: 'success'
            });
            _this14.search();
          } else {
            _this14.$message({
              message: '支付订单失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this14.$message({
            message: '支付订单异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //取消订单
    closeOrder: function closeOrder(id) {
      var _this15 = this;

      this.$confirm('是否确认取消订单？', '提示', {}).then(function () {
        _this15.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/close/' + id).then(function (response) {
          if (response.data.state) {
            _this15.$message({
              message: '订单取消成功!',
              type: 'success'
            });
            _this15.search();
          } else {
            _this15.$message({
              message: '取消订单失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this15.$message({
            message: '取消订单异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    // 截取当前数据到小数点后两位
    numFilter: function numFilter(value) {
      var realVal = parseFloat(value).toFixed(1);
      return realVal;
    },

    //申请售后
    afterMarket: function afterMarket(id) {
      var _this16 = this;

      this.$confirm('是否确认申请售后？', '提示', {}).then(function () {
        _this16.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/aftermarket/' + id).then(function (response) {
          if (response.data.state) {
            _this16.$message({
              message: '申请售后成功!',
              type: 'success'
            });
            _this16.search();
          } else {
            _this16.$message({
              message: '申请售后，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this16.$message({
            message: '申请售后，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //重新核算
    recalculation: function recalculation(id) {
      var _this17 = this;

      this.$confirm('是否确认重新核算？', '提示', {}).then(function () {
        _this17.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/recalculation/' + id).then(function (response) {
          if (response.data.state) {
            _this17.$message({
              message: '重新核算成功!',
              type: 'success'
            });
            _this17.search();
          } else {
            _this17.$message({
              message: '核算失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this17.$message({
            message: '核算失败，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //平账
    balanceaccounts: function balanceaccounts(id) {
      var _this18 = this;

      this.$confirm('是否确认平账？', '提示', {}).then(function () {
        _this18.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/balanceaccounts/' + id).then(function (response) {
          if (response.data.state) {
            _this18.$message({
              message: '平账成功!',
              type: 'success'
            });
            _this18.search();
          } else {
            _this18.$message({
              message: '平账失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this18.$message({
            message: '平账失败，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //延迟发货
    delayFahuo: function delayFahuo(id) {
      var _this19 = this;

      this.$confirm('是否确认延迟发货？', '提示', {}).then(function () {
        _this19.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/delayfahuo/' + id).then(function (response) {
          if (response.data.state) {
            _this19.$message({
              message: '延迟发货成功!',
              type: 'success'
            });
            _this19.search();
          } else {
            _this19.$message({
              message: '延迟发货失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this19.$message({
            message: '延迟发货失败，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //查询订单状态，物流状态等。
    expand: function expand(row, expanded) {
      if (expanded) {
        this.wuliuStatusTabs = row.wuliu_num ? row.wuliu_num.split(',') : [];
        this.wuliuAction = this.wuliuStatusTabs[0];
        this.getWuliuStatus(this.wuliuStatusTabs[0], row.order_num);
        this.getUserInfo(row.usid);
        this.expands = [];
        this.expands.push(row.id);
        this.getProduct(row.order_ids);
      }
    },
    wuliuStatusClick: function wuliuStatusClick(tab, event) {
      // console.log(tab)
      //   console.log(event)
      this.getWuliuStatus(tab.name);
    },

    //查询物流状态
    getWuliuStatus: function getWuliuStatus(wuliuNum, orderNum) {
      var _this20 = this;

      if (wuliuNum) {
        this.$axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/wuliu/' + wuliuNum + '/' + orderNum).then(function (response) {
          var data = response.data;
          if (data.state) {
            var result = data.msg;
            // this.wuliuStatus = basicdata.wuliuStatus[result.wuliustatus];
            _this20.wuliuInfos = [];
            var obj = result.wuliuinfo ? JSON.parse(result.wuliuinfo) : '';
            if (obj && obj.length > 0) {
              _this20.wuliuInfos = obj;
            }
          } else {
            _this20.$message({
              message: '查询物流状态失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this20.$message({
            message: '查询物流状态异常，请联系管理员',
            type: 'error'
          });
        });
      } else {
        this.wuliuInfos = [];
        this.wuliuStatus = 0;
      }
    },

    //获取用户信息
    getUserInfo: function getUserInfo(usid) {
      var _this21 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/userinfo/' + usid).then(function (response) {
        if (response.data.state) {
          _this21.userInfo = response.data.msg;
        } else {
          _this21.$message({
            message: '查询用户数据失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this21.$message({
          message: '查询用户数据异常，请联系管理员',
          type: 'error'
        });
      });
    },

    // 获取商品列表
    getProduct: function getProduct(orderIds) {
      var _this22 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/form/' + orderIds).then(function (response) {
        if (response.data.state) {
          _this22.tableDataProduct = response.data.msg;
        } else {
          _this22.$message({
            message: '获取商品列表失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this22.$message({
          message: '获取商品列表异常，请联系管理员',
          type: 'error'
        });
      });
    },
    makeImageName: function makeImageName(file) {
      var fileName = 'card/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      fileName += '.' + mime;
      this.uploadForm.key = fileName;
      return fileName;
    },
    beforeUpload1: function beforeUpload1(file) {
      this.imageUrl1 = __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + this.makeImageName(file);
    },
    beforeUpload2: function beforeUpload2(file) {
      this.imageUrl2 = __WEBPACK_IMPORTED_MODULE_7__static_config_basicdata_js__["a" /* default */].picUrl + this.makeImageName(file);
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.result = '上传成功';
    },
    handleError: function handleError(error, response, file) {
      this.result = error.toString();
    },

    //重置物流
    resetWuliu: function resetWuliu(row) {
      var _this23 = this;

      this.$confirm('是否重置物流数据？', '提示', {}).then(function () {
        _this23.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/resetwuliu/' + row.id).then(function (response) {
          if (response.data.state) {
            _this23.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/form/resetwuliu/' + row.order_ids).then(function (response) {
              if (response.data.state) {
                _this23.$message({
                  message: '重置物流数据成功!',
                  type: 'success'
                });
                _this23.search();
              } else {
                _this23.$message({
                  message: '重置物流数据失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this23.$message({
                message: '重置物流数据异常，请联系管理员',
                type: 'error'
              });
            });
          } else {
            _this23.$message({
              message: '重置物流数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this23.$message({
            message: '重置物流数据异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //退款确认框
    refund: function refund(row, isRefund) {
      this.back_fee = row.back_fee;
      this.reason = row.reason;
      this.orderNum = row.order_num;
      this.refundVisible = true;
      this.isRefund = isRefund;
    },

    //退款提交
    refundSubmit: function refundSubmit() {
      var _this24 = this;

      this.$confirm('是否确认退款？', '提示', {}).then(function () {
        _this24.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/status/' + _this24.orderNum + '/601').then(function (response) {
          if (!response.data.state) {
            _this24.$message({
              message: '退款失败，请联系管理员',
              type: 'warning'
            });
          }
          _this24.refundVisible = false;
          _this24.search();
        }).catch(function (error) {
          console.log(error);
          _this24.$message({
            message: '退款异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    // 导出Excel
    export2Excel: function export2Excel() {
      this.exportExcel(this.query);
    },
    exportExcel: function exportExcel(query) {
      var _this25 = this;

      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu + "|" + this.adrname + "|" + this.telphone + "|" + query;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/exportexcel', {
        "query": query
      }).then(function (response) {
        if (response.data.state) {
          if (response.data.msg) {
            console.log(response.data.msg);
            __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
              var _require = __webpack_require__("zKXg"),
                  export_json_to_excel = _require.export_json_to_excel;

              var tHeader = ['订单编号', '订单下单时间', '收货人姓名', '收货人电话', '收件人身份证号码', '省份', '城市', '县区', '收货地址', '收货整体地址【临时】', '商品条形码', '商品名称', '规格【临时】', '数量', '单价', '总成本', '总销价', '结算状态', '商品备注', '买家备注', '卖家备注', '发件人姓名', '发件人电话', '供应商']; //对应表格输出的title
              var filterVal = ['order_num', 'create_time', 'addr_name', 'tel', 'card_num', 'sheng', 'shi', 'xian', 'addr_detail', 'address_temp', 'upc', 'pro_name', 'spec_name', 'pronum', 'unit_price', 'cost', 'price', 'jiesuanstr', 'premark', 'remark', 'seller_remark', 'fx_name', 'fx_tel', 'dianpu_name']; // 对应表格输出的数据
              var list = response.data.msg;
              var data = _this25.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '宠品仓_导出订单_' + '姓名_' + _this25.adrname + '_' + '开始时间_' + _this25.beginTime + '_' + '结束时间_' + _this25.endTime + '_' + '订单状态_' + _this25.orderStatusExcel + '_' + '店铺ID_' + _this25.selectDianpu + '_' + '导出时间_' + new Date().toLocaleString()); //对应下载文件的名字
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
          } else {
            _this25.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        } else {
          _this25.$message({
            message: '无数据，请联系管理员！',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this25.$message({
          message: '导出异常，请联系管理员！',
          type: 'error'
        });
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },

    // 拆单
    chaiDan: function chaiDan(row) {
      var _this26 = this;

      this.$confirm('是否确定拆单？', '提示', {}).then(function () {
        _this26.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/part_deliver/' + row.id + '/1/3').then(function (response) {
          if (!response.data.state) {
            _this26.$message({
              message: '拆单失败，请联系管理员',
              type: 'warning'
            });
          }
          _this26.refundVisible = false;
          _this26.search();
        }).catch(function (error) {
          console.log(error);
          _this26.$message({
            message: '拆单异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    // 拆单规则
    chaidanGuize: function chaidanGuize(row) {
      this.chaidanVisbile = true;
      this.orderIds = row.order_ids;
      this.id = row.id;
      this.getOrderProName();
    },

    // 取消拆单
    cancelChaidan: function cancelChaidan(row) {
      var _this27 = this;

      this.$confirm('是否取消拆单？', '提示', {}).then(function () {
        _this27.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/part_deliver/' + row.id + '/-1/2').then(function (response) {
          if (!response.data.state) {
            _this27.$message({
              message: '取消拆单失败，请联系管理员',
              type: 'warning'
            });
          } else {
            _this27.$axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/delete/wuliu/' + row.order_num).then(function (response) {
              if (response.data.state) {
                _this27.$message({
                  message: '取消成功！',
                  type: 'success'
                });
                _this27.refundVisible = false;
                _this27.search();
              }
            }).catch(function (error) {
              console.log(error);
              _this27.$message({
                message: '取消拆单异常，请联系管理员',
                type: 'error'
              });
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this27.$message({
            message: '取消拆单异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    //修改规格
    editSpecHandler: function editSpecHandler(proid) {
      this.$router.push("/goods/prospec/" + proid);
    },
    syncSellingPrice: function syncSellingPrice(pro_id) {
      var _this28 = this;

      this.$confirm('确认同步售价吗？', '提示', {}).then(function () {

        _this28.$axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/product/syncsellingprice/' + pro_id).then(function (response) {
          var data = response.data;
          if (data.state) {
            _this28.$message({
              message: '复制成功',
              type: 'success'
            });
          } else {
            _this28.$message({
              message: '同步售价失败',
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this28.$message({
            message: '同步售价异常，请联系管理员',
            type: 'error'
          });
        });
      });
    },

    // 拆单
    chaidanSubmit: function chaidanSubmit() {
      var _this29 = this;

      var idArr = [],
          ids = '';
      if (this.selectGoodsData.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectGoodsData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            idArr.push(item.split('-')[1]);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        ids = idArr.toString();
        this.$axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/chaidan/' + this.id + '/' + ids).then(function (response) {
          if (!response.data.state) {
            _this29.$message({
              message: '拆单失败，请联系管理员',
              type: 'warning'
            });
          } else {
            _this29.$message({
              message: '拆单成功',
              type: 'success'
            });
            _this29.selectGoodsData = [];
          }
        }).catch(function (error) {
          console.log(error);
          _this29.$message({
            message: '拆单异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
    cancelChaidanSubmit: function cancelChaidanSubmit() {
      var _this30 = this;

      this.$confirm('是否确认所有操作完成？', '提示', {}).then(function () {
        _this30.chaidanVisbile = false;
      });
    },

    //提交批量物流
    batchWuliuSubmit: function batchWuliuSubmit() {
      var _this31 = this;

      this.$axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/order/batchwuliu/' + this.batchWulius).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this31.$message({
            message: '提交成功！',
            type: 'success'
          });
          _this31.batchWulius = '';
          _this31.batchWuliuVisible = false;
          _this31.search();
        } else {
          _this31.$message({
            message: '提交批量物流失败，请联系管理员' + response.data.msg,
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this31.$message({
          message: '提交批量物流异常，请联系管理员',
          type: 'error'
        });
      });
    },
    getDianpuList: function getDianpuList() {
      var _this32 = this;

      this.$axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].api_url + '/dianpu/list').then(function (response) {
        var data = response.data;
        if (data.state) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.msg), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              _this32.dianpuList.push({
                name: item.dianpu_name,
                value: item.id
              });
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else {
          _this32.$message({
            message: '获取店铺失败',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this32.$message({
          message: '获取店铺异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },
  created: function created() {
    this.usid = parseInt(this.$route.params.usid);
    this.orderNum = this.$route.params.orderNum;
    this.search();
    this.getDianpuList();
  }
});

/***/ }),

/***/ "f/Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spider_vue__ = __webpack_require__("t1Vg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a312444_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_spider_vue__ = __webpack_require__("/QBi");
function injectStyle (ssrContext) {
  __webpack_require__("h7DN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a312444"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a312444_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_spider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fAMr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"编号","prop":"brand_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"品牌名","prop":"brand_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),(scope.row.status == 1)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.deleteHandler(scope.row)}}},[_vm._v("恢复")]):_vm._e(),_vm._v(" "),(scope.row.is_monitor == 0)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.monitorHandler(scope.row)}}},[_vm._v("加入监控")]):_vm._e(),_vm._v(" "),(scope.row.is_monitor == 1)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.monitorHandler(scope.row)}}},[_vm._v("取消监控")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"品牌名","prop":"brand_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.brand_name),callback:function ($$v) {_vm.addForm.brand_name=$$v},expression:"addForm.brand_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"品牌图片","prop":"pic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me/","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"品牌名","prop":"brand_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.brand_name),callback:function ($$v) {_vm.editForm.brand_name=$$v},expression:"editForm.brand_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"品牌图片","prop":"pic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fvT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"商品编号","prop":"pro_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品名称","prop":"pro_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"首页分类","prop":"category_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分类","prop":"sec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.proStatus[scope.row.pro_status]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"推荐状态","prop":"recommend","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.recommendStatus[scope.row.recommend]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"发货方式","prop":"is_oversea","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isoverseaStatus[scope.row.is_oversea]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"备注","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.editSpecHandler(scope.row.pro_id)}}},[_vm._v("修改规格")])]}}])})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增","size":"large"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"商品名称","prop":"pro_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.pro_name),callback:function ($$v) {_vm.addForm.pro_name=$$v},expression:"addForm.pro_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"品牌","prop":"brand_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.brand_id),callback:function ($$v) {_vm.addForm.brand_id=$$v},expression:"addForm.brand_id"}},_vm._l((_vm.brand),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首页分类","prop":"category_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.category_id),callback:function ($$v) {_vm.addForm.category_id=$$v},expression:"addForm.category_id"}},_vm._l((_vm.indexcategory),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"二级分类","prop":"sec_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.sec_id),callback:function ($$v) {_vm.addForm.sec_id=$$v},expression:"addForm.sec_id"}},_vm._l((_vm.secondMenu),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"重量","prop":"weight"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.weight),callback:function ($$v) {_vm.addForm.weight=$$v},expression:"addForm.weight"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"适用什么宠物","prop":"suit_pet"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.suit_pet),callback:function ($$v) {_vm.addForm.suit_pet=$$v},expression:"addForm.suit_pet"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品主图","prop":"pro_mainpic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.mainHandleSuccess,"on-error":_vm.mainHandleError,"before-upload":_vm.mainBeforeUpload,"data":_vm.uploadForm}},[(_vm.mainPicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.mainPicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品图片","prop":"pro_pic"}},[_c('el-upload',{attrs:{"action":"https://up.qbox.me","on-success":_vm.uploadPro,"on-error":_vm.uploadError,"on-remove":_vm.removePicPro,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm,"file-list":_vm.fileListPro,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品详情图片","prop":"prointro_pic"}},[_c('el-upload',{attrs:{"action":"https://up.qbox.me","on-success":_vm.uploadProintro,"on-error":_vm.uploadError,"on-remove":_vm.removePicProintro,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm,"file-list":_vm.fileListProintro,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品销量","prop":"prosales"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.prosales),callback:function ($$v) {_vm.addForm.prosales=$$v},expression:"addForm.prosales"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品状态","prop":"pro_status"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.pro_status),callback:function ($$v) {_vm.addForm.pro_status=$$v},expression:"addForm.pro_status"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"推荐状态","prop":"recommend"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.recommend),callback:function ($$v) {_vm.addForm.recommend=$$v},expression:"addForm.recommend"}},_vm._l((_vm.recommendStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"UPC","prop":"upc"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.upc),callback:function ($$v) {_vm.addForm.upc=$$v},expression:"addForm.upc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备案价","prop":"beianjia"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.beianjia),callback:function ($$v) {_vm.addForm.beianjia=$$v},expression:"addForm.beianjia"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"原产地","prop":"origin_place"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.origin_place),callback:function ($$v) {_vm.addForm.origin_place=$$v},expression:"addForm.origin_place"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"仓库","prop":"is_oversea"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.is_oversea),callback:function ($$v) {_vm.addForm.is_oversea=$$v},expression:"addForm.is_oversea"}},_vm._l((_vm.overseaArr),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加入购物车","prop":"add_cart"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.add_cart),callback:function ($$v) {_vm.addForm.add_cart=$$v},expression:"addForm.add_cart"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"五件批发","prop":"five_pifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.five_pifa),callback:function ($$v) {_vm.addForm.five_pifa=$$v},expression:"addForm.five_pifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"一件代发","prop":"one_daifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.one_daifa),callback:function ($$v) {_vm.addForm.one_daifa=$$v},expression:"addForm.one_daifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否包邮","prop":"is_baoyou"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.addForm.is_baoyou),callback:function ($$v) {_vm.addForm.is_baoyou=$$v},expression:"addForm.is_baoyou"}})],1),_vm._v(" "),(_vm.addForm.is_baoyou === '0')?_c('el-form-item',{attrs:{"label":"快递模版","prop":"moban_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.moban_id),callback:function ($$v) {_vm.addForm.moban_id=$$v},expression:"addForm.moban_id"}},_vm._l((_vm.mobanArr),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属店铺","prop":"dianpu_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.addForm.dianpu_id),callback:function ($$v) {_vm.addForm.dianpu_id=$$v},expression:"addForm.dianpu_id"}},_vm._l((_vm.dianpuList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('div',{staticClass:"spec_border"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"商品规格"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.prospecForm.spec_name),callback:function ($$v) {_vm.prospecForm.spec_name=$$v},expression:"prospecForm.spec_name"}},_vm._l((_vm.prospecArr),function(item){return _c('el-option',{key:item.label,attrs:{"label":item.label,"value":item.label,"size":"small"}})})),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必选,可新增不同规格 如 16kg 32kg  一包  两包")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"库存"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.inventory),callback:function ($$v) {_vm.prospecForm.inventory=$$v},expression:"prospecForm.inventory"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"市场价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.market_price),callback:function ($$v) {_vm.prospecForm.market_price=$$v},expression:"prospecForm.market_price"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"宠品价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.cpprice),callback:function ($$v) {_vm.prospecForm.cpprice=$$v},expression:"prospecForm.cpprice"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否默认"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.prospecForm.is_default),callback:function ($$v) {_vm.prospecForm.is_default=$$v},expression:"prospecForm.is_default"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("商品必选一个默认规格")])],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"padding":"5px 0 0 150px"},attrs:{"span":12}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.saveSpec}},[_vm._v("保存规格")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-table',{attrs:{"data":_vm.prospecTable}},[_c('el-table-column',{attrs:{"prop":"spec_name","label":"规格"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"market_price","label":"市场价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cpprice","label":"宠品价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inventory","label":"库存"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_default","label":"是否默认"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isDefault[scope.row.is_default]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","plain":true,"type":"danger"},on:{"click":function($event){_vm.deleteSpec(scope.row.id, scope.row.index)}}},[_vm._v("删除")])]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.remark),callback:function ($$v) {_vm.addForm.remark=$$v},expression:"addForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑","size":"large"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"商品名称","prop":"pro_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.pro_name),callback:function ($$v) {_vm.editForm.pro_name=$$v},expression:"editForm.pro_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"品牌","prop":"brand_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.brand_id),callback:function ($$v) {_vm.editForm.brand_id=$$v},expression:"editForm.brand_id"}},_vm._l((_vm.brand),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"首页分类","prop":"category_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.category_id),callback:function ($$v) {_vm.editForm.category_id=$$v},expression:"editForm.category_id"}},_vm._l((_vm.indexcategory),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"二级分类","prop":"sec_id"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.sec_id),callback:function ($$v) {_vm.editForm.sec_id=$$v},expression:"editForm.sec_id"}},_vm._l((_vm.secondMenu),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"重量","prop":"weight"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.weight),callback:function ($$v) {_vm.editForm.weight=$$v},expression:"editForm.weight"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"适用什么宠物","prop":"suit_pet"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.suit_pet),callback:function ($$v) {_vm.editForm.suit_pet=$$v},expression:"editForm.suit_pet"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品主图","prop":"pro_mainpic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.mainHandleSuccess,"on-error":_vm.mainHandleError,"before-upload":_vm.mainBeforeUpload,"data":_vm.uploadForm}},[(_vm.mainPicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.mainPicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品图片","prop":"pro_pic"}},[_c('el-upload',{attrs:{"action":"https://up.qbox.me","on-success":_vm.uploadPro,"on-error":_vm.uploadError,"on-remove":_vm.removePicPro,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm,"file-list":_vm.fileListPro,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品详情图片","prop":"prointro_pic"}},[_c('el-upload',{attrs:{"action":"https://up.qbox.me","on-success":_vm.uploadProintro,"on-error":_vm.uploadError,"on-remove":_vm.removePicProintro,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm,"file-list":_vm.fileListProintro,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品销量","prop":"prosales"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.prosales),callback:function ($$v) {_vm.editForm.prosales=$$v},expression:"editForm.prosales"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品状态","prop":"pro_status"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.pro_status),callback:function ($$v) {_vm.editForm.pro_status=$$v},expression:"editForm.pro_status"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"推荐状态","prop":"recommend"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.recommend),callback:function ($$v) {_vm.editForm.recommend=$$v},expression:"editForm.recommend"}},_vm._l((_vm.recommendStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"UPC","prop":"upc"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.upc),callback:function ($$v) {_vm.editForm.upc=$$v},expression:"editForm.upc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备案价","prop":"beianjia"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.beianjia),callback:function ($$v) {_vm.editForm.beianjia=$$v},expression:"editForm.beianjia"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"原产地","prop":"origin_place"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.origin_place),callback:function ($$v) {_vm.editForm.origin_place=$$v},expression:"editForm.origin_place"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"仓库","prop":"is_oversea"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.is_oversea),callback:function ($$v) {_vm.editForm.is_oversea=$$v},expression:"editForm.is_oversea"}},_vm._l((_vm.overseaArr),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加入购物车","prop":"add_cart"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.add_cart),callback:function ($$v) {_vm.editForm.add_cart=$$v},expression:"editForm.add_cart"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"五件批发","prop":"five_pifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.five_pifa),callback:function ($$v) {_vm.editForm.five_pifa=$$v},expression:"editForm.five_pifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"一件代发","prop":"one_daifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.one_daifa),callback:function ($$v) {_vm.editForm.one_daifa=$$v},expression:"editForm.one_daifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否包邮","prop":"is_baoyou"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.editForm.is_baoyou),callback:function ($$v) {_vm.editForm.is_baoyou=$$v},expression:"editForm.is_baoyou"}})],1),_vm._v(" "),(_vm.editForm.is_baoyou === '0')?_c('el-form-item',{attrs:{"label":"快递模版","prop":"moban_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.moban_id),callback:function ($$v) {_vm.editForm.moban_id=$$v},expression:"editForm.moban_id"}},_vm._l((_vm.mobanArr),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属店铺","prop":"dianpu_id"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.editForm.dianpu_id),callback:function ($$v) {_vm.editForm.dianpu_id=$$v},expression:"editForm.dianpu_id"}},_vm._l((_vm.dianpuList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"size":"small"}})}))],1),_vm._v(" "),_c('div',{staticClass:"spec_border"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"商品规格"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.prospecForm.spec_name),callback:function ($$v) {_vm.prospecForm.spec_name=$$v},expression:"prospecForm.spec_name"}},_vm._l((_vm.prospecArr),function(item){return _c('el-option',{key:item.label,attrs:{"label":item.label,"value":item.label,"size":"small"}})})),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必选,可新增不同规格 如 16kg 32kg  一包  两包")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"库存"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.inventory),callback:function ($$v) {_vm.prospecForm.inventory=$$v},expression:"prospecForm.inventory"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"市场价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.market_price),callback:function ($$v) {_vm.prospecForm.market_price=$$v},expression:"prospecForm.market_price"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"宠品价"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.prospecForm.cpprice),callback:function ($$v) {_vm.prospecForm.cpprice=$$v},expression:"prospecForm.cpprice"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("必填")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否默认"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.prospecForm.is_default),callback:function ($$v) {_vm.prospecForm.is_default=$$v},expression:"prospecForm.is_default"}}),_vm._v(" "),_c('div',{staticClass:"el-form-item__error"},[_vm._v("商品必选一个默认规格")])],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"padding":"5px 0 0 150px"},attrs:{"span":12}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.saveSpec}},[_vm._v("保存规格")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-table',{attrs:{"data":_vm.prospecTable}},[_c('el-table-column',{attrs:{"prop":"spec_name","label":"规格"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"market_price","label":"市场价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cpprice","label":"宠品价"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inventory","label":"库存"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_default","label":"是否默认"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.isDefault[scope.row.is_default]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","plain":true,"type":"danger"},on:{"click":function($event){_vm.deleteSpec(scope.row.id, scope.row.index)}}},[_vm._v("删除")])]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.remark),callback:function ($$v) {_vm.editForm.remark=$$v},expression:"editForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"选择商品"},model:{value:(_vm.selectGoodsVisible),callback:function ($$v) {_vm.selectGoodsVisible=$$v},expression:"selectGoodsVisible"}},[_c('div',{staticClass:"select-goods"},[_c('el-tree',{staticClass:"goods-tree",attrs:{"highlight-current":"","data":_vm.goodsTypeData},on:{"node-click":_vm.handleNodeClick}}),_vm._v(" "),_c('div',{staticClass:"goods-data"},[(_vm.goodsData && _vm.goodsData.length > 0)?_c('el-checkbox-group',{model:{value:(_vm.selectGoodsData),callback:function ($$v) {_vm.selectGoodsData=$$v},expression:"selectGoodsData"}},_vm._l((_vm.goodsData),function(item){return _c('el-checkbox',{key:item.value,attrs:{"label":item.name+'-'+item.value}})})):_c('div',{staticClass:"no-goods"},[_vm._v("暂无数据")])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.selectGoodsSubmit}},[_vm._v("提交")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gBGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keywords_vue__ = __webpack_require__("jXwy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3895d03a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_keywords_vue__ = __webpack_require__("Y26B");
function injectStyle (ssrContext) {
  __webpack_require__("oAOm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3895d03a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keywords_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3895d03a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_keywords_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gTdx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zhuanti_vue__ = __webpack_require__("F+31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66af8065_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_zhuanti_vue__ = __webpack_require__("/NDR");
function injectStyle (ssrContext) {
  __webpack_require__("zZcF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66af8065"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zhuanti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66af8065_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_zhuanti_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h7DN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hVfv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ixB9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.addFormVisible = true}}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"名称","prop":"title","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"排序","prop":"sort","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"指向地址","prop":"href","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"状态","prop":"status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm.status[scope.row.status])+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"event_unique_key","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.pic)?_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showUploadForm(scope.row)}}},[_vm._v("修改图片")]):_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showUploadForm(scope.row)}}},[_vm._v("上传图片")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showEditForm(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),(scope.row.status == 0)?_c('el-button',{attrs:{"plain":true,"type":"danger","size":"small"},on:{"click":function($event){_vm.deleteDate(scope.row)}}},[_vm._v("删除")]):_c('el-button',{attrs:{"plain":true,"type":"danger","size":"small"},on:{"click":function($event){_vm.deleteDate(scope.row)}}},[_vm._v("恢复")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"名称","prop":"title"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.title),callback:function ($$v) {_vm.addForm.title=$$v},expression:"addForm.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"指向地址","prop":"href"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.href),callback:function ($$v) {_vm.addForm.href=$$v},expression:"addForm.href"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"排序","prop":"sort"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.sort),callback:function ($$v) {_vm.addForm.sort=$$v},expression:"addForm.sort"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"名称","prop":"title"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.title),callback:function ($$v) {_vm.editForm.title=$$v},expression:"editForm.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"指向地址","prop":"href"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.href),callback:function ($$v) {_vm.editForm.href=$$v},expression:"editForm.href"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"排序","prop":"sort"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.sort),callback:function ($$v) {_vm.editForm.sort=$$v},expression:"editForm.sort"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog-upload",attrs:{"title":"上传图片","size":"tiny"},model:{value:(_vm.uploadPicVisible),callback:function ($$v) {_vm.uploadPicVisible=$$v},expression:"uploadPicVisible"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload,"data":_vm.uploadForm}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.uploadSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spec_vue__ = __webpack_require__("XTf0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87b937ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_spec_vue__ = __webpack_require__("UoFt");
function injectStyle (ssrContext) {
  __webpack_require__("zxel")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87b937ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spec_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87b937ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_spec_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jXwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        keyword: '',
        is_hot: '0',
        is_default: '0',
        sort_order: '',
        scheme_url: '',
        channel: '0',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      isHot: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].isHot,
      isDefault: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].isDefault,
      channel: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].userChannel
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/keyword/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'error'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm);
            para.sort_order = parseInt(para.sort_order);
            para.is_hot = parseInt(para.is_hot);
            para.is_default = parseInt(para.is_default);
            para.channel = parseInt(para.channel);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/keyword', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: response.data.msg,
                  type: 'warning'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },
    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.editForm);
            para.sort_order = parseInt(para.sort_order);
            para.is_hot = parseInt(para.is_hot);
            para.is_default = parseInt(para.is_default);
            para.channel = parseInt(para.channel);
            //异步请求
            _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/keyword', para).then(function (response) {
              if (response.data.state) {
                _this3.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this3.$refs['editForm'].resetFields();
                _this3.editFormVisible = false;
                _this3.search();
              } else {
                _this3.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this3.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this3.submitLoading = false;
          });
        }
      });
    },
    deleteDate: function deleteDate(id) {
      var _this4 = this;

      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/keyword/' + id).then(function (response) {
          if (response.data.state) {
            _this4.$message({
              message: '删除成功',
              type: 'success'
            });
            _this4.search();
          } else {
            _this4.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this4.$message({
            message: '删除异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    showEditForm: function showEditForm(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.editForm.is_hot = row.is_hot.toString();
      this.editForm.is_default = row.is_default.toString();
      this.editForm.channel = row.channel.toString();
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "kYac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__ = __webpack_require__("0iuG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      recordStatus: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].status,
      selectRecordStatus: "200",
      beginTime: '',
      endTime: '',
      shopusid: '',
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 30,
      listLoading: false,
      expands: [],
      getRowKeys: function getRowKeys(row) {
        return row._id;
      },

      query: ''
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/monitor/page';
      this.beginTime = typeof this.beginTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_date_js__["a" /* formatDate */])(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
      this.endTime = typeof this.endTime != "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_date_js__["a" /* formatDate */])(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
      var query = this.beginTime + "|" + this.endTime + "|" + this.shopusid + "|" + this.selectRecordStatus + "|" + this.query;
      this.$axios.post(url, {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "lMZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":15}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.beginTime),callback:function ($$v) {_vm.beginTime=$$v},expression:"beginTime"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"请选择","size":"small"},model:{value:(_vm.selectUserLevel),callback:function ($$v) {_vm.selectUserLevel=$$v},expression:"selectUserLevel"}},[_c('el-option',{key:"200",attrs:{"label":"会员等级","value":"200"}}),_vm._v(" "),_vm._l((_vm.huiyuanLevel),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.export2Excel}},[_vm._v("导出数据")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"ID","prop":"usid","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"微信名称","prop":"name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"联系方式","prop":"tel","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"会员等级","prop":"level","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.huiyuanLevel[scope.row.level])+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"来源","prop":"channel","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.huiyuanChannel[scope.row.channel])+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺名称","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"五件批发","prop":"five_pifa","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.supportStatus[scope.row.five_pifa])+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"一件代发","prop":"one_daifa","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.supportStatus[scope.row.one_daifa])+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"购物车","prop":"add_cart","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.supportStatus[scope.row.add_cart])+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"用户状态","prop":"user_status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.verifyStatus[scope.row.user_status])+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"最近登陆","prop":"lately_at","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"审核时间","prop":"verify_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"白名单","prop":"is_white","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.is_white == 0)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("正常客户")]):_vm._e(),_vm._v(" "),(scope.row.is_white == 1)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v("白名单")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"备注","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.verify(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.view(scope.row)}}},[_vm._v("查看")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showOrder(scope.row.usid, '')}}},[_vm._v("查看订单")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"审核","size":"small"},model:{value:(_vm.verifyFormVisible),callback:function ($$v) {_vm.verifyFormVisible=$$v},expression:"verifyFormVisible"}},[_c('el-form',{ref:"userinfoForm",attrs:{"model":_vm.userinfoForm,"label-width":"200px"}},[_c('el-form-item',{attrs:{"label":"会员等级","prop":"level"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.userinfoForm.level),callback:function ($$v) {_vm.userinfoForm.level=$$v},expression:"userinfoForm.level"}},_vm._l((_vm.huiyuanLevel),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"来源","prop":"channel"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.userinfoForm.channel),callback:function ($$v) {_vm.userinfoForm.channel=$$v},expression:"userinfoForm.channel"}},_vm._l((_vm.huiyuanChannel),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"五件批发","prop":"five_pifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.five_pifa),callback:function ($$v) {_vm.userinfoForm.five_pifa=$$v},expression:"userinfoForm.five_pifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"一件代发","prop":"one_daifa"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.one_daifa),callback:function ($$v) {_vm.userinfoForm.one_daifa=$$v},expression:"userinfoForm.one_daifa"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加入购物车","prop":"add_cart"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.add_cart),callback:function ($$v) {_vm.userinfoForm.add_cart=$$v},expression:"userinfoForm.add_cart"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"审核状态","prop":"user_status"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.user_status),callback:function ($$v) {_vm.userinfoForm.user_status=$$v},expression:"userinfoForm.user_status"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否白名单","prop":"is_white"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.is_white),callback:function ($$v) {_vm.userinfoForm.is_white=$$v},expression:"userinfoForm.is_white"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","auto-complete":"off","size":"small","required":""},model:{value:(_vm.userinfoForm.remark),callback:function ($$v) {_vm.userinfoForm.remark=$$v},expression:"userinfoForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.verifySubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"查看","size":"large"},model:{value:(_vm.viewFormVisible),callback:function ($$v) {_vm.viewFormVisible=$$v},expression:"viewFormVisible"}},[_c('el-form',{ref:"userinfoForm",attrs:{"model":_vm.userinfoForm,"label-width":"100px"}},[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"微信编号","prop":"open_id"}},[_c('el-input',{model:{value:(_vm.userinfoForm.dianpu_name),callback:function ($$v) {_vm.userinfoForm.dianpu_name=$$v},expression:"userinfoForm.dianpu_name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"会员编号"}},[_c('el-input',{model:{value:(_vm.userinfoForm.name),callback:function ($$v) {_vm.userinfoForm.name=$$v},expression:"userinfoForm.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"性别"}},[_c('el-input',{model:{value:(_vm.sex),callback:function ($$v) {_vm.sex=$$v},expression:"sex"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"联系方式"}},[_c('el-input',{model:{value:(_vm.userinfoForm.tel),callback:function ($$v) {_vm.userinfoForm.tel=$$v},expression:"userinfoForm.tel"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"邮箱"}},[_c('el-input',{model:{value:(_vm.userinfoForm.email),callback:function ($$v) {_vm.userinfoForm.email=$$v},expression:"userinfoForm.email"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"用户等级"}},[_c('el-input',{model:{value:(_vm.level),callback:function ($$v) {_vm.level=$$v},expression:"level"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"来源"}},[_c('el-input',{model:{value:(_vm.channel),callback:function ($$v) {_vm.channel=$$v},expression:"channel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"微信号"}},[_c('el-input',{model:{value:(_vm.userinfoForm.wechat_num),callback:function ($$v) {_vm.userinfoForm.wechat_num=$$v},expression:"userinfoForm.wechat_num"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"淘宝店/实体店"}},[_c('el-input',{model:{value:(_vm.userinfoForm.dianpu_name),callback:function ($$v) {_vm.userinfoForm.dianpu_name=$$v},expression:"userinfoForm.dianpu_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"地址"}},[_c('el-input',{model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证"}},[_c('el-input',{model:{value:(_vm.userinfoForm.card_num),callback:function ($$v) {_vm.userinfoForm.card_num=$$v},expression:"userinfoForm.card_num"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"营业图片"}},[(_vm.userinfoForm.yingye_pic)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.userinfoForm.yingye_pic}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"五件批发"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.five_pifa),callback:function ($$v) {_vm.userinfoForm.five_pifa=$$v},expression:"userinfoForm.five_pifa"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"一件代发"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.one_daifa),callback:function ($$v) {_vm.userinfoForm.one_daifa=$$v},expression:"userinfoForm.one_daifa"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"加入购物车"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.add_cart),callback:function ($$v) {_vm.userinfoForm.add_cart=$$v},expression:"userinfoForm.add_cart"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"用户状态"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.user_status),callback:function ($$v) {_vm.userinfoForm.user_status=$$v},expression:"userinfoForm.user_status"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"是否白名单"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.userinfoForm.is_white),callback:function ($$v) {_vm.userinfoForm.is_white=$$v},expression:"userinfoForm.is_white"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.userinfoForm.remark),callback:function ($$v) {_vm.userinfoForm.remark=$$v},expression:"userinfoForm.remark"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m+Rc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list1_vue__ = __webpack_require__("JX0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6f533aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_list1_vue__ = __webpack_require__("JiTn");
function injectStyle (ssrContext) {
  __webpack_require__("0efo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6f533aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_list1_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mBUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_vue__ = __webpack_require__("Bzfq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0184ba67_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_brand_vue__ = __webpack_require__("fAMr");
function injectStyle (ssrContext) {
  __webpack_require__("xB8M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0184ba67"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0184ba67_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_brand_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "neEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: this.$cookie.get('user') ? this.$cookie.get('user').split('|')[1] : '',
      isCollapse: false,
      menuClass: 'content-menu',
      menuIcon: 'el-icon-caret-left',
      containerClass: 'content-container'
    };
  },

  methods: {
    manyCommand: function manyCommand(command) {
      switch (command) {
        case "loginout":
          this.$cookie.delete('user');
          this.$router.push({ path: '/login' });
          break;
      }
    },
    toggleSidebar: function toggleSidebar() {
      if (this.isCollapse) {
        this.isCollapse = false;
        this.menuIcon = 'el-icon-caret-left';
        this.menuClass = 'content-menu';
        this.containerClass = 'content-container';
      } else {
        this.isCollapse = true;
        this.menuIcon = 'el-icon-caret-right';
        this.menuClass = 'content-menu content-menu-width';
        this.containerClass = 'content-container container-left';
      }
    }
  }
});

/***/ }),

/***/ "oAOm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "owsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("sisA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1237a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("ixB9");
function injectStyle (ssrContext) {
  __webpack_require__("Khrh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd1237a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1237a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q0vN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":20}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.beginTime),callback:function ($$v) {_vm.beginTime=$$v},expression:"beginTime"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"请选择","size":"small"},model:{value:(_vm.orderStatusExcel),callback:function ($$v) {_vm.orderStatusExcel=$$v},expression:"orderStatusExcel"}},[_c('el-option',{key:"200",attrs:{"label":"全部","value":"200"}}),_vm._v(" "),_vm._l((_vm.orderStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"店铺","size":"small"},model:{value:(_vm.selectDianpu),callback:function ($$v) {_vm.selectDianpu=$$v},expression:"selectDianpu"}},[_c('el-option',{key:"0",attrs:{"label":"无","value":"0"}}),_vm._v(" "),_vm._l((_vm.dianpuList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.value,"size":"small"}})})],2),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-input',{attrs:{"placeholder":"客户姓名(仅查询)","size":"small"},model:{value:(_vm.adrname),callback:function ($$v) {_vm.adrname=$$v},expression:"adrname"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-input',{attrs:{"placeholder":"手机号(仅查询)","size":"small"},model:{value:(_vm.telphone),callback:function ($$v) {_vm.telphone=$$v},expression:"telphone"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-input',{attrs:{"placeholder":"物流单号(仅查询)","size":"small"},model:{value:(_vm.wuliudanhao),callback:function ($$v) {_vm.wuliudanhao=$$v},expression:"wuliudanhao"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.mail}},[_vm._v("导出邮件")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.suppsumry}},[_vm._v("供应概要")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.export2Excel}},[_vm._v("导出数据")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.batchWuliu}},[_vm._v("批量物流")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":"订单编号","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"row-key":_vm.getRowKeys,"expand-row-keys":_vm.expands},on:{"expand":_vm.expand}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"订单状态","name":"1"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-steps',{attrs:{"space":100,"active":_vm.getOrderStatus(scope.row.order_status),"finish-status":"success"}},[_c('el-step',{attrs:{"title":"待支付"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"待发货"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已发货"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已收货"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已完成"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"退货"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"已退款"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"失效"}})],1)],1)]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"商品列表","name":"2"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-table',{attrs:{"data":_vm.tableDataProduct,"border":""}},[_c('el-table-column',{attrs:{"label":"商品图片","prop":"pro_mianpic","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var $index = ref.$index;
return [_c('img',{staticStyle:{"height":"100px"},attrs:{"src":row.pro_mianpic,"alt":""}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"数量","prop":"pronum","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.pronum == 1)?_c('el-button',{attrs:{"type":"primary","size":"large"}},[_vm._v(_vm._s(scope.row.pronum))]):_vm._e(),_vm._v(" "),(scope.row.pronum == 2)?_c('el-button',{attrs:{"type":"danger","size":"large"}},[_vm._v(" "+_vm._s(scope.row.pronum))]):_vm._e(),_vm._v(" "),(scope.row.pronum > 2)?_c('el-button',{attrs:{"type":"warning","size":"large"}},[_vm._v(" "+_vm._s(scope.row.pronum))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"商品名称","prop":"pro_name","align":"center","min-width":500}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"价格","prop":"price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"核销","prop":"cost","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"规格","prop":"spec_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.editSpecHandler(scope.row.pro_id)}}},[_vm._v("修改规格")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.syncSellingPrice(scope.row.pro_id)}}},[_vm._v("同步售价")])]}}])})],1)],1)]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"物流状态","name":"3"}},[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.wuliuAction),callback:function ($$v) {_vm.wuliuAction=$$v},expression:"wuliuAction"}},_vm._l((_vm.wuliuStatusTabs),function(item,index){return _c('el-tab-pane',{key:index,staticStyle:{"text-align":"center"},attrs:{"name":item}},[_c('template',{attrs:{"slot":"label"},slot:"label"},[_c('a',{staticStyle:{"color":"inherit","text-decoration":"none","display":"block"},attrs:{"href":'https://www.baidu.com/s?wd=' + item,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n          "+_vm._s(item)+"\n        ")])]),_vm._v(" "),(_vm.wuliuInfos && _vm.wuliuInfos.length > 0)?_c('div',{staticStyle:{"text-align":"left"}},[_vm._v("\n        物流信息：\n        "),_vm._l((_vm.wuliuInfos),function(info,infoIndex){return _c('p',{key:infoIndex},[_vm._v("\n          "+_vm._s(info.context)+" "+_vm._s(info.time)+"\n        ")])})],2):_vm._e()],2)}))],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"用户信息","name":"4"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("用户ID：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.usid))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("昵称：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.name))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("联系方式：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[(_vm.userInfo.tel)?_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.tel))]):_c('div',{staticClass:"user-font"},[_vm._v("暂无")])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("店铺：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[(_vm.userInfo.dianpu_name)?_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.dianpu_name))]):_c('div',{staticClass:"user-font"},[_vm._v("暂无")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("创建时间：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userInfo.create_time))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("渠道：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.userChannel[_vm.userInfo.channel]))])])],1)],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"收货地址","name":"5"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("收货人姓名：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.addr_name))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("联系方式：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.tel))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("省市县：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.sheng)+_vm._s(scope.row.shi)+_vm._s(scope.row.xian))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("详细地址：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.addr_detail))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("地址检测：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[(scope.row.addr_detail.split(' ').length > 1)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v("地址异常")]):_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("地址正常")])],1),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("身份证：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(scope.row.card_num))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("地址汇总：")]),_vm._v(" "),_c('el-col',{attrs:{"span":20}},[_c('div',{staticClass:"user-font"},[_vm._v("\n      "+_vm._s(scope.row.addr_name)+" "+_vm._s(scope.row.tel)+" "+_vm._s(scope.row.sheng)+" "+_vm._s(scope.row.shi)+" "+_vm._s(scope.row.xian)+" "+_vm._s(scope.row.addr_detail)+" "+_vm._s(scope.row.card_num)+"\n    ")])])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"订单编号","prop":"order_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"开始时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"收件人","prop":"addr_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"手机号","prop":"tel","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"省份","prop":"sheng","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"运费","prop":"yunfei","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"应付款","prop":"ordersum","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"实付款","prop":"act_ordersum","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"成本","prop":"all_cost","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"产出额","prop":"profit","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"利润率","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.numFilter(scope.row.profit/scope.row.act_ordersum*100)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"订单状态","prop":"order_status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.order_status == 6)?_c('el-button',{attrs:{"type":"danger","size":"small"}},[_vm._v("售后中")]):(scope.row.order_status == 2)?_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("待发货")]):(scope.row.order_status == 3)?_c('el-button',{attrs:{"type":"success","size":"small"}},[_vm._v("收货中")]):_c('el-button',{attrs:{"type":"info","size":"small"}},[_vm._v(_vm._s(_vm.orderStatus[scope.row.order_status]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流单位","prop":"wuliu_company","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"付款时间","prop":"pay_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分销","prop":"fen_xiao_dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"供应","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"流水号","prop":"transaction_id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"买家留言","prop":"remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"卖家留言","prop":"seller_reply","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"自己备注","prop":"seller_remark","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"event_unique_key","align":"center","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[(scope.row.order_status === 1)?_c('div',[_c('el-button',{attrs:{"type":"danger","size":"medium"},on:{"click":function($event){_vm.payOrder(scope.row.id)}}},[_vm._v("确认支付")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.closeOrder(scope.row.id)}}},[_vm._v("取消订单")])],1):(scope.row.order_status === 2)?_c('div',[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.openWuliu(scope.row)}}},[_vm._v("添加物流")]),_vm._v(" "),(scope.row.part_deliver !== 1)?_c('el-button',{attrs:{"type":"danger","size":"medium"},on:{"click":function($event){_vm.chaiDan(scope.row)}}},[_vm._v("\n                拆分订单\n            ")]):_vm._e(),_vm._v(" "),(scope.row.seller_remark !== '延迟发货' && scope.row.transaction_id !== '')?_c('el-button',{attrs:{"type":"success","size":"medium"},on:{"click":function($event){_vm.delayFahuo(scope.row.id)}}},[_vm._v("\n                延迟发货\n            ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(scope.row.order_status === 3)?_c('div',[(scope.row.part_deliver === 0)?_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.resetWuliu(scope.row)}}},[_vm._v("重置物流")]):_vm._e(),_vm._v(" "),(scope.row.part_deliver === 1)?_c('el-button',{attrs:{"type":"success","size":"medium"},on:{"click":function($event){_vm.chaidanGuize(scope.row)}}},[_vm._v("设置拆单规则")]):_vm._e(),_vm._v(" "),(scope.row.part_deliver === 1)?_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.chaidanXiangxi(scope.row)}}},[_vm._v("添加拆单物流")]):_vm._e()],1):(scope.row.part_deliver === 1)?_c('div',[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.chaidanXiangxi(scope.row)}}},[_vm._v("查看拆单物流")])],1):_vm._e(),_vm._v(" "),(scope.row.part_deliver === 1)?_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.cancelChaidan(scope.row)}}},[_vm._v("\n            取消拆单\n        ")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.openRemark(scope.row)}}},[_vm._v("查看备注")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.afterMarket(scope.row.id)}}},[_vm._v("申请售后")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.balanceaccounts(scope.row.id)}}},[_vm._v("平账订单")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.recalculation(scope.row.id)}}},[_vm._v("重新核算")])],1)]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"查看备注"},model:{value:(_vm.seeRemarkVisible),callback:function ($$v) {_vm.seeRemarkVisible=$$v},expression:"seeRemarkVisible"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("买家留言：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',[_vm._v(_vm._s(_vm.remark))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("卖家留言：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"type":"textarea","rows":"3","placeholder":"请输入留言"},model:{value:(_vm.sellerReply),callback:function ($$v) {_vm.sellerReply=$$v},expression:"sellerReply"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("自己备注：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"type":"textarea","rows":"3","placeholder":"请输入备注"},model:{value:(_vm.sellerRemark),callback:function ($$v) {_vm.sellerRemark=$$v},expression:"sellerRemark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.remarkSubmit}},[_vm._v("确认")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"添加物流"},model:{value:(_vm.addWuliuVisible),callback:function ($$v) {_vm.addWuliuVisible=$$v},expression:"addWuliuVisible"}},[_c('el-form',{ref:"wuliuForm",attrs:{"model":_vm.wuliuForm,"label-width":"150px"}},[_c('el-form-item',{attrs:{"label":"订单编号","prop":"ordernum"}},[_c('el-input',{attrs:{"disabled":true,"auto-complete":"off","size":"small","required":""},model:{value:(_vm.wuliuForm.ordernum),callback:function ($$v) {_vm.wuliuForm.ordernum=$$v},expression:"wuliuForm.ordernum"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物流单位","prop":"wuliucompany"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.wuliuForm.wuliucompany),callback:function ($$v) {_vm.wuliuForm.wuliucompany=$$v},expression:"wuliuForm.wuliucompany"}},_vm._l((_vm.wuliuCompany),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item,"size":"small"}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物流编号","prop":"wuliunum"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.wuliuForm.wuliunum),callback:function ($$v) {_vm.wuliuForm.wuliunum=$$v},expression:"wuliuForm.wuliunum"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"large","loading":_vm.submitLoading},on:{"click":_vm.wuliuSubmit}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改价格","size":"tiny"},model:{value:(_vm.updatePriceVisible),callback:function ($$v) {_vm.updatePriceVisible=$$v},expression:"updatePriceVisible"}},[_c('el-row',[_c('el-col',{staticStyle:{"line-height":"30px"},attrs:{"offset":1,"span":6}},[_vm._v("实际付款：")]),_vm._v(" "),_c('el-col',{attrs:{"span":17}},[_c('el-input',{attrs:{"placeholder":"请输入价格","size":"small"},model:{value:(_vm.actOrdersum),callback:function ($$v) {_vm.actOrdersum=$$v},expression:"actOrdersum"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.updatePrice}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改收货地址","size":"small"},model:{value:(_vm.updateAddressVisible),callback:function ($$v) {_vm.updateAddressVisible=$$v},expression:"updateAddressVisible"}},[_c('el-form',{ref:"addressForm",attrs:{"model":_vm.addressForm,"label-width":"150px"}},[_c('el-form-item',{attrs:{"label":"姓名","prop":"addr_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.addr_name),callback:function ($$v) {_vm.addressForm.addr_name=$$v},expression:"addressForm.addr_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系方式","prop":"tel"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.tel),callback:function ($$v) {_vm.addressForm.tel=$$v},expression:"addressForm.tel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"地址","prop":"sheng"}},[_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.sheng),callback:function ($$v) {_vm.addressForm.sheng=$$v},expression:"addressForm.sheng"}})],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2,"offset":1}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.shi),callback:function ($$v) {_vm.addressForm.shi=$$v},expression:"addressForm.shi"}})],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2,"offset":1}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.xian),callback:function ($$v) {_vm.addressForm.xian=$$v},expression:"addressForm.xian"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"详细地址","prop":"addr_detail"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.addr_detail),callback:function ($$v) {_vm.addressForm.addr_detail=$$v},expression:"addressForm.addr_detail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号","prop":"card_num"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addressForm.card_num),callback:function ($$v) {_vm.addressForm.card_num=$$v},expression:"addressForm.card_num"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证","prop":"card_pic"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload1,"data":_vm.uploadForm}},[(_vm.imageUrl1)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl1}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})]),_vm._v(" "),_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload2,"data":_vm.uploadForm}},[(_vm.imageUrl2)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl2}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.updateAddress}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"退款确认","size":"tiny"},model:{value:(_vm.refundVisible),callback:function ($$v) {_vm.refundVisible=$$v},expression:"refundVisible"}},[_c('el-row',[_c('el-col',{attrs:{"offset":1,"span":6}},[_vm._v("退款金额：")]),_vm._v(" "),_c('el-col',{attrs:{"span":17}},[_vm._v("\n          "+_vm._s(_vm.back_fee)+"\n        ")])],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding-top":"10px"}},[_c('el-col',{attrs:{"offset":1,"span":6}},[_vm._v("退款原因：")]),_vm._v(" "),_c('el-col',{attrs:{"span":17}},[_vm._v("\n          "+_vm._s(_vm.reason)+"\n        ")])],1),_vm._v(" "),(_vm.isRefund == 1)?_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.refundSubmit}},[_vm._v("确认")])],1):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"拆单规则","close-on-click-modal":false,"close-on-press-escape":false},model:{value:(_vm.chaidanVisbile),callback:function ($$v) {_vm.chaidanVisbile=$$v},expression:"chaidanVisbile"}},[_c('el-row',{staticStyle:{"margin-bottom":"20px","padding-bottom":"15px","border-bottom":"1px dashed #d1dbe5"}},[_c('el-col',{staticStyle:{"background-color":"#f9fafc","padding":"10px","border-radius":"4px"},attrs:{"span":24}},[_c('span',{staticStyle:{"margin-right":"15px","font-weight":"600","color":"#48576a"}},[_vm._v("单品自动拆单:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#606266","font-size":"13px"}},[_vm._v("请在下方勾选【1个】商品，并输入拆分包裹数：")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"110px","margin":"0 10px"},attrs:{"min":2,"max":10,"step":1,"step-strictly":"","size":"small"},model:{value:(_vm.autoSplitNum),callback:function ($$v) {_vm.autoSplitNum=$$v},expression:"autoSplitNum"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#606266","font-size":"14px","margin-right":"15px"}},[_vm._v("个包裹")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small"},on:{"click":_vm.autoChaidanSubmit}},[_vm._v("一键自动拆单")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticStyle:{"margin-bottom":"10px"},attrs:{"span":24}},[_c('span',{staticStyle:{"font-weight":"600","color":"#48576a"}},[_vm._v("选择商品 (支持单品自动拆单 / 多品手动组合拆单):")])]),_vm._v(" "),_c('el-col',{staticClass:"goods-data",attrs:{"span":24}},[_c('el-checkbox-group',{model:{value:(_vm.selectGoodsData),callback:function ($$v) {_vm.selectGoodsData=$$v},expression:"selectGoodsData"}},_vm._l((_vm.goodsData),function(item,i){return _c('el-checkbox',{key:item,attrs:{"label":item}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.chaidanSubmit}},[_vm._v("手动组合拆单")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.cancelChaidanSubmit}},[_vm._v("关闭")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量物流"},model:{value:(_vm.batchWuliuVisible),callback:function ($$v) {_vm.batchWuliuVisible=$$v},expression:"batchWuliuVisible"}},[_c('el-row',{staticStyle:{"margin-top":"30px"}},[_c('el-col',{attrs:{"offset":2,"span":4}},[_vm._v("批量物流：")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-input',{attrs:{"type":"textarea","rows":"25","placeholder":"只支持【非拆单】物流，订单号|物流公司|运单号（每条按逗号隔开，快递公司必须按例子的名称）\n            1524861378848092680|UEQ|3934980308849,\n            1524861378848092680|中通速递|3934980308849,\n            1524861378848092680|圆通速递|3934980308849,\n            1524861378848092680|天天快递|3934980308849,\n            1524861378848092680|韵达快递|3934980308849,"},model:{value:(_vm.batchWulius),callback:function ($$v) {_vm.batchWulius=$$v},expression:"batchWulius"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":_vm.batchWuliuSubmit}},[_vm._v("确认")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"查看图片","label-width":"200px","size":"tiny"},model:{value:(_vm.viewFormVisible),callback:function ($$v) {_vm.viewFormVisible=$$v},expression:"viewFormVisible"}},[(_vm.pro_mainpic)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.pro_mainpic}}):_vm._e()]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"拆单物流管理","visible":_vm.splitWuliuDialogVisible,"width":"85%"},on:{"update:visible":function($event){_vm.splitWuliuDialogVisible=$event}}},[_c('div',{staticStyle:{"margin-bottom":"15px"}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showSubBatchWuliu}},[_vm._v("批量修改物流")])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.subListLoading),expression:"subListLoading"}],attrs:{"data":_vm.subTableData,"border":""}},[_c('el-table-column',{attrs:{"label":"订单编号","prop":"order_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"子订单编号","prop":"suborder_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流单位","prop":"wuliu_company","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流编号","prop":"wuliu_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showSubWuliu(scope.row)}}},[_vm._v("修改物流")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","size":"small"}},[_c('a',{staticStyle:{"color":"inherit","text-decoration":"none"},attrs:{"href":'https://www.baidu.com/s?wd=' + scope.row.wuliu_num,"target":"_blank"}},[_vm._v("\n      查看物流\n    ")])])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.splitWuliuDialogVisible = false ; _vm.search()}}},[_vm._v("关闭")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改物流","visible":_vm.subWuliuVisible,"append-to-body":true,"width":"40%"},on:{"update:visible":function($event){_vm.subWuliuVisible=$event}}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"选择物流单位"},model:{value:(_vm.subWuliuCom),callback:function ($$v) {_vm.subWuliuCom=$$v},expression:"subWuliuCom"}},_vm._l((_vm.wuliuCompany),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}))],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"15px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-input',{attrs:{"placeholder":"物流编号"},model:{value:(_vm.subWuliuNum),callback:function ($$v) {_vm.subWuliuNum=$$v},expression:"subWuliuNum"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.subWuliuVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.subEditSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量发货 / 修改物流","visible":_vm.subBatchWuliuVisible,"width":"65%","append-to-body":true},on:{"update:visible":function($event){_vm.subBatchWuliuVisible=$event}}},[_c('el-row',{staticStyle:{"margin-bottom":"15px"}},[_c('el-col',{attrs:{"span":24}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("统一物流单位：")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"280px"},attrs:{"placeholder":"选择物流单位（对以下所有订单生效）"},model:{value:(_vm.subBatchWuliuCom),callback:function ($$v) {_vm.subBatchWuliuCom=$$v},expression:"subBatchWuliuCom"}},_vm._l((_vm.wuliuCompany),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}))],1)],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.subBatchTableData,"border":"","max-height":"400"}},[_c('el-table-column',{attrs:{"label":"子订单编号","prop":"suborder_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"当前物流状态","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.wuliu_num)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("已发货")]):_c('el-tag',{attrs:{"type":"info"}},[_vm._v("未发货")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流单号","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"placeholder":"请输入物流单号","clearable":""},model:{value:(scope.row.new_wuliu_num),callback:function ($$v) {scope.row.new_wuliu_num=$$v},expression:"scope.row.new_wuliu_num"}})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{nativeOn:{"click":function($event){_vm.subBatchWuliuVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.subBatchSubmitLoading},nativeOn:{"click":function($event){_vm.subBatchEditSubmit($event)}}},[_vm._v("批量提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q83E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("5b5L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8fa1924_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("9SPL");
function injectStyle (ssrContext) {
  __webpack_require__("tAlG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8fa1924"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8fa1924_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qJjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zNqe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb81c31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("tona");
function injectStyle (ssrContext) {
  __webpack_require__("/XPq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fb81c31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb81c31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sYY/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sisA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_token_js__ = __webpack_require__("eVHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 15,
      listLoading: false,
      query: '',
      submitLoading: false,
      addFormVisible: false,
      addForm: {
        adver_id: 0,
        title: '',
        sort: 0,
        href: '',
        create_time: '',
        status: 0
      },
      editFormVisible: false,
      editForm: {},
      formRules: {},
      uploadPicVisible: false,
      showUploadList: false,
      uploadForm: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_token_js__["a" /* getQiniuToken */])(),
        key: null
      },
      adverId: 0,
      imageUrl: '',
      id: 0,
      status: __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].status
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getAdverPic(this.adverId);
    },
    getAdverPic: function getAdverPic(adverId) {
      var _this = this;

      this.listLoading = true;
      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adverpic/page', {
        "page": this.page,
        "size": this.pageSize,
        "query": adverId
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
        } else {
          _this.$message({
            message: data.msg,
            type: 'warning'
          });
        }
        _this.listLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this2.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm));
            para.sort = parseInt(para.sort);
            para.adver_id = parseInt(_this2.adverId);
            //异步请求
            _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adverpic', para).then(function (response) {
              if (response.data.state) {
                _this2.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this2.$refs['addForm'].resetFields();
                _this2.addFormVisible = false;
                _this2.search();
              } else {
                _this2.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this2.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this2.submitLoading = false;
          });
        }
      });
    },
    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.submitLoading = true;
            var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.editForm));
            para.sort = parseInt(para.sort);
            //异步请求
            _this3.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adverpic', para).then(function (response) {
              if (response.data.state) {
                _this3.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this3.$refs['editForm'].resetFields();
                _this3.editFormVisible = false;
                _this3.search();
              } else {
                _this3.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this3.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this3.submitLoading = false;
          });
        }
      });
    },
    deleteDate: function deleteDate(row) {
      var _this4 = this;

      var text = '是否删除？';
      var status = 1;
      if (row.status == 1) {
        text = '是否恢复？';
        status = 0;
      }
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adverpic/' + row.id + '/' + status).then(function (response) {
          if (response.data.state) {
            _this4.$message({
              message: '操作成功',
              type: 'success'
            });
            _this4.search();
          } else {
            _this4.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this4.$message({
            message: '操作异常，请联系管理员',
            type: 'error'
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    showEditForm: function showEditForm(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    showUploadForm: function showUploadForm(row) {
      this.uploadPicVisible = true;
      this.id = row.id;
      this.imageUrl = row.pic;
    },

    //上传图片
    beforeUpload: function beforeUpload(file) {
      var fileName = 'adver/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
      var mime = file.name.split('.')[1];
      fileName += '.' + mime;
      this.uploadForm.key = fileName;
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.imageUrl = __WEBPACK_IMPORTED_MODULE_5__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
      this.result = '上传成功';
    },
    handleError: function handleError(error, response, file) {
      this.result = error.toString();
    },

    //修改图片
    uploadSubmit: function uploadSubmit() {
      var _this5 = this;

      this.$confirm('确认提交吗？', '提示', {}).then(function () {
        _this5.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/adverpic/' + _this5.id + '?pic=' + _this5.imageUrl).then(function (response) {
          if (response.data.state) {
            _this5.$message({
              message: '提交成功',
              type: 'success'
            });
            _this5.uploadPicVisible = false;
            _this5.search();
          } else {
            _this5.$message({
              message: response.data.msg,
              type: 'error'
            });
          }
        }).catch(function (error) {
          console.log(error);
          _this5.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        });
      });
    }
  },
  created: function created() {
    this.adverId = this.$route.params.id;
    this.search();
  }
});

/***/ }),

/***/ "t1Vg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_config_basicdata_js__ = __webpack_require__("0iuG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 30,
      listLoading: false,
      expands: [],
      getRowKeys: function getRowKeys(row) {
        return row._id;
      },

      query: '',
      spiderStatus: __WEBPACK_IMPORTED_MODULE_1__static_config_basicdata_js__["a" /* default */].spiderStatus,
      spiderMode: __WEBPACK_IMPORTED_MODULE_1__static_config_basicdata_js__["a" /* default */].spiderMode

    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/spider/page';
      this.$axios.post(url, {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },


    //推荐
    setSpider: function setSpider(id, isrecommend) {
      var _this2 = this;

      this.$axios.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api_url + '/spider/status', {
        id: id,
        status: isrecommend
      }).then(function (response) {
        if (response.data.state) {
          _this2.$message({
            message: '成功!',
            type: 'success'
          });
          _this2.search();
        } else {
          _this2.$message({
            message: '失败，请联系管理员',
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$message({
          message: '异常，请联系管理员',
          type: 'error'
        });
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "tAlG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movingpin_vue__ = __webpack_require__("LBU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a84967_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_movingpin_vue__ = __webpack_require__("5IAk");
function injectStyle (ssrContext) {
  __webpack_require__("hVfv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movingpin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a84967_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_movingpin_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tPPp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tona":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addHandler}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"编号","prop":"id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"店铺名称","prop":"dianpu_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否审核","prop":"is_verify","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.verifyStatus[scope.row.is_verify]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.viewHandler(scope.row)}}},[_vm._v("查看")]),_vm._v(" "),(scope.row.is_verify == 0)?_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.verify(scope.row)}}},[_vm._v("确认审核")]):_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.verify(scope.row)}}},[_vm._v("取消审核")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增","size":"large"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"rules":_vm.formRules,"label-width":"100px"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"店铺名称","prop":"dianpu_name"}},[_c('el-input',{model:{value:(_vm.addForm.dianpu_name),callback:function ($$v) {_vm.addForm.dianpu_name=$$v},expression:"addForm.dianpu_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"店铺描述"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.addForm.dianpu_describe),callback:function ($$v) {_vm.addForm.dianpu_describe=$$v},expression:"addForm.dianpu_describe"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"公司名称"}},[_c('el-input',{model:{value:(_vm.addForm.com_name),callback:function ($$v) {_vm.addForm.com_name=$$v},expression:"addForm.com_name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"店铺图标"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.iconHandleSuccess,"on-error":_vm.iconHandleError,"before-upload":_vm.iconBeforeUpload,"data":_vm.uploadForm}},[(_vm.iconPicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.iconPicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"微信号"}},[_c('el-input',{model:{value:(_vm.addForm.wechat_num),callback:function ($$v) {_vm.addForm.wechat_num=$$v},expression:"addForm.wechat_num"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"QQ号"}},[_c('el-input',{model:{value:(_vm.addForm.qq),callback:function ($$v) {_vm.addForm.qq=$$v},expression:"addForm.qq"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"联系方式"}},[_c('el-input',{model:{value:(_vm.addForm.tel),callback:function ($$v) {_vm.addForm.tel=$$v},expression:"addForm.tel"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"邮箱"}},[_c('el-input',{model:{value:(_vm.addForm.email),callback:function ($$v) {_vm.addForm.email=$$v},expression:"addForm.email"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务开始时间"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.addForm.start_time),callback:function ($$v) {_vm.addForm.start_time=$$v},expression:"addForm.start_time"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务结束时间"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.addForm.end_time),callback:function ($$v) {_vm.addForm.end_time=$$v},expression:"addForm.end_time"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"身份证"}},[_c('el-input',{model:{value:(_vm.addForm.card_num),callback:function ($$v) {_vm.addForm.card_num=$$v},expression:"addForm.card_num"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-form-item',{attrs:{"label":"发货地","prop":"fahuodi"}},[_c('el-input',{model:{value:(_vm.addForm.fahuodi),callback:function ($$v) {_vm.addForm.fahuodi=$$v},expression:"addForm.fahuodi"}})],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"身份证正面"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.card1HandleSuccess,"on-error":_vm.card1HandleError,"before-upload":_vm.card1BeforeUpload,"data":_vm.uploadForm}},[(_vm.card1PicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.card1PicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"身份证反面"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.card2HandleSuccess,"on-error":_vm.card2HandleError,"before-upload":_vm.card2BeforeUpload,"data":_vm.uploadForm}},[(_vm.card2PicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.card2PicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"资质照片"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://up.qbox.me","show-file-list":_vm.showUploadList,"on-success":_vm.zizhiHandleSuccess,"on-error":_vm.zizhiHandleError,"before-upload":_vm.zizhiBeforeUpload,"data":_vm.uploadForm}},[(_vm.zizhiPicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.zizhiPicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"退款地址"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.addForm.tuikuan_addr),callback:function ($$v) {_vm.addForm.tuikuan_addr=$$v},expression:"addForm.tuikuan_addr"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.addForm.remark),callback:function ($$v) {_vm.addForm.remark=$$v},expression:"addForm.remark"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.submit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"查看","size":"large"},model:{value:(_vm.viewFormVisible),callback:function ($$v) {_vm.viewFormVisible=$$v},expression:"viewFormVisible"}},[_c('el-form',{ref:"dianpuForm",attrs:{"model":_vm.dianpuForm,"label-width":"100px"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"店铺名称","prop":"dianpu_name"}},[_c('el-input',{model:{value:(_vm.dianpuForm.dianpu_name),callback:function ($$v) {_vm.dianpuForm.dianpu_name=$$v},expression:"dianpuForm.dianpu_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"店铺描述"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.dianpuForm.dianpu_describe),callback:function ($$v) {_vm.dianpuForm.dianpu_describe=$$v},expression:"dianpuForm.dianpu_describe"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"公司名称"}},[_c('el-input',{model:{value:(_vm.dianpuForm.com_name),callback:function ($$v) {_vm.dianpuForm.com_name=$$v},expression:"dianpuForm.com_name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"店铺图标"}},[(_vm.dianpuForm.dianpu_ico)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.dianpuForm.dianpu_ico}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"微信号"}},[_c('el-input',{model:{value:(_vm.dianpuForm.wechat_num),callback:function ($$v) {_vm.dianpuForm.wechat_num=$$v},expression:"dianpuForm.wechat_num"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"QQ号"}},[_c('el-input',{model:{value:(_vm.dianpuForm.qq),callback:function ($$v) {_vm.dianpuForm.qq=$$v},expression:"dianpuForm.qq"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"联系方式"}},[_c('el-input',{model:{value:(_vm.dianpuForm.tel),callback:function ($$v) {_vm.dianpuForm.tel=$$v},expression:"dianpuForm.tel"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"邮箱"}},[_c('el-input',{model:{value:(_vm.dianpuForm.email),callback:function ($$v) {_vm.dianpuForm.email=$$v},expression:"dianpuForm.email"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务开始时间"}},[_c('el-input',{model:{value:(_vm.dianpuForm.start_time),callback:function ($$v) {_vm.dianpuForm.start_time=$$v},expression:"dianpuForm.start_time"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务结束时间"}},[_c('el-input',{model:{value:(_vm.dianpuForm.end_time),callback:function ($$v) {_vm.dianpuForm.end_time=$$v},expression:"dianpuForm.end_time"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"身份证"}},[_c('el-input',{model:{value:(_vm.dianpuForm.card_num),callback:function ($$v) {_vm.dianpuForm.card_num=$$v},expression:"dianpuForm.card_num"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-form-item',{attrs:{"label":"发货地","prop":"fahuodi"}},[_c('el-input',{model:{value:(_vm.dianpuForm.fahuodi),callback:function ($$v) {_vm.dianpuForm.fahuodi=$$v},expression:"dianpuForm.fahuodi"}})],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"身份证正面"}},[(_vm.card1PicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.card1PicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"身份证反面"}},[(_vm.card2PicUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.card2PicUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"资质照片"}},[(_vm.dianpuForm.zizhi_pic)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.dianpuForm.zizhi_pic}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"退款地址"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.dianpuForm.tuikuan_addr),callback:function ($$v) {_vm.dianpuForm.tuikuan_addr=$$v},expression:"dianpuForm.tuikuan_addr"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.dianpuForm.remark),callback:function ($$v) {_vm.dianpuForm.remark=$$v},expression:"dianpuForm.remark"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u164":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u1S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar rightsearch",attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"搜索","size":"small"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('el-button',{attrs:{"slot":"append","icon":"search"},on:{"click":_vm.search},slot:"append"})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"ID","prop":"id","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"模版名称","prop":"name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"物流单位","prop":"wuliu_company","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否通用","prop":"an_jian","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.tongyongStatus[scope.row.is_currency]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"是否按件","prop":"an_jian","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.anjianStatus[scope.row.an_jian]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"通用价格","prop":"currency_price","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.editHandler(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"small","type":"danger"},on:{"click":function($event){_vm.deleteHandler(scope.row.id)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"模版名称","prop":"name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.name),callback:function ($$v) {_vm.addForm.name=$$v},expression:"addForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物流单位","prop":"wuliu_company"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.wuliu_company),callback:function ($$v) {_vm.addForm.wuliu_company=$$v},expression:"addForm.wuliu_company"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_currency"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.is_currency),callback:function ($$v) {_vm.is_currency=$$v},expression:"is_currency"}})],1),_vm._v(" "),(_vm.is_currency === '1')?_c('el-form-item',{attrs:{"label":"是否按件计算","prop":"an_jian"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.an_jian),callback:function ($$v) {_vm.an_jian=$$v},expression:"an_jian"}})],1):_vm._e(),_vm._v(" "),(_vm.is_currency === '1')?_c('el-form-item',{attrs:{"label":"通用价格","prop":"currency_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.currency_price),callback:function ($$v) {_vm.addForm.currency_price=$$v},expression:"addForm.currency_price"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"模版名称","prop":"name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.name),callback:function ($$v) {_vm.editForm.name=$$v},expression:"editForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物流单位","prop":"wuliu_company"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.wuliu_company),callback:function ($$v) {_vm.editForm.wuliu_company=$$v},expression:"editForm.wuliu_company"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_currency"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.is_currency),callback:function ($$v) {_vm.is_currency=$$v},expression:"is_currency"}})],1),_vm._v(" "),(_vm.is_currency === '1')?_c('el-form-item',{attrs:{"label":"是否按件计算","prop":"an_jian"}},[_c('el-switch',{attrs:{"on-color":"#13ce66","off-color":"#bfcbd9","on-value":"1","off-value":"0"},model:{value:(_vm.an_jian),callback:function ($$v) {_vm.an_jian=$$v},expression:"an_jian"}})],1):_vm._e(),_vm._v(" "),(_vm.is_currency === '1')?_c('el-form-item',{attrs:{"label":"通用价格","prop":"currency_price"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.currency_price),callback:function ($$v) {_vm.editForm.currency_price=$$v},expression:"editForm.currency_price"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u4nf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uqi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-row',[_c('el-col',{staticClass:"toolbar",attrs:{"span":24}},[_c('el-select',{attrs:{"placeholder":"请选择","size":"small"},on:{"change":_vm.search},model:{value:(_vm.tixian_status),callback:function ($$v) {_vm.tixian_status=$$v},expression:"tixian_status"}},[_c('el-option',{key:"-1",attrs:{"label":"全部","value":"-1"}}),_vm._v(" "),_vm._l((_vm.tixianStatus),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":index,"size":"small"}})})],2)],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData,"border":"","row-key":_vm.getRowKeys,"expand-row-keys":_vm.expands},on:{"expand":_vm.expand}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('input',{attrs:{"type":"hidden"},domProps:{"value":scope.row.id}}),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"账号信息","name":"1"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("账号：")]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.cardForm.card_num))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("户名：")]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.cardForm.card_name))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("银行名称：")]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.cardForm.bank))])])],1)],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"店铺信息","name":"2"}},[_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("店铺名称：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.dianpu.dianpu_name))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("公司名称：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.dianpu.com_name))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("联系方式：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.dianpu.tel))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("身份证号：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.dianpu.card_num))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("开始时间：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.dianpu.start_time))])]),_vm._v(" "),_c('el-col',{attrs:{"offset":2,"span":2}},[_vm._v("结束时间：")]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"user-font"},[_vm._v(_vm._s(_vm.dianpu.end_time))])])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"提现编号","prop":"tixian_num","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"账户余额","prop":"cur_coins","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"提现金额","prop":"tixian_coins","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"提现状态","prop":"tixian_status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(_vm.tixianStatus[scope.row.tixian_status]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"提现时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","prop":"labels","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.tixian_status == 0)?_c('el-button',{attrs:{"plain":true,"size":"small","type":"info"},on:{"click":function($event){_vm.tixian(scope.row.id)}}},[_vm._v("确认提现")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "veHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('el-col',{staticClass:"toolbar",attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.addFormVisible = true}}},[_vm._v("新增")])],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.listLoading),expression:"listLoading"}],attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"广告名称","prop":"adver_name","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"开始时间","prop":"start_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"结束时间","prop":"end_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"创建时间","prop":"create_time","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.addPic(scope.row)}}},[_vm._v("新增图片")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"info","size":"small"},on:{"click":function($event){_vm.showEditForm(scope.row)}}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"danger","size":"small"},on:{"click":function($event){_vm.deleteDate(scope.row.adver_id)}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-col',{staticClass:"toolbar_page",attrs:{"span":0}},[_c('el-pagination',{attrs:{"page-sizes":[10, 15, 20, 30],"page-size":_vm.pageSize,"layout":"sizes, prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增"},model:{value:(_vm.addFormVisible),callback:function ($$v) {_vm.addFormVisible=$$v},expression:"addFormVisible"}},[_c('el-form',{ref:"addForm",attrs:{"model":_vm.addForm,"label-width":"150px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"广告名称","prop":"adver_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.addForm.adver_name),callback:function ($$v) {_vm.addForm.adver_name=$$v},expression:"addForm.adver_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开始时间","prop":"start_time"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.addForm.start_time),callback:function ($$v) {_vm.addForm.start_time=$$v},expression:"addForm.start_time"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结束时间","prop":"end_time"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.addForm.end_time),callback:function ($$v) {_vm.addForm.end_time=$$v},expression:"addForm.end_time"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.addSubmit($event)}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑"},model:{value:(_vm.editFormVisible),callback:function ($$v) {_vm.editFormVisible=$$v},expression:"editFormVisible"}},[_c('el-form',{ref:"editForm",attrs:{"model":_vm.editForm,"label-width":"200px","rules":_vm.formRules}},[_c('el-form-item',{attrs:{"label":"广告名称","prop":"adver_name"}},[_c('el-input',{attrs:{"auto-complete":"off","size":"small","required":""},model:{value:(_vm.editForm.adver_name),callback:function ($$v) {_vm.editForm.adver_name=$$v},expression:"editForm.adver_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开始时间","prop":"start_time"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择开始时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.editForm.start_time),callback:function ($$v) {_vm.editForm.start_time=$$v},expression:"editForm.start_time"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结束时间","prop":"end_time"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择结束时间","size":"small","format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.editForm.end_time),callback:function ($$v) {_vm.editForm.end_time=$$v},expression:"editForm.end_time"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.submitLoading},nativeOn:{"click":function($event){_vm.editSubmit($event)}}},[_vm._v("提交")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vkyI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("neEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3027d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("+dD6");
function injectStyle (ssrContext) {
  __webpack_require__("Bnsx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3027d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xB8M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yje/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zDZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"loginModel",staticClass:"demo-ruleForm login-container",attrs:{"model":_vm.loginModel,"rules":_vm.rules2,"label-position":"left","label-width":"0px"}},[_c('h3',{staticClass:"title"},[_vm._v("系统登录")]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"username"}},[_c('el-input',{attrs:{"type":"text","auto-complete":"off","placeholder":"用户名"},model:{value:(_vm.loginModel.username),callback:function ($$v) {_vm.loginModel.username=$$v},expression:"loginModel.username"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","placeholder":"密码"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.loginSubmit($event)}},model:{value:(_vm.loginModel.password),callback:function ($$v) {_vm.loginModel.password=$$v},expression:"loginModel.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"verification"}},[_c('el-input',{attrs:{"type":"text","auto-complete":"off","placeholder":"验证码"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.loginSubmit($event)}},model:{value:(_vm.loginModel.verification),callback:function ($$v) {_vm.loginModel.verification=$$v},expression:"loginModel.verification"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary","loading":_vm.logining},nativeOn:{"click":function($event){$event.preventDefault();_vm.loginSubmit($event)}}},[_vm._v("登录")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zNqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__ = __webpack_require__("0iuG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_js_date_js__ = __webpack_require__("bAtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_js_util_js__ = __webpack_require__("Tiwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_js_token_js__ = __webpack_require__("eVHZ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _ref;

        return _ref = {
            tableData: [],
            total: 0,
            page: 1,
            pageSize: 15,
            listLoading: false,
            query: '',
            viewFormVisible: false,
            dianpuForm: {},
            addForm: {
                id: 0,
                admin_id: 0,
                dianpu_name: '',
                dianpu_ico: '',
                dianpu_describe: '',
                com_name: '',
                wechat_num: '',
                qq: '',
                tel: '',
                email: '',
                start_time: '',
                end_time: '',
                create_time: '',
                card_num: '',
                card_pic: '',
                zizhi_pic: '',
                tuikuan_addr: '',
                fahuodi: '',
                remark: '',
                status: 0
            },
            showUploadList: false,
            iconPicUrl: '',
            card1PicUrl: '',
            card2PicUrl: '',
            zizhiPicUrl: '',
            uploadForm: {
                token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__static_js_token_js__["a" /* getQiniuToken */])(),
                key: null
            },
            fahuodi: '',
            formRules: {},
            verifyStatus: __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].verifyStatus
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'card1PicUrl', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'card2PicUrl', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fahuodiArr', __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].shengFen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'addFormVisible', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'submitLoading', false), _ref;
    },

    methods: {
        //分页方法
        handleSizeChange: function handleSizeChange(size) {
            this.pageSize = size;
            this.search();
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.page = page;
            this.search();
        },
        search: function search() {
            this.getSearch(this.query);
        },
        getSearch: function getSearch(query) {
            var _this = this;

            this.listLoading = true;
            this.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/dianpu/page', {
                "page": this.page,
                "size": this.pageSize,
                "query": query
            }).then(function (response) {
                var data = response.data;
                if (data.state) {
                    _this.total = data.count;
                    _this.tableData = data.msg;
                    _this.listLoading = false;
                }
            }).catch(function (error) {
                console.log(error);
                _this.$message({
                    message: '获取数据异常，请联系管理员',
                    type: 'error'
                });
            });
        },
        addHandler: function addHandler() {

            this.addFormVisible = true;
        },

        //上传店铺图标
        iconBeforeUpload: function iconBeforeUpload(file) {
            var fileName = 'dianpu/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
            var mime = file.name.split('.')[1];
            fileName += '.' + mime;
            this.uploadForm.key = fileName;
        },
        iconHandleSuccess: function iconHandleSuccess(response, file, fileList) {
            this.iconPicUrl = __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
            this.result = '上传成功';
        },
        iconHandleError: function iconHandleError(error, response, file) {
            this.result = error.toString();
        },


        //上传身份证
        card1BeforeUpload: function card1BeforeUpload(file) {
            var fileName = 'dianpu/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
            var mime = file.name.split('.')[1];
            fileName += '.' + mime;
            this.uploadForm.key = fileName;
        },
        card1HandleSuccess: function card1HandleSuccess(response, file, fileList) {
            this.card1PicUrl = __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
            this.result = '上传成功';
        },
        card1HandleError: function card1HandleError(error, response, file) {
            this.result = error.toString();
        },


        //上传身份证
        card2BeforeUpload: function card2BeforeUpload(file) {
            var fileName = 'dianpu/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
            var mime = file.name.split('.')[1];
            fileName += '.' + mime;
            this.uploadForm.key = fileName;
        },
        card2HandleSuccess: function card2HandleSuccess(response, file, fileList) {
            this.card2PicUrl = __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
            this.result = '上传成功';
        },
        card2HandleError: function card2HandleError(error, response, file) {
            this.result = error.toString();
        },


        //上传商品主图片
        zizhiBeforeUpload: function zizhiBeforeUpload(file) {
            var fileName = 'dianpu/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
            var mime = file.name.split('.')[1];
            fileName += '.' + mime;
            this.uploadForm.key = fileName;
        },
        zizhiHandleSuccess: function zizhiHandleSuccess(response, file, fileList) {
            this.zizhiPicUrl = __WEBPACK_IMPORTED_MODULE_3__static_config_basicdata_js__["a" /* default */].picUrl + this.uploadForm.key;
            this.result = '上传成功';
        },
        zizhiHandleError: function zizhiHandleError(error, response, file) {
            this.result = error.toString();
        },


        // 提交
        submit: function submit() {
            var _this2 = this;

            this.$refs.addForm.validate(function (valid) {
                if (valid) {
                    _this2.$confirm('确认提交吗？', '提示', {}).then(function () {
                        var para = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__static_js_util_js__["a" /* formatPara */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm));
                        if (para.id == 0) para.create_time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__static_js_date_js__["a" /* formatDate */])(new Date(), "yyyy-MM-dd hh:mm:ss");
                        para.dianpu_ico = _this2.iconPicUrl;
                        para.card_pic = _this2.card1PicUrl + ',' + _this2.card2PicUrl;
                        para.zizhi_pic = _this2.zizhiPicUrl;
                        //异步请求
                        _this2.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/dianpu', para).then(function (response) {
                            if (response.data.state) {
                                _this2.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                _this2.$refs['addForm'].resetFields();
                                _this2.dianpu_ico = [];
                                _this2.card_pic = [];
                                _this2.zizhi_pic = [];
                                _this2.addFormVisible = false;
                                _this2.search();
                            } else {
                                _this2.$message({
                                    message: '提交失败，请联系管理员',
                                    type: 'warning'
                                });
                            }
                        }).catch(function (error) {
                            console.log(error);
                            _this2.$message({
                                message: '提交异常，请联系管理员',
                                type: 'error'
                            });
                        });
                    });
                }
            });
        },
        viewHandler: function viewHandler(row) {
            this.dianpuForm = row;
            var card_pic = this.dianpuForm.card_pic;
            if (card_pic && card_pic.split(',').length > 0) {
                this.card1PicUrl = card_pic.split(',')[0];
                this.card2PicUrl = card_pic.split(',')[1];
            }
            this.viewFormVisible = true;
        },
        verify: function verify(row) {
            var _this3 = this;

            this.$confirm('确认审核吗？', '提示', {}).then(function () {
                _this3.submitLoading = true;
                var verify = 0;
                if (row.is_verify == 0) {
                    verify = 1;
                }
                //异步请求
                _this3.$axios.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url + '/dianpu/verify/' + row.id + '/' + verify).then(function (response) {
                    if (response.data.state) {
                        _this3.$message({
                            message: '成功',
                            type: 'success'
                        });
                        _this3.search();
                    } else {
                        _this3.$message({
                            message: '提交失败，请联系管理员',
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                    _this3.$message({
                        message: '提交异常，请联系管理员',
                        type: 'error'
                    });
                });
                _this3.submitLoading = false;
            });
        }
    },

    created: function created() {
        this.search();
    }
});

/***/ }),

/***/ "zVnG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopcar_vue__ = __webpack_require__("cMpV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18da327e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shopcar_vue__ = __webpack_require__("GCxY");
function injectStyle (ssrContext) {
  __webpack_require__("INGJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18da327e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopcar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18da327e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_shopcar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zZcF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zdzv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ze7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__ = __webpack_require__("0iuG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 30,
      listLoading: false,
      expands: [],
      getRowKeys: function getRowKeys(row) {
        return row._id;
      },

      editForm: {},
      query: '',
      recommend: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].recommend,
      verify: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].verify,
      status: __WEBPACK_IMPORTED_MODULE_2__static_config_basicdata_js__["a" /* default */].status,
      picVisible: false,
      editFormVisible: false,
      picList: []
    };
  },

  methods: {
    //分页方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.search();
    },
    search: function search() {
      this.getSearch(this.query);
    },
    getSearch: function getSearch(query) {
      var _this = this;

      this.listLoading = true;
      var url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/copywrite/page';
      this.$axios.post(url, {
        "page": this.page,
        "size": this.pageSize,
        "query": query
      }).then(function (response) {
        var data = response.data;
        if (data.state) {
          _this.total = data.count;
          _this.tableData = data.msg;
          _this.listLoading = false;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$message({
          message: '获取数据异常，请联系管理员',
          type: 'warning'
        });
      });
    },

    //操作删除
    deleteData: function deleteData(id) {
      var _this2 = this;

      if (id != 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/copywrite/delete/' + id).then(function (response) {
            if (response.data.state) {
              _this2.$message({
                message: '删除成功',
                type: 'success'
              });
              _this2.search();
            } else {
              _this2.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(function (error) {
            console.log(error);
            _this2.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(function () {
          _this2.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },

    //操作恢复
    recoveryData: function recoveryData(id) {
      var _this3 = this;

      if (id != 0) {
        this.$confirm('是否恢复?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this3.$axios.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/copywrite/recovery/' + id).then(function (response) {
            if (response.data.state) {
              _this3.$message({
                message: '成功',
                type: 'success'
              });
              _this3.search();
            } else {
              _this3.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(function (error) {
            console.log(error);
            _this3.$message({
              message: '异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(function () {
          _this3.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },

    //审核
    setVerify: function setVerify(id) {
      var _this4 = this;

      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/copywrite/verify', {
        id: id,
        status: 0
      }).then(function (response) {
        if (response.data.state) {
          _this4.$message({
            message: '审核成功!',
            type: 'success'
          });
          _this4.search();
        } else {
          _this4.$message({
            message: '推荐失败，请联系管理员',
            type: 'warning'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this4.$message({
          message: '审核异常，请联系管理员',
          type: 'error'
        });
      });
    },

    //推荐
    setRecommend: function setRecommend(id, isrecommend) {
      var _this5 = this;

      this.$axios.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/copywrite/recommend', {
        id: id,
        status: isrecommend
      }).then(function (response) {
        if (response.data.state) {
          _this5.$message({
            message: '推荐成功!',
            type: 'success'
          });
          _this5.search();
        } else {
          _this5.$message({
            message: '推荐失败，请联系管理员',
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          message: '推荐异常，请联系管理员',
          type: 'error'
        });
      });
    },
    editSubmit: function editSubmit() {
      var _this6 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this6.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this6.submitLoading = true;
            var para = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this6.editForm);
            //异步请求
            _this6.$axios.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api_url + '/copywrite/schemeurl', {
              id: para._id,
              schemeurl: para.schemeurl
            }).then(function (response) {
              if (response.data.state) {
                _this6.$message({
                  message: '提交成功',
                  type: 'success'
                });
                _this6.$refs['editForm'].resetFields();
                _this6.editFormVisible = false;
                _this6.search();
              } else {
                _this6.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              console.log(error);
              _this6.$message({
                message: '提交异常，请联系管理员',
                type: 'error'
              });
            });
            _this6.submitLoading = false;
          });
        }
      });
    },
    showEditForm: function showEditForm(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },

    //查看图片
    getPicUrl: function getPicUrl(row) {
      this.picVisible = true;
      this.picList = row.pic.split(',');
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),

/***/ "zxel":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a876cfdb2d6f2eb62fac.js